/* eslint-disable */
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDateTime: { input: any; output: any; }
  AWSJSON: { input: any; output: any; }
};

export type CardDriverRankingDriverInfo = {
  __typename?: 'CardDriverRankingDriverInfo';
  customDriverName?: Maybe<Scalars['String']['output']>;
  customDriverPageUrl?: Maybe<Scalars['String']['output']>;
  customDriverSurname?: Maybe<Scalars['String']['output']>;
  flagUrl?: Maybe<Scalars['String']['output']>;
  pos?: Maybe<Scalars['String']['output']>;
  pts?: Maybe<Scalars['String']['output']>;
};

export type CardDriverRankingDriverInfoInput = {
  customDriverName?: InputMaybe<Scalars['String']['input']>;
  customDriverPageUrl?: InputMaybe<Scalars['String']['input']>;
  customDriverSurname?: InputMaybe<Scalars['String']['input']>;
  flagUrl?: InputMaybe<Scalars['String']['input']>;
  pos?: InputMaybe<Scalars['String']['input']>;
  pts?: InputMaybe<Scalars['String']['input']>;
};

export type CardDriverRankingWidget = {
  __typename?: 'CardDriverRankingWidget';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  customCompetitionName?: Maybe<Scalars['String']['output']>;
  drivers?: Maybe<Array<Maybe<CardDriverRankingDriverInfo>>>;
  rankingLink?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type CardGpCalendarGpInfo = {
  __typename?: 'CardGpCalendarGpInfo';
  customGpName?: Maybe<Scalars['String']['output']>;
  endDateTime?: Maybe<Scalars['String']['output']>;
  flagUrl?: Maybe<Scalars['String']['output']>;
  isExclusive?: Maybe<Scalars['Boolean']['output']>;
  lgpPreviewUrl?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['String']['output']>;
};

export type CardGpCalendarGpInfoInput = {
  customGpName?: InputMaybe<Scalars['String']['input']>;
  endDateTime?: InputMaybe<Scalars['String']['input']>;
  flagUrl?: InputMaybe<Scalars['String']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  lgpPreviewUrl?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

export type CardGpCalendarWidget = {
  __typename?: 'CardGpCalendarWidget';
  calendarLink?: Maybe<Scalars['String']['output']>;
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  customCompetitionName?: Maybe<Scalars['String']['output']>;
  gpList?: Maybe<Array<Maybe<CardGpCalendarGpInfo>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type CardGpResultsResultInfo = {
  __typename?: 'CardGpResultsResultInfo';
  customDriverName?: Maybe<Scalars['String']['output']>;
  customDriverPageUrl?: Maybe<Scalars['String']['output']>;
  customDriverSurname?: Maybe<Scalars['String']['output']>;
  flagUrl?: Maybe<Scalars['String']['output']>;
  gap?: Maybe<Scalars['String']['output']>;
  pos?: Maybe<Scalars['String']['output']>;
  timing?: Maybe<CardGpResultsResultInfoTiming>;
};

export type CardGpResultsResultInfoInput = {
  customDriverName?: InputMaybe<Scalars['String']['input']>;
  customDriverPageUrl?: InputMaybe<Scalars['String']['input']>;
  customDriverSurname?: InputMaybe<Scalars['String']['input']>;
  flagUrl?: InputMaybe<Scalars['String']['input']>;
  gap?: InputMaybe<Scalars['String']['input']>;
  pos?: InputMaybe<Scalars['String']['input']>;
  timing?: InputMaybe<CardGpResultsResultInfoTimingInput>;
};

export type CardGpResultsResultInfoTiming = {
  __typename?: 'CardGpResultsResultInfoTiming';
  timeHours?: Maybe<Scalars['String']['output']>;
  timeMilliseconds?: Maybe<Scalars['String']['output']>;
  timeMinutes?: Maybe<Scalars['String']['output']>;
  timeSeconds?: Maybe<Scalars['String']['output']>;
};

export type CardGpResultsResultInfoTimingInput = {
  timeHours?: InputMaybe<Scalars['String']['input']>;
  timeMilliseconds?: InputMaybe<Scalars['String']['input']>;
  timeMinutes?: InputMaybe<Scalars['String']['input']>;
  timeSeconds?: InputMaybe<Scalars['String']['input']>;
};

export type CardGpResultsWidget = {
  __typename?: 'CardGpResultsWidget';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  customCompetitionName?: Maybe<Scalars['String']['output']>;
  customGpName?: Maybe<Scalars['String']['output']>;
  isSprint?: Maybe<Scalars['Boolean']['output']>;
  results?: Maybe<Array<Maybe<CardGpResultsResultInfo>>>;
  resultsLink?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type CardTeamRankingTeamInfo = {
  __typename?: 'CardTeamRankingTeamInfo';
  customTeamName?: Maybe<Scalars['String']['output']>;
  customTeamPageUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  pos?: Maybe<Scalars['String']['output']>;
  pts?: Maybe<Scalars['String']['output']>;
};

export type CardTeamRankingTeamInfoInput = {
  customTeamName?: InputMaybe<Scalars['String']['input']>;
  customTeamPageUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  pos?: InputMaybe<Scalars['String']['input']>;
  pts?: InputMaybe<Scalars['String']['input']>;
};

export type CardTeamRankingWidget = {
  __typename?: 'CardTeamRankingWidget';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  customCompetitionName?: Maybe<Scalars['String']['output']>;
  rankingLink?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<Maybe<CardTeamRankingTeamInfo>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type Competition = {
  __typename?: 'Competition';
  competitionId: Scalars['ID']['output'];
  competitionJson: Scalars['AWSJSON']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  drivers?: Maybe<ModelDriverConnection>;
  editorialData?: Maybe<EditorialData>;
  editorialDataId: Scalars['ID']['output'];
  grandPrixes?: Maybe<ModelGrandPrixConnection>;
  previousCompetition?: Maybe<Competition>;
  previousSeasonAndCompId?: Maybe<Scalars['ID']['output']>;
  season?: Maybe<Season>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  teams?: Maybe<ModelTeamConnection>;
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type CompetitiondriversArgs = {
  driverId?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelDriverFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CompetitiongrandPrixesArgs = {
  filter?: InputMaybe<ModelGrandPrixFilterInput>;
  gpId?: InputMaybe<ModelIDKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CompetitionteamsArgs = {
  filter?: InputMaybe<ModelTeamFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  teamId?: InputMaybe<ModelIDKeyConditionInput>;
};

export type CreateCardDriverRankingWidgetInput = {
  competitionId: Scalars['ID']['input'];
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  drivers?: InputMaybe<Array<InputMaybe<CardDriverRankingDriverInfoInput>>>;
  rankingLink?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCardGpCalendarWidgetInput = {
  calendarLink?: InputMaybe<Scalars['String']['input']>;
  competitionId: Scalars['ID']['input'];
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  gpList?: InputMaybe<Array<InputMaybe<CardGpCalendarGpInfoInput>>>;
};

export type CreateCardGpResultsWidgetInput = {
  competitionId: Scalars['ID']['input'];
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  customGpName?: InputMaybe<Scalars['String']['input']>;
  isSprint?: InputMaybe<Scalars['Boolean']['input']>;
  results?: InputMaybe<Array<InputMaybe<CardGpResultsResultInfoInput>>>;
  resultsLink?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCardTeamRankingWidgetInput = {
  competitionId: Scalars['ID']['input'];
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  rankingLink?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<InputMaybe<CardTeamRankingTeamInfoInput>>>;
};

export type CreateCompetitionInput = {
  competitionId: Scalars['ID']['input'];
  competitionJson: Scalars['AWSJSON']['input'];
  editorialDataId: Scalars['ID']['input'];
  previousSeasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type CreateCrossLinkInput = {
  crossLinkJson: Scalars['AWSJSON']['input'];
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type CreateDriverInput = {
  driverId: Scalars['ID']['input'];
  driverJson: Scalars['AWSJSON']['input'];
  editorialDataId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type CreateDriverRankingWidgetInput = {
  competitionId: Scalars['ID']['input'];
  competitionLabel?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<DriverRankingDriverInput>>>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type CreateDriverStatsWidgetInput = {
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  customSeasonName?: InputMaybe<Scalars['String']['input']>;
  driverId: Scalars['ID']['input'];
  seasonAndCompId?: InputMaybe<Scalars['String']['input']>;
  statistics?: InputMaybe<Array<InputMaybe<DriverStatInput>>>;
};

export type CreateEditorialDataInput = {
  editorialDataId: Scalars['ID']['input'];
  editorialJson: Scalars['AWSJSON']['input'];
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
};

export type CreateGpCalendarWidgetInput = {
  competitionId: Scalars['ID']['input'];
  items?: InputMaybe<Array<InputMaybe<GpCalendarItemInput>>>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type CreateGpCurrentCalendarWidgetInput = {
  competitionId: Scalars['ID']['input'];
  items?: InputMaybe<Array<InputMaybe<GpCalendarItemInput>>>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type CreateGpDataInput = {
  competitionId: Scalars['ID']['input'];
  data: Scalars['AWSJSON']['input'];
  gpId: Scalars['ID']['input'];
  messageType: Scalars['String']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type CreateGpLiveContainerWidgetInput = {
  DS?: InputMaybe<GpLiveContainerWrapperInput>;
  G?: InputMaybe<GpLiveContainerWrapperInput>;
  R?: InputMaybe<GpLiveContainerWrapperInput>;
  TS?: InputMaybe<GpLiveContainerWrapperInput>;
  competitionId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type CreateGpLiveHeroWidgetInput = {
  competitionId: Scalars['ID']['input'];
  gpInfo?: InputMaybe<GpLiveHeroGpInfoInput>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type CreateGpPodiumListWidgetInput = {
  competitionId: Scalars['ID']['input'];
  grandPrixList?: InputMaybe<Array<InputMaybe<GpPodiumListGrandPrixInput>>>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type CreateGpResultsContainerWidgetInput = {
  FP1?: InputMaybe<GpResultsContainerWrapperInput>;
  FP2?: InputMaybe<GpResultsContainerWrapperInput>;
  FP3?: InputMaybe<GpResultsContainerWrapperInput>;
  FP4?: InputMaybe<GpResultsContainerWrapperInput>;
  G?: InputMaybe<GpResultsContainerWrapperInput>;
  GS?: InputMaybe<GpResultsContainerWrapperInput>;
  Q?: InputMaybe<GpResultsContainerWrapperInput>;
  QS?: InputMaybe<GpResultsContainerWrapperInput>;
  R?: InputMaybe<GpResultsContainerWrapperInput>;
  SPRINT?: InputMaybe<GpResultsContainerWrapperInput>;
  SS?: InputMaybe<GpResultsContainerWrapperInput>;
  competitionId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type CreateGpResultsWidgetInput = {
  competitionId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
  gpInfo?: InputMaybe<GpResultsGpInfoInput>;
  gpStatus?: InputMaybe<Scalars['String']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  sessionName: Scalars['String']['input'];
  sessions?: InputMaybe<Array<InputMaybe<GpResultsSessionInput>>>;
};

export type CreateGrandPrixInput = {
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  editorialDataId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
  gpJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLgpHeroStickyWidgetInput = {
  competitionId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
  info?: InputMaybe<LgpHeroStickyInfoInput>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  session?: InputMaybe<LgpHeroStickySessionInput>;
};

export type CreateLgpHeroWidgetInput = {
  competitionId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
  info?: InputMaybe<LgpHeroInfoInput>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  session?: InputMaybe<LgpHeroSessionInput>;
};

export type CreateLgpPreviewWidgetInput = {
  calendar?: InputMaybe<LgpInfoLinkInput>;
  competitionId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
  gpName?: InputMaybe<Scalars['String']['input']>;
  gpStartDateTime?: InputMaybe<Scalars['String']['input']>;
  laps?: InputMaybe<Scalars['String']['input']>;
  lengthKm?: InputMaybe<Scalars['String']['input']>;
  news?: InputMaybe<LgpInfoLinkInput>;
  ranking?: InputMaybe<LgpInfoLinkInput>;
  results?: InputMaybe<LgpInfoLinkInput>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  sessions?: InputMaybe<Array<InputMaybe<LgpPreviewSessionInput>>>;
  sportLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLgpResultsContainerWidgetInput = {
  FP1?: InputMaybe<LgpResultsContainerWrapperInput>;
  FP2?: InputMaybe<LgpResultsContainerWrapperInput>;
  FP3?: InputMaybe<LgpResultsContainerWrapperInput>;
  FP4?: InputMaybe<LgpResultsContainerWrapperInput>;
  G?: InputMaybe<LgpResultsContainerWrapperInput>;
  GS?: InputMaybe<LgpResultsContainerWrapperInput>;
  Q?: InputMaybe<LgpResultsContainerWrapperInput>;
  QS?: InputMaybe<LgpResultsContainerWrapperInput>;
  R?: InputMaybe<LgpResultsContainerWrapperInput>;
  SPRINT?: InputMaybe<LgpResultsContainerWrapperInput>;
  SS?: InputMaybe<LgpResultsContainerWrapperInput>;
  competitionId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type CreateLgpResultsWidgetInput = {
  calendar?: InputMaybe<LgpInfoLinkInput>;
  competitionId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
  gpInfo?: InputMaybe<LgpResultsGpInfoInput>;
  gpStatus?: InputMaybe<Scalars['String']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  ranking?: InputMaybe<LgpInfoLinkInput>;
  results?: InputMaybe<LgpInfoLinkInput>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  sessionName: Scalars['String']['input'];
  sessions?: InputMaybe<Array<InputMaybe<LgpResultsSessionInput>>>;
};

export type CreateLiveScoreWidgetInput = {
  currentDay?: InputMaybe<Array<InputMaybe<LiveScoreWidgetDayInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  nextDay?: InputMaybe<Array<InputMaybe<LiveScoreWidgetDayInput>>>;
  previousDay?: InputMaybe<Array<InputMaybe<LiveScoreWidgetDayInput>>>;
};

export type CreateSeasonInput = {
  seasonId: Scalars['ID']['input'];
  seasonJson: Scalars['AWSJSON']['input'];
};

export type CreateSeasonRankingGalleryWidgetInput = {
  competitionId: Scalars['ID']['input'];
  competitionName?: InputMaybe<Scalars['String']['input']>;
  competitionsSlugName?: InputMaybe<Scalars['String']['input']>;
  drivers?: InputMaybe<Array<InputMaybe<SeasonDriverRankingInput>>>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  teams?: InputMaybe<Array<InputMaybe<SeasonTeamRankingInput>>>;
};

export type CreateSessionInput = {
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  gpId: Scalars['ID']['input'];
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  sessionJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTeamDriverPageWidgetInput = {
  competitionId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  teamList?: InputMaybe<Array<InputMaybe<TeamDriverTeamInput>>>;
};

export type CreateTeamInput = {
  editorialDataId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  teamJson: Scalars['AWSJSON']['input'];
};

export type CreateTeamRankingWidgetInput = {
  competitionId: Scalars['ID']['input'];
  competitionLabel?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<TeamRankingTeamInput>>>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type CrossLink = {
  __typename?: 'CrossLink';
  createdAt: Scalars['AWSDateTime']['output'];
  crossLinkJson: Scalars['AWSJSON']['output'];
  gpId: Scalars['ID']['output'];
  seasonAndCompId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type DeleteCardDriverRankingWidgetInput = {
  competitionId: Scalars['ID']['input'];
};

export type DeleteCardGpCalendarWidgetInput = {
  competitionId: Scalars['ID']['input'];
};

export type DeleteCardGpResultsWidgetInput = {
  competitionId: Scalars['ID']['input'];
};

export type DeleteCardTeamRankingWidgetInput = {
  competitionId: Scalars['ID']['input'];
};

export type DeleteCompetitionInput = {
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteCrossLinkInput = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteDriverInput = {
  driverId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteDriverRankingWidgetInput = {
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteDriverStatsWidgetInput = {
  driverId: Scalars['ID']['input'];
};

export type DeleteEditorialDataInput = {
  editorialDataId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteGpCalendarWidgetInput = {
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteGpCurrentCalendarWidgetInput = {
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteGpDataInput = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteGpLiveContainerWidgetInput = {
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteGpLiveHeroWidgetInput = {
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteGpPodiumListWidgetInput = {
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteGpResultsContainerWidgetInput = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteGpResultsWidgetInput = {
  gpId: Scalars['ID']['input'];
  sessionName: Scalars['String']['input'];
};

export type DeleteGrandPrixInput = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteLgpHeroStickyWidgetInput = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteLgpHeroWidgetInput = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteLgpPreviewWidgetInput = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteLgpResultsContainerWidgetInput = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteLgpResultsWidgetInput = {
  gpId: Scalars['ID']['input'];
  sessionName: Scalars['String']['input'];
};

export type DeleteLiveScoreWidgetInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSeasonInput = {
  seasonId: Scalars['ID']['input'];
};

export type DeleteSeasonRankingGalleryWidgetInput = {
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteSessionInput = {
  gpId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type DeleteTeamDriverPageWidgetInput = {
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteTeamInput = {
  seasonAndCompId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type DeleteTeamRankingWidgetInput = {
  seasonAndCompId: Scalars['ID']['input'];
};

export type Driver = {
  __typename?: 'Driver';
  competition?: Maybe<Competition>;
  createdAt: Scalars['AWSDateTime']['output'];
  driverId: Scalars['ID']['output'];
  driverJson: Scalars['AWSJSON']['output'];
  editorialData?: Maybe<EditorialData>;
  editorialDataId: Scalars['ID']['output'];
  seasonAndCompId: Scalars['ID']['output'];
  team?: Maybe<Team>;
  teamId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type DriverRankingDriver = {
  __typename?: 'DriverRankingDriver';
  driverInfo?: Maybe<DriverRankingDriverInfo>;
};

export type DriverRankingDriverInfo = {
  __typename?: 'DriverRankingDriverInfo';
  customDriverName?: Maybe<Scalars['String']['output']>;
  customDriverPageUrl?: Maybe<Scalars['String']['output']>;
  customDriverSurname?: Maybe<Scalars['String']['output']>;
  customTeamName?: Maybe<Scalars['String']['output']>;
  customTeamPageUrl?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  flagUrl?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  pos?: Maybe<Scalars['String']['output']>;
  pts?: Maybe<Scalars['String']['output']>;
};

export type DriverRankingDriverInfoInput = {
  customDriverName?: InputMaybe<Scalars['String']['input']>;
  customDriverPageUrl?: InputMaybe<Scalars['String']['input']>;
  customDriverSurname?: InputMaybe<Scalars['String']['input']>;
  customTeamName?: InputMaybe<Scalars['String']['input']>;
  customTeamPageUrl?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  flagUrl?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  pos?: InputMaybe<Scalars['String']['input']>;
  pts?: InputMaybe<Scalars['String']['input']>;
};

export type DriverRankingDriverInput = {
  driverInfo?: InputMaybe<DriverRankingDriverInfoInput>;
};

export type DriverRankingWidget = {
  __typename?: 'DriverRankingWidget';
  competitionId: Scalars['ID']['output'];
  competitionLabel?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  items?: Maybe<Array<Maybe<DriverRankingDriver>>>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type DriverStat = {
  __typename?: 'DriverStat';
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type DriverStatInput = {
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type DriverStatsWidget = {
  __typename?: 'DriverStatsWidget';
  createdAt: Scalars['AWSDateTime']['output'];
  customCompetitionName?: Maybe<Scalars['String']['output']>;
  customSeasonName?: Maybe<Scalars['String']['output']>;
  driverId: Scalars['ID']['output'];
  seasonAndCompId?: Maybe<Scalars['String']['output']>;
  statistics?: Maybe<Array<Maybe<DriverStat>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type EditorialData = {
  __typename?: 'EditorialData';
  competition?: Maybe<Competition>;
  createdAt: Scalars['AWSDateTime']['output'];
  editorialDataId: Scalars['ID']['output'];
  editorialJson: Scalars['AWSJSON']['output'];
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  seasonAndCompId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type GpCalendarGpInfo = {
  __typename?: 'GpCalendarGpInfo';
  circuitUrl?: Maybe<Scalars['String']['output']>;
  customGpName?: Maybe<Scalars['String']['output']>;
  flagUrl?: Maybe<Scalars['String']['output']>;
  gpCrosslink?: Maybe<Scalars['String']['output']>;
  gpPageUrl?: Maybe<Scalars['String']['output']>;
  gpStatus?: Maybe<Scalars['String']['output']>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  isExclusive?: Maybe<Scalars['Boolean']['output']>;
  isSprint?: Maybe<Scalars['Boolean']['output']>;
  lapRecord?: Maybe<Scalars['String']['output']>;
  laps?: Maybe<Scalars['String']['output']>;
  lengthKm?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['String']['output']>;
};

export type GpCalendarGpInfoInput = {
  circuitUrl?: InputMaybe<Scalars['String']['input']>;
  customGpName?: InputMaybe<Scalars['String']['input']>;
  flagUrl?: InputMaybe<Scalars['String']['input']>;
  gpCrosslink?: InputMaybe<Scalars['String']['input']>;
  gpPageUrl?: InputMaybe<Scalars['String']['input']>;
  gpStatus?: InputMaybe<Scalars['String']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isSprint?: InputMaybe<Scalars['Boolean']['input']>;
  lapRecord?: InputMaybe<Scalars['String']['input']>;
  laps?: InputMaybe<Scalars['String']['input']>;
  lengthKm?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

export type GpCalendarItem = {
  __typename?: 'GpCalendarItem';
  gpInfo?: Maybe<GpCalendarGpInfo>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  sessions?: Maybe<GpCalendarItemSessions>;
};

export type GpCalendarItemInput = {
  gpInfo?: InputMaybe<GpCalendarGpInfoInput>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  sessions?: InputMaybe<GpCalendarItemSessionsInput>;
};

export type GpCalendarItemSessions = {
  __typename?: 'GpCalendarItemSessions';
  items?: Maybe<Array<Maybe<GpCalendarSession>>>;
};

export type GpCalendarItemSessionsInput = {
  items?: InputMaybe<Array<InputMaybe<GpCalendarSessionInput>>>;
};

export type GpCalendarSession = {
  __typename?: 'GpCalendarSession';
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  sessionInfo?: Maybe<GpCalendarSessionInfo>;
  sessionLabel?: Maybe<Scalars['String']['output']>;
  sessionResultUrl?: Maybe<Scalars['String']['output']>;
  sessionStatus?: Maybe<Scalars['String']['output']>;
};

export type GpCalendarSessionInfo = {
  __typename?: 'GpCalendarSessionInfo';
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  sessionLabel?: Maybe<Scalars['String']['output']>;
  sessionName?: Maybe<Scalars['String']['output']>;
  sessionStatus?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['String']['output']>;
};

export type GpCalendarSessionInfoInput = {
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  sessionLabel?: InputMaybe<Scalars['String']['input']>;
  sessionName?: InputMaybe<Scalars['String']['input']>;
  sessionStatus?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

export type GpCalendarSessionInput = {
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  sessionInfo?: InputMaybe<GpCalendarSessionInfoInput>;
  sessionLabel?: InputMaybe<Scalars['String']['input']>;
  sessionResultUrl?: InputMaybe<Scalars['String']['input']>;
  sessionStatus?: InputMaybe<Scalars['String']['input']>;
};

export type GpCalendarWidget = {
  __typename?: 'GpCalendarWidget';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  items?: Maybe<Array<Maybe<GpCalendarItem>>>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type GpCurrentCalendarWidget = {
  __typename?: 'GpCurrentCalendarWidget';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  items?: Maybe<Array<Maybe<GpCalendarItem>>>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type GpData = {
  __typename?: 'GpData';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  data: Scalars['AWSJSON']['output'];
  gpId: Scalars['ID']['output'];
  messageType: Scalars['String']['output'];
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type GpLiveContainerWidget = {
  __typename?: 'GpLiveContainerWidget';
  DS?: Maybe<GpLiveContainerWrapper>;
  G?: Maybe<GpLiveContainerWrapper>;
  R?: Maybe<GpLiveContainerWrapper>;
  TS?: Maybe<GpLiveContainerWrapper>;
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type GpLiveContainerWrapper = {
  __typename?: 'GpLiveContainerWrapper';
  customDataAttributes?: Maybe<GpLiveContainerWrapperAttributes>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  ssi?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GpLiveContainerWrapperAttributes = {
  __typename?: 'GpLiveContainerWrapperAttributes';
  tracking?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GpLiveContainerWrapperAttributesInput = {
  tracking?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type GpLiveContainerWrapperInput = {
  customDataAttributes?: InputMaybe<GpLiveContainerWrapperAttributesInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  ssi?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GpLiveHeroGpInfo = {
  __typename?: 'GpLiveHeroGpInfo';
  circuitUrl?: Maybe<Scalars['String']['output']>;
  customGpName?: Maybe<Scalars['String']['output']>;
  flagUrl?: Maybe<Scalars['String']['output']>;
  gpPageUrl?: Maybe<Scalars['String']['output']>;
  gpStatus?: Maybe<Scalars['String']['output']>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  isExclusive?: Maybe<Scalars['Boolean']['output']>;
  isSprint?: Maybe<Scalars['Boolean']['output']>;
  lapRecord?: Maybe<Scalars['String']['output']>;
  laps?: Maybe<Scalars['String']['output']>;
  lengthKm?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['String']['output']>;
};

export type GpLiveHeroGpInfoInput = {
  circuitUrl?: InputMaybe<Scalars['String']['input']>;
  customGpName?: InputMaybe<Scalars['String']['input']>;
  flagUrl?: InputMaybe<Scalars['String']['input']>;
  gpPageUrl?: InputMaybe<Scalars['String']['input']>;
  gpStatus?: InputMaybe<Scalars['String']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isSprint?: InputMaybe<Scalars['Boolean']['input']>;
  lapRecord?: InputMaybe<Scalars['String']['input']>;
  laps?: InputMaybe<Scalars['String']['input']>;
  lengthKm?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

export type GpLiveHeroWidget = {
  __typename?: 'GpLiveHeroWidget';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  gpInfo?: Maybe<GpLiveHeroGpInfo>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type GpPodiumListGpInfo = {
  __typename?: 'GpPodiumListGpInfo';
  customGpName?: Maybe<Scalars['String']['output']>;
  gpCrosslink?: Maybe<Scalars['String']['output']>;
  gpPageUrl?: Maybe<Scalars['String']['output']>;
  gpStatus?: Maybe<Scalars['String']['output']>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  isExclusive?: Maybe<Scalars['Boolean']['output']>;
  isSprint?: Maybe<Scalars['Boolean']['output']>;
  lapRecord?: Maybe<Scalars['String']['output']>;
  laps?: Maybe<Scalars['String']['output']>;
  lengthKm?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['String']['output']>;
};

export type GpPodiumListGpInfoInput = {
  customGpName?: InputMaybe<Scalars['String']['input']>;
  gpCrosslink?: InputMaybe<Scalars['String']['input']>;
  gpPageUrl?: InputMaybe<Scalars['String']['input']>;
  gpStatus?: InputMaybe<Scalars['String']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isSprint?: InputMaybe<Scalars['Boolean']['input']>;
  lapRecord?: InputMaybe<Scalars['String']['input']>;
  laps?: InputMaybe<Scalars['String']['input']>;
  lengthKm?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

export type GpPodiumListGrandPrix = {
  __typename?: 'GpPodiumListGrandPrix';
  gpInfo?: Maybe<GpPodiumListGpInfo>;
  gpStatus?: Maybe<Scalars['String']['output']>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  session?: Maybe<GpPodiumListSession>;
};

export type GpPodiumListGrandPrixInput = {
  gpInfo?: InputMaybe<GpPodiumListGpInfoInput>;
  gpStatus?: InputMaybe<Scalars['String']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  session?: InputMaybe<GpPodiumListSessionInput>;
};

export type GpPodiumListSession = {
  __typename?: 'GpPodiumListSession';
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  sessionInfo?: Maybe<GpPodiumListSessionInfo>;
  sessionLabel?: Maybe<Scalars['String']['output']>;
  sessionStatus?: Maybe<Scalars['String']['output']>;
};

export type GpPodiumListSessionInfo = {
  __typename?: 'GpPodiumListSessionInfo';
  details?: Maybe<Array<Maybe<GpPodiumListSessionInfoDetails>>>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  sessionLabel?: Maybe<Scalars['String']['output']>;
  sessionName?: Maybe<Scalars['String']['output']>;
  sessionStatus?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['String']['output']>;
};

export type GpPodiumListSessionInfoDetails = {
  __typename?: 'GpPodiumListSessionInfoDetails';
  customDriverName?: Maybe<Scalars['String']['output']>;
  customDriverPageUrl?: Maybe<Scalars['String']['output']>;
  customDriverSurname?: Maybe<Scalars['String']['output']>;
  customTeamName?: Maybe<Scalars['String']['output']>;
  customTeamPageUrl?: Maybe<Scalars['String']['output']>;
  fastestLap?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  flagUrl?: Maybe<Scalars['String']['output']>;
  gap?: Maybe<Scalars['String']['output']>;
  isFastestLap?: Maybe<Scalars['Boolean']['output']>;
  laps?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  points?: Maybe<GpPodiumListSessionInfoDetailsPoints>;
  position?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team?: Maybe<GpPodiumListSessionInfoDetailsTeam>;
  timing?: Maybe<GpPodiumListSessionInfoDetailsTiming>;
};

export type GpPodiumListSessionInfoDetailsInput = {
  customDriverName?: InputMaybe<Scalars['String']['input']>;
  customDriverPageUrl?: InputMaybe<Scalars['String']['input']>;
  customDriverSurname?: InputMaybe<Scalars['String']['input']>;
  customTeamName?: InputMaybe<Scalars['String']['input']>;
  customTeamPageUrl?: InputMaybe<Scalars['String']['input']>;
  fastestLap?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  flagUrl?: InputMaybe<Scalars['String']['input']>;
  gap?: InputMaybe<Scalars['String']['input']>;
  isFastestLap?: InputMaybe<Scalars['Boolean']['input']>;
  laps?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<GpPodiumListSessionInfoDetailsPointsInput>;
  position?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<GpPodiumListSessionInfoDetailsTeamInput>;
  timing?: InputMaybe<GpPodiumListSessionInfoDetailsTimingInput>;
};

export type GpPodiumListSessionInfoDetailsPoints = {
  __typename?: 'GpPodiumListSessionInfoDetailsPoints';
  personPoints?: Maybe<Scalars['String']['output']>;
  teamPoints?: Maybe<Scalars['String']['output']>;
};

export type GpPodiumListSessionInfoDetailsPointsInput = {
  personPoints?: InputMaybe<Scalars['String']['input']>;
  teamPoints?: InputMaybe<Scalars['String']['input']>;
};

export type GpPodiumListSessionInfoDetailsTeam = {
  __typename?: 'GpPodiumListSessionInfoDetailsTeam';
  name?: Maybe<Scalars['String']['output']>;
};

export type GpPodiumListSessionInfoDetailsTeamInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GpPodiumListSessionInfoDetailsTiming = {
  __typename?: 'GpPodiumListSessionInfoDetailsTiming';
  timeHours?: Maybe<Scalars['String']['output']>;
  timeMilliseconds?: Maybe<Scalars['String']['output']>;
  timeMinutes?: Maybe<Scalars['String']['output']>;
  timeSeconds?: Maybe<Scalars['String']['output']>;
};

export type GpPodiumListSessionInfoDetailsTimingInput = {
  timeHours?: InputMaybe<Scalars['String']['input']>;
  timeMilliseconds?: InputMaybe<Scalars['String']['input']>;
  timeMinutes?: InputMaybe<Scalars['String']['input']>;
  timeSeconds?: InputMaybe<Scalars['String']['input']>;
};

export type GpPodiumListSessionInfoInput = {
  details?: InputMaybe<Array<InputMaybe<GpPodiumListSessionInfoDetailsInput>>>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  sessionLabel?: InputMaybe<Scalars['String']['input']>;
  sessionName?: InputMaybe<Scalars['String']['input']>;
  sessionStatus?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

export type GpPodiumListSessionInput = {
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  sessionInfo?: InputMaybe<GpPodiumListSessionInfoInput>;
  sessionLabel?: InputMaybe<Scalars['String']['input']>;
  sessionStatus?: InputMaybe<Scalars['String']['input']>;
};

export type GpPodiumListWidget = {
  __typename?: 'GpPodiumListWidget';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  grandPrixList?: Maybe<Array<Maybe<GpPodiumListGrandPrix>>>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type GpResultsContainerWidget = {
  __typename?: 'GpResultsContainerWidget';
  FP1?: Maybe<GpResultsContainerWrapper>;
  FP2?: Maybe<GpResultsContainerWrapper>;
  FP3?: Maybe<GpResultsContainerWrapper>;
  FP4?: Maybe<GpResultsContainerWrapper>;
  G?: Maybe<GpResultsContainerWrapper>;
  GS?: Maybe<GpResultsContainerWrapper>;
  Q?: Maybe<GpResultsContainerWrapper>;
  QS?: Maybe<GpResultsContainerWrapper>;
  R?: Maybe<GpResultsContainerWrapper>;
  SPRINT?: Maybe<GpResultsContainerWrapper>;
  SS?: Maybe<GpResultsContainerWrapper>;
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  gpId: Scalars['ID']['output'];
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type GpResultsContainerWrapper = {
  __typename?: 'GpResultsContainerWrapper';
  customDataAttributes?: Maybe<GpResultsContainerWrapperAttributes>;
  ssi?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['String']['output']>;
};

export type GpResultsContainerWrapperAttributes = {
  __typename?: 'GpResultsContainerWrapperAttributes';
  tracking?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GpResultsContainerWrapperAttributesInput = {
  tracking?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type GpResultsContainerWrapperInput = {
  customDataAttributes?: InputMaybe<GpResultsContainerWrapperAttributesInput>;
  ssi?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

export type GpResultsGpInfo = {
  __typename?: 'GpResultsGpInfo';
  customGpName?: Maybe<Scalars['String']['output']>;
  gpStatus?: Maybe<Scalars['String']['output']>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  isExclusive?: Maybe<Scalars['Boolean']['output']>;
  isSprint?: Maybe<Scalars['Boolean']['output']>;
  lapRecord?: Maybe<Scalars['String']['output']>;
  laps?: Maybe<Scalars['String']['output']>;
  lengthKm?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['String']['output']>;
};

export type GpResultsGpInfoInput = {
  customGpName?: InputMaybe<Scalars['String']['input']>;
  gpStatus?: InputMaybe<Scalars['String']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isSprint?: InputMaybe<Scalars['Boolean']['input']>;
  lapRecord?: InputMaybe<Scalars['String']['input']>;
  laps?: InputMaybe<Scalars['String']['input']>;
  lengthKm?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

export type GpResultsSession = {
  __typename?: 'GpResultsSession';
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  sessionInfo?: Maybe<GpResultsSessionInfo>;
};

export type GpResultsSessionInfo = {
  __typename?: 'GpResultsSessionInfo';
  details?: Maybe<Array<Maybe<GpResultsSessionInfoDetails>>>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  sessionLabel?: Maybe<Scalars['String']['output']>;
  sessionName?: Maybe<Scalars['String']['output']>;
  sessionStatus?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['String']['output']>;
};

export type GpResultsSessionInfoDetails = {
  __typename?: 'GpResultsSessionInfoDetails';
  customDriverName?: Maybe<Scalars['String']['output']>;
  customDriverPageUrl?: Maybe<Scalars['String']['output']>;
  customDriverSurname?: Maybe<Scalars['String']['output']>;
  customTeamName?: Maybe<Scalars['String']['output']>;
  customTeamPageUrl?: Maybe<Scalars['String']['output']>;
  fastestLap?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  flagUrl?: Maybe<Scalars['String']['output']>;
  gap?: Maybe<Scalars['String']['output']>;
  isFastestLap?: Maybe<Scalars['Boolean']['output']>;
  laps?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  points?: Maybe<GpResultsSessionInfoDetailsPoints>;
  position?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team?: Maybe<GpResultsSessionInfoDetailsTeam>;
  timing?: Maybe<GpResultsSessionInfoDetailsTiming>;
};

export type GpResultsSessionInfoDetailsInput = {
  customDriverName?: InputMaybe<Scalars['String']['input']>;
  customDriverPageUrl?: InputMaybe<Scalars['String']['input']>;
  customDriverSurname?: InputMaybe<Scalars['String']['input']>;
  customTeamName?: InputMaybe<Scalars['String']['input']>;
  customTeamPageUrl?: InputMaybe<Scalars['String']['input']>;
  fastestLap?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  flagUrl?: InputMaybe<Scalars['String']['input']>;
  gap?: InputMaybe<Scalars['String']['input']>;
  isFastestLap?: InputMaybe<Scalars['Boolean']['input']>;
  laps?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<GpResultsSessionInfoDetailsPointsInput>;
  position?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<GpResultsSessionInfoDetailsTeamInput>;
  timing?: InputMaybe<GpResultsSessionInfoDetailsTimingInput>;
};

export type GpResultsSessionInfoDetailsPoints = {
  __typename?: 'GpResultsSessionInfoDetailsPoints';
  personPoints?: Maybe<Scalars['String']['output']>;
  teamPoints?: Maybe<Scalars['String']['output']>;
};

export type GpResultsSessionInfoDetailsPointsInput = {
  personPoints?: InputMaybe<Scalars['String']['input']>;
  teamPoints?: InputMaybe<Scalars['String']['input']>;
};

export type GpResultsSessionInfoDetailsTeam = {
  __typename?: 'GpResultsSessionInfoDetailsTeam';
  name?: Maybe<Scalars['String']['output']>;
};

export type GpResultsSessionInfoDetailsTeamInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GpResultsSessionInfoDetailsTiming = {
  __typename?: 'GpResultsSessionInfoDetailsTiming';
  timeHours?: Maybe<Scalars['String']['output']>;
  timeMilliseconds?: Maybe<Scalars['String']['output']>;
  timeMinutes?: Maybe<Scalars['String']['output']>;
  timeSeconds?: Maybe<Scalars['String']['output']>;
};

export type GpResultsSessionInfoDetailsTimingInput = {
  timeHours?: InputMaybe<Scalars['String']['input']>;
  timeMilliseconds?: InputMaybe<Scalars['String']['input']>;
  timeMinutes?: InputMaybe<Scalars['String']['input']>;
  timeSeconds?: InputMaybe<Scalars['String']['input']>;
};

export type GpResultsSessionInfoInput = {
  details?: InputMaybe<Array<InputMaybe<GpResultsSessionInfoDetailsInput>>>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  sessionLabel?: InputMaybe<Scalars['String']['input']>;
  sessionName?: InputMaybe<Scalars['String']['input']>;
  sessionStatus?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

export type GpResultsSessionInput = {
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  sessionInfo?: InputMaybe<GpResultsSessionInfoInput>;
};

export type GpResultsWidget = {
  __typename?: 'GpResultsWidget';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  gpId: Scalars['ID']['output'];
  gpInfo?: Maybe<GpResultsGpInfo>;
  gpStatus?: Maybe<Scalars['String']['output']>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  sessionName: Scalars['String']['output'];
  sessions?: Maybe<Array<Maybe<GpResultsSession>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type GrandPrix = {
  __typename?: 'GrandPrix';
  createdAt: Scalars['AWSDateTime']['output'];
  crossLink?: Maybe<CrossLink>;
  date?: Maybe<Scalars['AWSDateTime']['output']>;
  editorialData?: Maybe<EditorialData>;
  editorialDataId: Scalars['ID']['output'];
  gpId: Scalars['ID']['output'];
  gpJson?: Maybe<Scalars['AWSJSON']['output']>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  seasonAndCompId: Scalars['ID']['output'];
  sessions?: Maybe<ModelSessionConnection>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type GrandPrixsessionsArgs = {
  date?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSessionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type LgpHeroInfo = {
  __typename?: 'LgpHeroInfo';
  circuitImgUrl?: Maybe<Scalars['String']['output']>;
  customGpName?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  flagImgUrl?: Maybe<Scalars['String']['output']>;
  sportTag?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type LgpHeroInfoInput = {
  circuitImgUrl?: InputMaybe<Scalars['String']['input']>;
  customGpName?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  flagImgUrl?: InputMaybe<Scalars['String']['input']>;
  sportTag?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type LgpHeroPodium = {
  __typename?: 'LgpHeroPodium';
  customDriverName?: Maybe<Scalars['String']['output']>;
  customDriverShortName?: Maybe<Scalars['String']['output']>;
  customDriverSurname?: Maybe<Scalars['String']['output']>;
  driverImgUrl?: Maybe<Scalars['String']['output']>;
  flagImgUrl?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type LgpHeroPodiumInput = {
  customDriverName?: InputMaybe<Scalars['String']['input']>;
  customDriverShortName?: InputMaybe<Scalars['String']['input']>;
  customDriverSurname?: InputMaybe<Scalars['String']['input']>;
  driverImgUrl?: InputMaybe<Scalars['String']['input']>;
  flagImgUrl?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type LgpHeroSession = {
  __typename?: 'LgpHeroSession';
  date?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  podium?: Maybe<Array<LgpHeroPodium>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LgpHeroSessionInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  podium?: InputMaybe<Array<LgpHeroPodiumInput>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type LgpHeroStickyInfo = {
  __typename?: 'LgpHeroStickyInfo';
  customGpName?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  flagImgUrl?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type LgpHeroStickyInfoInput = {
  customGpName?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  flagImgUrl?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type LgpHeroStickySession = {
  __typename?: 'LgpHeroStickySession';
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LgpHeroStickySessionInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type LgpHeroStickyWidget = {
  __typename?: 'LgpHeroStickyWidget';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  gpId: Scalars['ID']['output'];
  info?: Maybe<LgpHeroStickyInfo>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  session?: Maybe<LgpHeroStickySession>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LgpHeroWidget = {
  __typename?: 'LgpHeroWidget';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  gpId: Scalars['ID']['output'];
  info?: Maybe<LgpHeroInfo>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  session?: Maybe<LgpHeroSession>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LgpInfoLink = {
  __typename?: 'LgpInfoLink';
  link?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type LgpInfoLinkInput = {
  link?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type LgpPreviewSession = {
  __typename?: 'LgpPreviewSession';
  date?: Maybe<Scalars['String']['output']>;
  sessionName?: Maybe<Scalars['String']['output']>;
};

export type LgpPreviewSessionInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  sessionName?: InputMaybe<Scalars['String']['input']>;
};

export type LgpPreviewWidget = {
  __typename?: 'LgpPreviewWidget';
  calendar?: Maybe<LgpInfoLink>;
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  gpId: Scalars['ID']['output'];
  gpName?: Maybe<Scalars['String']['output']>;
  gpStartDateTime?: Maybe<Scalars['String']['output']>;
  laps?: Maybe<Scalars['String']['output']>;
  lengthKm?: Maybe<Scalars['String']['output']>;
  news?: Maybe<LgpInfoLink>;
  ranking?: Maybe<LgpInfoLink>;
  results?: Maybe<LgpInfoLink>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  sessions?: Maybe<Array<Maybe<LgpPreviewSession>>>;
  sportLabel?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LgpResultsContainerWidget = {
  __typename?: 'LgpResultsContainerWidget';
  FP1?: Maybe<LgpResultsContainerWrapper>;
  FP2?: Maybe<LgpResultsContainerWrapper>;
  FP3?: Maybe<LgpResultsContainerWrapper>;
  FP4?: Maybe<LgpResultsContainerWrapper>;
  G?: Maybe<LgpResultsContainerWrapper>;
  GS?: Maybe<LgpResultsContainerWrapper>;
  Q?: Maybe<LgpResultsContainerWrapper>;
  QS?: Maybe<LgpResultsContainerWrapper>;
  R?: Maybe<LgpResultsContainerWrapper>;
  SPRINT?: Maybe<LgpResultsContainerWrapper>;
  SS?: Maybe<LgpResultsContainerWrapper>;
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  gpId: Scalars['ID']['output'];
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LgpResultsContainerWrapper = {
  __typename?: 'LgpResultsContainerWrapper';
  customDataAttributes?: Maybe<LgpResultsContainerWrapperAttributes>;
  ssi?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['String']['output']>;
};

export type LgpResultsContainerWrapperAttributes = {
  __typename?: 'LgpResultsContainerWrapperAttributes';
  tracking?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LgpResultsContainerWrapperAttributesInput = {
  tracking?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LgpResultsContainerWrapperInput = {
  customDataAttributes?: InputMaybe<LgpResultsContainerWrapperAttributesInput>;
  ssi?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

export type LgpResultsGpInfo = {
  __typename?: 'LgpResultsGpInfo';
  customGpName?: Maybe<Scalars['String']['output']>;
  gpStatus?: Maybe<Scalars['String']['output']>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  isExclusive?: Maybe<Scalars['Boolean']['output']>;
  isSprint?: Maybe<Scalars['Boolean']['output']>;
  lapRecord?: Maybe<Scalars['String']['output']>;
  laps?: Maybe<Scalars['String']['output']>;
  lengthKm?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['String']['output']>;
};

export type LgpResultsGpInfoInput = {
  customGpName?: InputMaybe<Scalars['String']['input']>;
  gpStatus?: InputMaybe<Scalars['String']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isSprint?: InputMaybe<Scalars['Boolean']['input']>;
  lapRecord?: InputMaybe<Scalars['String']['input']>;
  laps?: InputMaybe<Scalars['String']['input']>;
  lengthKm?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

export type LgpResultsSession = {
  __typename?: 'LgpResultsSession';
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  sessionInfo?: Maybe<LgpResultsSessionInfo>;
};

export type LgpResultsSessionInfo = {
  __typename?: 'LgpResultsSessionInfo';
  details?: Maybe<Array<Maybe<LgpResultsSessionInfoDetails>>>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  sessionLabel?: Maybe<Scalars['String']['output']>;
  sessionName?: Maybe<Scalars['String']['output']>;
  sessionStatus?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['String']['output']>;
};

export type LgpResultsSessionInfoDetails = {
  __typename?: 'LgpResultsSessionInfoDetails';
  customDriverName?: Maybe<Scalars['String']['output']>;
  customDriverPageUrl?: Maybe<Scalars['String']['output']>;
  customDriverSurname?: Maybe<Scalars['String']['output']>;
  customTeamName?: Maybe<Scalars['String']['output']>;
  customTeamPageUrl?: Maybe<Scalars['String']['output']>;
  fastestLap?: Maybe<Scalars['String']['output']>;
  flagUrl?: Maybe<Scalars['String']['output']>;
  gap?: Maybe<Scalars['String']['output']>;
  isFastestLap?: Maybe<Scalars['Boolean']['output']>;
  laps?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timing?: Maybe<LgpResultsSessionInfoDetailsTiming>;
};

export type LgpResultsSessionInfoDetailsInput = {
  customDriverName?: InputMaybe<Scalars['String']['input']>;
  customDriverPageUrl?: InputMaybe<Scalars['String']['input']>;
  customDriverSurname?: InputMaybe<Scalars['String']['input']>;
  customTeamName?: InputMaybe<Scalars['String']['input']>;
  customTeamPageUrl?: InputMaybe<Scalars['String']['input']>;
  fastestLap?: InputMaybe<Scalars['String']['input']>;
  flagUrl?: InputMaybe<Scalars['String']['input']>;
  gap?: InputMaybe<Scalars['String']['input']>;
  isFastestLap?: InputMaybe<Scalars['Boolean']['input']>;
  laps?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timing?: InputMaybe<LgpResultsSessionInfoDetailsTimingInput>;
};

export type LgpResultsSessionInfoDetailsTiming = {
  __typename?: 'LgpResultsSessionInfoDetailsTiming';
  timeHours?: Maybe<Scalars['String']['output']>;
  timeMilliseconds?: Maybe<Scalars['String']['output']>;
  timeMinutes?: Maybe<Scalars['String']['output']>;
  timeSeconds?: Maybe<Scalars['String']['output']>;
};

export type LgpResultsSessionInfoDetailsTimingInput = {
  timeHours?: InputMaybe<Scalars['String']['input']>;
  timeMilliseconds?: InputMaybe<Scalars['String']['input']>;
  timeMinutes?: InputMaybe<Scalars['String']['input']>;
  timeSeconds?: InputMaybe<Scalars['String']['input']>;
};

export type LgpResultsSessionInfoInput = {
  details?: InputMaybe<Array<InputMaybe<LgpResultsSessionInfoDetailsInput>>>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  sessionLabel?: InputMaybe<Scalars['String']['input']>;
  sessionName?: InputMaybe<Scalars['String']['input']>;
  sessionStatus?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

export type LgpResultsSessionInput = {
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  sessionInfo?: InputMaybe<LgpResultsSessionInfoInput>;
};

export type LgpResultsWidget = {
  __typename?: 'LgpResultsWidget';
  calendar?: Maybe<LgpInfoLink>;
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  gpId: Scalars['ID']['output'];
  gpInfo?: Maybe<LgpResultsGpInfo>;
  gpStatus?: Maybe<Scalars['String']['output']>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  ranking?: Maybe<LgpInfoLink>;
  results?: Maybe<LgpInfoLink>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  sessionName: Scalars['String']['output'];
  sessions?: Maybe<Array<Maybe<LgpResultsSession>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LiveScoreWidget = {
  __typename?: 'LiveScoreWidget';
  createdAt: Scalars['AWSDateTime']['output'];
  currentDay?: Maybe<Array<Maybe<LiveScoreWidgetDay>>>;
  id: Scalars['ID']['output'];
  nextDay?: Maybe<Array<Maybe<LiveScoreWidgetDay>>>;
  previousDay?: Maybe<Array<Maybe<LiveScoreWidgetDay>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LiveScoreWidgetDay = {
  __typename?: 'LiveScoreWidgetDay';
  gpInfo?: Maybe<LiveScoreWidgetGpInfo>;
  sessions?: Maybe<Array<Maybe<LiveScoreWidgetSession>>>;
  sportTag?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetDayInput = {
  gpInfo?: InputMaybe<LiveScoreWidgetGpInfoInput>;
  sessions?: InputMaybe<Array<InputMaybe<LiveScoreWidgetSessionInput>>>;
  sportTag?: InputMaybe<Scalars['String']['input']>;
};

export type LiveScoreWidgetGpInfo = {
  __typename?: 'LiveScoreWidgetGpInfo';
  calendarUrl?: Maybe<Scalars['String']['output']>;
  customGpName?: Maybe<Scalars['String']['output']>;
  gpCrosslink?: Maybe<Scalars['String']['output']>;
  gpFlag?: Maybe<Scalars['String']['output']>;
  gpPageUrl?: Maybe<Scalars['String']['output']>;
  rankingUrl?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetGpInfoInput = {
  calendarUrl?: InputMaybe<Scalars['String']['input']>;
  customGpName?: InputMaybe<Scalars['String']['input']>;
  gpCrosslink?: InputMaybe<Scalars['String']['input']>;
  gpFlag?: InputMaybe<Scalars['String']['input']>;
  gpPageUrl?: InputMaybe<Scalars['String']['input']>;
  rankingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type LiveScoreWidgetResults = {
  __typename?: 'LiveScoreWidgetResults';
  customDriverName?: Maybe<Scalars['String']['output']>;
  customDriverPageUrl?: Maybe<Scalars['String']['output']>;
  customDriverSurname?: Maybe<Scalars['String']['output']>;
  customTeamName?: Maybe<Scalars['String']['output']>;
  customTeamPageUrl?: Maybe<Scalars['String']['output']>;
  fastestLap?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  flagUrl?: Maybe<Scalars['String']['output']>;
  gap?: Maybe<Scalars['String']['output']>;
  isFastestLap?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  timing?: Maybe<LiveScoreWidgetResultsTiming>;
};

export type LiveScoreWidgetResultsInput = {
  customDriverName?: InputMaybe<Scalars['String']['input']>;
  customDriverPageUrl?: InputMaybe<Scalars['String']['input']>;
  customDriverSurname?: InputMaybe<Scalars['String']['input']>;
  customTeamName?: InputMaybe<Scalars['String']['input']>;
  customTeamPageUrl?: InputMaybe<Scalars['String']['input']>;
  fastestLap?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  flagUrl?: InputMaybe<Scalars['String']['input']>;
  gap?: InputMaybe<Scalars['String']['input']>;
  isFastestLap?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  timing?: InputMaybe<LiveScoreWidgetResultsTimingInput>;
};

export type LiveScoreWidgetResultsTiming = {
  __typename?: 'LiveScoreWidgetResultsTiming';
  timeHours?: Maybe<Scalars['String']['output']>;
  timeMilliseconds?: Maybe<Scalars['String']['output']>;
  timeMinutes?: Maybe<Scalars['String']['output']>;
  timeSeconds?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetResultsTimingInput = {
  timeHours?: InputMaybe<Scalars['String']['input']>;
  timeMilliseconds?: InputMaybe<Scalars['String']['input']>;
  timeMinutes?: InputMaybe<Scalars['String']['input']>;
  timeSeconds?: InputMaybe<Scalars['String']['input']>;
};

export type LiveScoreWidgetSession = {
  __typename?: 'LiveScoreWidgetSession';
  results?: Maybe<Array<Maybe<LiveScoreWidgetResults>>>;
  resultsUrl?: Maybe<Scalars['String']['output']>;
  sessionDate?: Maybe<Scalars['String']['output']>;
  sessionName?: Maybe<Scalars['String']['output']>;
  sessionStatus?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreWidgetSessionInput = {
  results?: InputMaybe<Array<InputMaybe<LiveScoreWidgetResultsInput>>>;
  resultsUrl?: InputMaybe<Scalars['String']['input']>;
  sessionDate?: InputMaybe<Scalars['String']['input']>;
  sessionName?: InputMaybe<Scalars['String']['input']>;
  sessionStatus?: InputMaybe<Scalars['String']['input']>;
};

export type ModelBooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModelCardDriverRankingWidgetConnection = {
  __typename?: 'ModelCardDriverRankingWidgetConnection';
  items: Array<Maybe<CardDriverRankingWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCardDriverRankingWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCardDriverRankingWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  customCompetitionName?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelCardDriverRankingWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCardDriverRankingWidgetFilterInput>>>;
  rankingLink?: InputMaybe<ModelStringFilterInput>;
};

export type ModelCardGpCalendarWidgetConnection = {
  __typename?: 'ModelCardGpCalendarWidgetConnection';
  items: Array<Maybe<CardGpCalendarWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCardGpCalendarWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCardGpCalendarWidgetFilterInput>>>;
  calendarLink?: InputMaybe<ModelStringFilterInput>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  customCompetitionName?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelCardGpCalendarWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCardGpCalendarWidgetFilterInput>>>;
};

export type ModelCardGpResultsWidgetConnection = {
  __typename?: 'ModelCardGpResultsWidgetConnection';
  items: Array<Maybe<CardGpResultsWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCardGpResultsWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCardGpResultsWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  customCompetitionName?: InputMaybe<ModelStringFilterInput>;
  customGpName?: InputMaybe<ModelStringFilterInput>;
  isSprint?: InputMaybe<ModelBooleanFilterInput>;
  not?: InputMaybe<ModelCardGpResultsWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCardGpResultsWidgetFilterInput>>>;
  resultsLink?: InputMaybe<ModelStringFilterInput>;
};

export type ModelCardTeamRankingWidgetConnection = {
  __typename?: 'ModelCardTeamRankingWidgetConnection';
  items: Array<Maybe<CardTeamRankingWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCardTeamRankingWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCardTeamRankingWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  customCompetitionName?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelCardTeamRankingWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCardTeamRankingWidgetFilterInput>>>;
  rankingLink?: InputMaybe<ModelStringFilterInput>;
};

export type ModelCompetitionConnection = {
  __typename?: 'ModelCompetitionConnection';
  items: Array<Maybe<Competition>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCompetitionFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCompetitionFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  competitionJson?: InputMaybe<ModelStringFilterInput>;
  editorialDataId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelCompetitionFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCompetitionFilterInput>>>;
  previousSeasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelCrossLinkConnection = {
  __typename?: 'ModelCrossLinkConnection';
  items: Array<Maybe<CrossLink>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCrossLinkFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCrossLinkFilterInput>>>;
  crossLinkJson?: InputMaybe<ModelStringFilterInput>;
  gpId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelCrossLinkFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCrossLinkFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelDriverConnection = {
  __typename?: 'ModelDriverConnection';
  items: Array<Maybe<Driver>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelDriverFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelDriverFilterInput>>>;
  driverId?: InputMaybe<ModelIDFilterInput>;
  driverJson?: InputMaybe<ModelStringFilterInput>;
  editorialDataId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelDriverFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelDriverFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  teamId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelDriverRankingWidgetConnection = {
  __typename?: 'ModelDriverRankingWidgetConnection';
  items: Array<Maybe<DriverRankingWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelDriverRankingWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelDriverRankingWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  competitionLabel?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelDriverRankingWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelDriverRankingWidgetFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelDriverStatsWidgetConnection = {
  __typename?: 'ModelDriverStatsWidgetConnection';
  items: Array<Maybe<DriverStatsWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelDriverStatsWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelDriverStatsWidgetFilterInput>>>;
  customCompetitionName?: InputMaybe<ModelStringFilterInput>;
  customSeasonName?: InputMaybe<ModelStringFilterInput>;
  driverId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelDriverStatsWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelDriverStatsWidgetFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelStringFilterInput>;
};

export type ModelEditorialDataConnection = {
  __typename?: 'ModelEditorialDataConnection';
  items: Array<Maybe<EditorialData>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelEditorialDataFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelEditorialDataFilterInput>>>;
  editorialDataId?: InputMaybe<ModelIDFilterInput>;
  editorialJson?: InputMaybe<ModelStringFilterInput>;
  isCurrent?: InputMaybe<ModelBooleanFilterInput>;
  not?: InputMaybe<ModelEditorialDataFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelEditorialDataFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelFloatFilterInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  ge?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  le?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
};

export type ModelGpCalendarWidgetConnection = {
  __typename?: 'ModelGpCalendarWidgetConnection';
  items: Array<Maybe<GpCalendarWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelGpCalendarWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelGpCalendarWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelGpCalendarWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelGpCalendarWidgetFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelGpCurrentCalendarWidgetConnection = {
  __typename?: 'ModelGpCurrentCalendarWidgetConnection';
  items: Array<Maybe<GpCurrentCalendarWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelGpCurrentCalendarWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelGpCurrentCalendarWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelGpCurrentCalendarWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelGpCurrentCalendarWidgetFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelGpDataConnection = {
  __typename?: 'ModelGpDataConnection';
  items: Array<Maybe<GpData>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelGpDataFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelGpDataFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  data?: InputMaybe<ModelStringFilterInput>;
  gpId?: InputMaybe<ModelIDFilterInput>;
  messageType?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelGpDataFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelGpDataFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelGpLiveContainerWidgetConnection = {
  __typename?: 'ModelGpLiveContainerWidgetConnection';
  items: Array<Maybe<GpLiveContainerWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelGpLiveContainerWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelGpLiveContainerWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelGpLiveContainerWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelGpLiveContainerWidgetFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelGpLiveHeroWidgetConnection = {
  __typename?: 'ModelGpLiveHeroWidgetConnection';
  items: Array<Maybe<GpLiveHeroWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelGpLiveHeroWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelGpLiveHeroWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  isCurrent?: InputMaybe<ModelBooleanFilterInput>;
  not?: InputMaybe<ModelGpLiveHeroWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelGpLiveHeroWidgetFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelGpPodiumListWidgetConnection = {
  __typename?: 'ModelGpPodiumListWidgetConnection';
  items: Array<Maybe<GpPodiumListWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelGpPodiumListWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelGpPodiumListWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelGpPodiumListWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelGpPodiumListWidgetFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelGpResultsContainerWidgetConnection = {
  __typename?: 'ModelGpResultsContainerWidgetConnection';
  items: Array<Maybe<GpResultsContainerWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelGpResultsContainerWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelGpResultsContainerWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  gpId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelGpResultsContainerWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelGpResultsContainerWidgetFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelGpResultsWidgetConnection = {
  __typename?: 'ModelGpResultsWidgetConnection';
  items: Array<Maybe<GpResultsWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelGpResultsWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelGpResultsWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  gpId?: InputMaybe<ModelIDFilterInput>;
  gpStatus?: InputMaybe<ModelStringFilterInput>;
  isCurrent?: InputMaybe<ModelBooleanFilterInput>;
  not?: InputMaybe<ModelGpResultsWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelGpResultsWidgetFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
  sessionName?: InputMaybe<ModelStringFilterInput>;
};

export type ModelGrandPrixConnection = {
  __typename?: 'ModelGrandPrixConnection';
  items: Array<Maybe<GrandPrix>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelGrandPrixFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelGrandPrixFilterInput>>>;
  date?: InputMaybe<ModelStringFilterInput>;
  editorialDataId?: InputMaybe<ModelIDFilterInput>;
  gpId?: InputMaybe<ModelIDFilterInput>;
  gpJson?: InputMaybe<ModelStringFilterInput>;
  isCurrent?: InputMaybe<ModelBooleanFilterInput>;
  not?: InputMaybe<ModelGrandPrixFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelGrandPrixFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  status?: InputMaybe<ModelStringFilterInput>;
};

export type ModelIDFilterInput = {
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelIDKeyConditionInput = {
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelIntFilterInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelLgpHeroStickyWidgetConnection = {
  __typename?: 'ModelLgpHeroStickyWidgetConnection';
  items: Array<Maybe<LgpHeroStickyWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLgpHeroStickyWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLgpHeroStickyWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  gpId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelLgpHeroStickyWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLgpHeroStickyWidgetFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelLgpHeroWidgetConnection = {
  __typename?: 'ModelLgpHeroWidgetConnection';
  items: Array<Maybe<LgpHeroWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLgpHeroWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLgpHeroWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  gpId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelLgpHeroWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLgpHeroWidgetFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelLgpPreviewWidgetConnection = {
  __typename?: 'ModelLgpPreviewWidgetConnection';
  items: Array<Maybe<LgpPreviewWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLgpPreviewWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLgpPreviewWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  gpId?: InputMaybe<ModelIDFilterInput>;
  gpName?: InputMaybe<ModelStringFilterInput>;
  gpStartDateTime?: InputMaybe<ModelStringFilterInput>;
  laps?: InputMaybe<ModelStringFilterInput>;
  lengthKm?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelLgpPreviewWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLgpPreviewWidgetFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
  sportLabel?: InputMaybe<ModelStringFilterInput>;
};

export type ModelLgpResultsContainerWidgetConnection = {
  __typename?: 'ModelLgpResultsContainerWidgetConnection';
  items: Array<Maybe<LgpResultsContainerWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLgpResultsContainerWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLgpResultsContainerWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  gpId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelLgpResultsContainerWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLgpResultsContainerWidgetFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelLgpResultsWidgetConnection = {
  __typename?: 'ModelLgpResultsWidgetConnection';
  items: Array<Maybe<LgpResultsWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLgpResultsWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLgpResultsWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  gpId?: InputMaybe<ModelIDFilterInput>;
  gpStatus?: InputMaybe<ModelStringFilterInput>;
  isCurrent?: InputMaybe<ModelBooleanFilterInput>;
  not?: InputMaybe<ModelLgpResultsWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLgpResultsWidgetFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
  sessionName?: InputMaybe<ModelStringFilterInput>;
};

export type ModelLiveScoreWidgetConnection = {
  __typename?: 'ModelLiveScoreWidgetConnection';
  items: Array<Maybe<LiveScoreWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLiveScoreWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLiveScoreWidgetFilterInput>>>;
  id?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelLiveScoreWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLiveScoreWidgetFilterInput>>>;
};

export type ModelSeasonConnection = {
  __typename?: 'ModelSeasonConnection';
  items: Array<Maybe<Season>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSeasonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSeasonFilterInput>>>;
  not?: InputMaybe<ModelSeasonFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSeasonFilterInput>>>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
  seasonJson?: InputMaybe<ModelStringFilterInput>;
};

export type ModelSeasonRankingGalleryWidgetConnection = {
  __typename?: 'ModelSeasonRankingGalleryWidgetConnection';
  items: Array<Maybe<SeasonRankingGalleryWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSeasonRankingGalleryWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSeasonRankingGalleryWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  competitionName?: InputMaybe<ModelStringFilterInput>;
  competitionsSlugName?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelSeasonRankingGalleryWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSeasonRankingGalleryWidgetFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelSessionConnection = {
  __typename?: 'ModelSessionConnection';
  items: Array<Maybe<Session>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSessionFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSessionFilterInput>>>;
  date?: InputMaybe<ModelStringFilterInput>;
  gpId?: InputMaybe<ModelIDFilterInput>;
  isCurrent?: InputMaybe<ModelBooleanFilterInput>;
  not?: InputMaybe<ModelSessionFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSessionFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  sessionId?: InputMaybe<ModelIDFilterInput>;
  sessionJson?: InputMaybe<ModelStringFilterInput>;
  status?: InputMaybe<ModelStringFilterInput>;
};

export enum ModelSortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type ModelStringFilterInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
};

export type ModelStringKeyConditionInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
};

export type ModelTeamConnection = {
  __typename?: 'ModelTeamConnection';
  items: Array<Maybe<Team>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTeamDriverPageWidgetConnection = {
  __typename?: 'ModelTeamDriverPageWidgetConnection';
  items: Array<Maybe<TeamDriverPageWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTeamDriverPageWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTeamDriverPageWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelTeamDriverPageWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTeamDriverPageWidgetFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelTeamFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTeamFilterInput>>>;
  editorialDataId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelTeamFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTeamFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  teamId?: InputMaybe<ModelIDFilterInput>;
  teamJson?: InputMaybe<ModelStringFilterInput>;
};

export type ModelTeamRankingWidgetConnection = {
  __typename?: 'ModelTeamRankingWidgetConnection';
  items: Array<Maybe<TeamRankingWidget>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTeamRankingWidgetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTeamRankingWidgetFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  competitionLabel?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelTeamRankingWidgetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTeamRankingWidgetFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createCardDriverRankingWidget?: Maybe<CardDriverRankingWidget>;
  createCardGpCalendarWidget?: Maybe<CardGpCalendarWidget>;
  createCardGpResultsWidget?: Maybe<CardGpResultsWidget>;
  createCardTeamRankingWidget?: Maybe<CardTeamRankingWidget>;
  createCompetition?: Maybe<Competition>;
  createCrossLink?: Maybe<CrossLink>;
  createDriver?: Maybe<Driver>;
  createDriverRankingWidget?: Maybe<DriverRankingWidget>;
  createDriverStatsWidget?: Maybe<DriverStatsWidget>;
  createEditorialData?: Maybe<EditorialData>;
  createGpCalendarWidget?: Maybe<GpCalendarWidget>;
  createGpCurrentCalendarWidget?: Maybe<GpCurrentCalendarWidget>;
  createGpData?: Maybe<GpData>;
  createGpLiveContainerWidget?: Maybe<GpLiveContainerWidget>;
  createGpLiveHeroWidget?: Maybe<GpLiveHeroWidget>;
  createGpPodiumListWidget?: Maybe<GpPodiumListWidget>;
  createGpResultsContainerWidget?: Maybe<GpResultsContainerWidget>;
  createGpResultsWidget?: Maybe<GpResultsWidget>;
  createGrandPrix?: Maybe<GrandPrix>;
  createLgpHeroStickyWidget?: Maybe<LgpHeroStickyWidget>;
  createLgpHeroWidget?: Maybe<LgpHeroWidget>;
  createLgpPreviewWidget?: Maybe<LgpPreviewWidget>;
  createLgpResultsContainerWidget?: Maybe<LgpResultsContainerWidget>;
  createLgpResultsWidget?: Maybe<LgpResultsWidget>;
  createLiveScoreWidget?: Maybe<LiveScoreWidget>;
  createSeason?: Maybe<Season>;
  createSeasonRankingGalleryWidget?: Maybe<SeasonRankingGalleryWidget>;
  createSession?: Maybe<Session>;
  createTeam?: Maybe<Team>;
  createTeamDriverPageWidget?: Maybe<TeamDriverPageWidget>;
  createTeamRankingWidget?: Maybe<TeamRankingWidget>;
  deleteCardDriverRankingWidget?: Maybe<CardDriverRankingWidget>;
  deleteCardGpCalendarWidget?: Maybe<CardGpCalendarWidget>;
  deleteCardGpResultsWidget?: Maybe<CardGpResultsWidget>;
  deleteCardTeamRankingWidget?: Maybe<CardTeamRankingWidget>;
  deleteCompetition?: Maybe<Competition>;
  deleteCrossLink?: Maybe<CrossLink>;
  deleteDriver?: Maybe<Driver>;
  deleteDriverRankingWidget?: Maybe<DriverRankingWidget>;
  deleteDriverStatsWidget?: Maybe<DriverStatsWidget>;
  deleteEditorialData?: Maybe<EditorialData>;
  deleteGpCalendarWidget?: Maybe<GpCalendarWidget>;
  deleteGpCurrentCalendarWidget?: Maybe<GpCurrentCalendarWidget>;
  deleteGpData?: Maybe<GpData>;
  deleteGpLiveContainerWidget?: Maybe<GpLiveContainerWidget>;
  deleteGpLiveHeroWidget?: Maybe<GpLiveHeroWidget>;
  deleteGpPodiumListWidget?: Maybe<GpPodiumListWidget>;
  deleteGpResultsContainerWidget?: Maybe<GpResultsContainerWidget>;
  deleteGpResultsWidget?: Maybe<GpResultsWidget>;
  deleteGrandPrix?: Maybe<GrandPrix>;
  deleteLgpHeroStickyWidget?: Maybe<LgpHeroStickyWidget>;
  deleteLgpHeroWidget?: Maybe<LgpHeroWidget>;
  deleteLgpPreviewWidget?: Maybe<LgpPreviewWidget>;
  deleteLgpResultsContainerWidget?: Maybe<LgpResultsContainerWidget>;
  deleteLgpResultsWidget?: Maybe<LgpResultsWidget>;
  deleteLiveScoreWidget?: Maybe<LiveScoreWidget>;
  deleteSeason?: Maybe<Season>;
  deleteSeasonRankingGalleryWidget?: Maybe<SeasonRankingGalleryWidget>;
  deleteSession?: Maybe<Session>;
  deleteTeam?: Maybe<Team>;
  deleteTeamDriverPageWidget?: Maybe<TeamDriverPageWidget>;
  deleteTeamRankingWidget?: Maybe<TeamRankingWidget>;
  putObject?: Maybe<Scalars['String']['output']>;
  updateCardDriverRankingWidget?: Maybe<CardDriverRankingWidget>;
  updateCardGpCalendarWidget?: Maybe<CardGpCalendarWidget>;
  updateCardGpResultsWidget?: Maybe<CardGpResultsWidget>;
  updateCardTeamRankingWidget?: Maybe<CardTeamRankingWidget>;
  updateCompetition?: Maybe<Competition>;
  updateCrossLink?: Maybe<CrossLink>;
  updateDriver?: Maybe<Driver>;
  updateDriverRankingWidget?: Maybe<DriverRankingWidget>;
  updateDriverStatsWidget?: Maybe<DriverStatsWidget>;
  updateEditorialData?: Maybe<EditorialData>;
  updateGpCalendarWidget?: Maybe<GpCalendarWidget>;
  updateGpCurrentCalendarWidget?: Maybe<GpCurrentCalendarWidget>;
  updateGpData?: Maybe<GpData>;
  updateGpLiveContainerWidget?: Maybe<GpLiveContainerWidget>;
  updateGpLiveHeroWidget?: Maybe<GpLiveHeroWidget>;
  updateGpPodiumListWidget?: Maybe<GpPodiumListWidget>;
  updateGpResultsContainerWidget?: Maybe<GpResultsContainerWidget>;
  updateGpResultsWidget?: Maybe<GpResultsWidget>;
  updateGrandPrix?: Maybe<GrandPrix>;
  updateLgpHeroStickyWidget?: Maybe<LgpHeroStickyWidget>;
  updateLgpHeroWidget?: Maybe<LgpHeroWidget>;
  updateLgpPreviewWidget?: Maybe<LgpPreviewWidget>;
  updateLgpResultsContainerWidget?: Maybe<LgpResultsContainerWidget>;
  updateLgpResultsWidget?: Maybe<LgpResultsWidget>;
  updateLiveScoreWidget?: Maybe<LiveScoreWidget>;
  updateSeason?: Maybe<Season>;
  updateSeasonRankingGalleryWidget?: Maybe<SeasonRankingGalleryWidget>;
  updateSession?: Maybe<Session>;
  updateTeam?: Maybe<Team>;
  updateTeamDriverPageWidget?: Maybe<TeamDriverPageWidget>;
  updateTeamRankingWidget?: Maybe<TeamRankingWidget>;
};


export type MutationcreateCardDriverRankingWidgetArgs = {
  input: CreateCardDriverRankingWidgetInput;
};


export type MutationcreateCardGpCalendarWidgetArgs = {
  input: CreateCardGpCalendarWidgetInput;
};


export type MutationcreateCardGpResultsWidgetArgs = {
  input: CreateCardGpResultsWidgetInput;
};


export type MutationcreateCardTeamRankingWidgetArgs = {
  input: CreateCardTeamRankingWidgetInput;
};


export type MutationcreateCompetitionArgs = {
  input: CreateCompetitionInput;
};


export type MutationcreateCrossLinkArgs = {
  input: CreateCrossLinkInput;
};


export type MutationcreateDriverArgs = {
  input: CreateDriverInput;
};


export type MutationcreateDriverRankingWidgetArgs = {
  input: CreateDriverRankingWidgetInput;
};


export type MutationcreateDriverStatsWidgetArgs = {
  input: CreateDriverStatsWidgetInput;
};


export type MutationcreateEditorialDataArgs = {
  input: CreateEditorialDataInput;
};


export type MutationcreateGpCalendarWidgetArgs = {
  input: CreateGpCalendarWidgetInput;
};


export type MutationcreateGpCurrentCalendarWidgetArgs = {
  input: CreateGpCurrentCalendarWidgetInput;
};


export type MutationcreateGpDataArgs = {
  input: CreateGpDataInput;
};


export type MutationcreateGpLiveContainerWidgetArgs = {
  input: CreateGpLiveContainerWidgetInput;
};


export type MutationcreateGpLiveHeroWidgetArgs = {
  input: CreateGpLiveHeroWidgetInput;
};


export type MutationcreateGpPodiumListWidgetArgs = {
  input: CreateGpPodiumListWidgetInput;
};


export type MutationcreateGpResultsContainerWidgetArgs = {
  input: CreateGpResultsContainerWidgetInput;
};


export type MutationcreateGpResultsWidgetArgs = {
  input: CreateGpResultsWidgetInput;
};


export type MutationcreateGrandPrixArgs = {
  input: CreateGrandPrixInput;
};


export type MutationcreateLgpHeroStickyWidgetArgs = {
  input: CreateLgpHeroStickyWidgetInput;
};


export type MutationcreateLgpHeroWidgetArgs = {
  input: CreateLgpHeroWidgetInput;
};


export type MutationcreateLgpPreviewWidgetArgs = {
  input: CreateLgpPreviewWidgetInput;
};


export type MutationcreateLgpResultsContainerWidgetArgs = {
  input: CreateLgpResultsContainerWidgetInput;
};


export type MutationcreateLgpResultsWidgetArgs = {
  input: CreateLgpResultsWidgetInput;
};


export type MutationcreateLiveScoreWidgetArgs = {
  input: CreateLiveScoreWidgetInput;
};


export type MutationcreateSeasonArgs = {
  input: CreateSeasonInput;
};


export type MutationcreateSeasonRankingGalleryWidgetArgs = {
  input: CreateSeasonRankingGalleryWidgetInput;
};


export type MutationcreateSessionArgs = {
  input: CreateSessionInput;
};


export type MutationcreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationcreateTeamDriverPageWidgetArgs = {
  input: CreateTeamDriverPageWidgetInput;
};


export type MutationcreateTeamRankingWidgetArgs = {
  input: CreateTeamRankingWidgetInput;
};


export type MutationdeleteCardDriverRankingWidgetArgs = {
  input: DeleteCardDriverRankingWidgetInput;
};


export type MutationdeleteCardGpCalendarWidgetArgs = {
  input: DeleteCardGpCalendarWidgetInput;
};


export type MutationdeleteCardGpResultsWidgetArgs = {
  input: DeleteCardGpResultsWidgetInput;
};


export type MutationdeleteCardTeamRankingWidgetArgs = {
  input: DeleteCardTeamRankingWidgetInput;
};


export type MutationdeleteCompetitionArgs = {
  input: DeleteCompetitionInput;
};


export type MutationdeleteCrossLinkArgs = {
  input: DeleteCrossLinkInput;
};


export type MutationdeleteDriverArgs = {
  input: DeleteDriverInput;
};


export type MutationdeleteDriverRankingWidgetArgs = {
  input: DeleteDriverRankingWidgetInput;
};


export type MutationdeleteDriverStatsWidgetArgs = {
  input: DeleteDriverStatsWidgetInput;
};


export type MutationdeleteEditorialDataArgs = {
  input: DeleteEditorialDataInput;
};


export type MutationdeleteGpCalendarWidgetArgs = {
  input: DeleteGpCalendarWidgetInput;
};


export type MutationdeleteGpCurrentCalendarWidgetArgs = {
  input: DeleteGpCurrentCalendarWidgetInput;
};


export type MutationdeleteGpDataArgs = {
  input: DeleteGpDataInput;
};


export type MutationdeleteGpLiveContainerWidgetArgs = {
  input: DeleteGpLiveContainerWidgetInput;
};


export type MutationdeleteGpLiveHeroWidgetArgs = {
  input: DeleteGpLiveHeroWidgetInput;
};


export type MutationdeleteGpPodiumListWidgetArgs = {
  input: DeleteGpPodiumListWidgetInput;
};


export type MutationdeleteGpResultsContainerWidgetArgs = {
  input: DeleteGpResultsContainerWidgetInput;
};


export type MutationdeleteGpResultsWidgetArgs = {
  input: DeleteGpResultsWidgetInput;
};


export type MutationdeleteGrandPrixArgs = {
  input: DeleteGrandPrixInput;
};


export type MutationdeleteLgpHeroStickyWidgetArgs = {
  input: DeleteLgpHeroStickyWidgetInput;
};


export type MutationdeleteLgpHeroWidgetArgs = {
  input: DeleteLgpHeroWidgetInput;
};


export type MutationdeleteLgpPreviewWidgetArgs = {
  input: DeleteLgpPreviewWidgetInput;
};


export type MutationdeleteLgpResultsContainerWidgetArgs = {
  input: DeleteLgpResultsContainerWidgetInput;
};


export type MutationdeleteLgpResultsWidgetArgs = {
  input: DeleteLgpResultsWidgetInput;
};


export type MutationdeleteLiveScoreWidgetArgs = {
  input: DeleteLiveScoreWidgetInput;
};


export type MutationdeleteSeasonArgs = {
  input: DeleteSeasonInput;
};


export type MutationdeleteSeasonRankingGalleryWidgetArgs = {
  input: DeleteSeasonRankingGalleryWidgetInput;
};


export type MutationdeleteSessionArgs = {
  input: DeleteSessionInput;
};


export type MutationdeleteTeamArgs = {
  input: DeleteTeamInput;
};


export type MutationdeleteTeamDriverPageWidgetArgs = {
  input: DeleteTeamDriverPageWidgetInput;
};


export type MutationdeleteTeamRankingWidgetArgs = {
  input: DeleteTeamRankingWidgetInput;
};


export type MutationputObjectArgs = {
  input: S3Object;
};


export type MutationupdateCardDriverRankingWidgetArgs = {
  input: UpdateCardDriverRankingWidgetInput;
};


export type MutationupdateCardGpCalendarWidgetArgs = {
  input: UpdateCardGpCalendarWidgetInput;
};


export type MutationupdateCardGpResultsWidgetArgs = {
  input: UpdateCardGpResultsWidgetInput;
};


export type MutationupdateCardTeamRankingWidgetArgs = {
  input: UpdateCardTeamRankingWidgetInput;
};


export type MutationupdateCompetitionArgs = {
  input: UpdateCompetitionInput;
};


export type MutationupdateCrossLinkArgs = {
  input: UpdateCrossLinkInput;
};


export type MutationupdateDriverArgs = {
  input: UpdateDriverInput;
};


export type MutationupdateDriverRankingWidgetArgs = {
  input: UpdateDriverRankingWidgetInput;
};


export type MutationupdateDriverStatsWidgetArgs = {
  input: UpdateDriverStatsWidgetInput;
};


export type MutationupdateEditorialDataArgs = {
  input: UpdateEditorialDataInput;
};


export type MutationupdateGpCalendarWidgetArgs = {
  input: UpdateGpCalendarWidgetInput;
};


export type MutationupdateGpCurrentCalendarWidgetArgs = {
  input: UpdateGpCurrentCalendarWidgetInput;
};


export type MutationupdateGpDataArgs = {
  input: UpdateGpDataInput;
};


export type MutationupdateGpLiveContainerWidgetArgs = {
  input: UpdateGpLiveContainerWidgetInput;
};


export type MutationupdateGpLiveHeroWidgetArgs = {
  input: UpdateGpLiveHeroWidgetInput;
};


export type MutationupdateGpPodiumListWidgetArgs = {
  input: UpdateGpPodiumListWidgetInput;
};


export type MutationupdateGpResultsContainerWidgetArgs = {
  input: UpdateGpResultsContainerWidgetInput;
};


export type MutationupdateGpResultsWidgetArgs = {
  input: UpdateGpResultsWidgetInput;
};


export type MutationupdateGrandPrixArgs = {
  input: UpdateGrandPrixInput;
};


export type MutationupdateLgpHeroStickyWidgetArgs = {
  input: UpdateLgpHeroStickyWidgetInput;
};


export type MutationupdateLgpHeroWidgetArgs = {
  input: UpdateLgpHeroWidgetInput;
};


export type MutationupdateLgpPreviewWidgetArgs = {
  input: UpdateLgpPreviewWidgetInput;
};


export type MutationupdateLgpResultsContainerWidgetArgs = {
  input: UpdateLgpResultsContainerWidgetInput;
};


export type MutationupdateLgpResultsWidgetArgs = {
  input: UpdateLgpResultsWidgetInput;
};


export type MutationupdateLiveScoreWidgetArgs = {
  input: UpdateLiveScoreWidgetInput;
};


export type MutationupdateSeasonArgs = {
  input: UpdateSeasonInput;
};


export type MutationupdateSeasonRankingGalleryWidgetArgs = {
  input: UpdateSeasonRankingGalleryWidgetInput;
};


export type MutationupdateSessionArgs = {
  input: UpdateSessionInput;
};


export type MutationupdateTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationupdateTeamDriverPageWidgetArgs = {
  input: UpdateTeamDriverPageWidgetInput;
};


export type MutationupdateTeamRankingWidgetArgs = {
  input: UpdateTeamRankingWidgetInput;
};

export type Query = {
  __typename?: 'Query';
  directLambda?: Maybe<Scalars['AWSJSON']['output']>;
  getCardDriverRankingWidget?: Maybe<CardDriverRankingWidget>;
  getCardGpCalendarWidget?: Maybe<CardGpCalendarWidget>;
  getCardGpResultsWidget?: Maybe<CardGpResultsWidget>;
  getCardTeamRankingWidget?: Maybe<CardTeamRankingWidget>;
  getCompetition?: Maybe<Competition>;
  getCompetitionById?: Maybe<ModelCompetitionConnection>;
  getCompetitionBySeasonId?: Maybe<ModelCompetitionConnection>;
  getCrossLink?: Maybe<CrossLink>;
  getCrossLinkByGpId?: Maybe<ModelCrossLinkConnection>;
  getDriver?: Maybe<Driver>;
  getDriverById?: Maybe<ModelDriverConnection>;
  getDriverByTeamId?: Maybe<ModelDriverConnection>;
  getDriverRankingWidget?: Maybe<DriverRankingWidget>;
  getDriverStatsWidget?: Maybe<DriverStatsWidget>;
  getEditorialData?: Maybe<EditorialData>;
  getEditorialDataById?: Maybe<ModelEditorialDataConnection>;
  getGpById?: Maybe<ModelGrandPrixConnection>;
  getGpBySeasonAndCompId?: Maybe<ModelGrandPrixConnection>;
  getGpCalendarWidget?: Maybe<GpCalendarWidget>;
  getGpCurrentCalendarWidget?: Maybe<GpCurrentCalendarWidget>;
  getGpData?: Maybe<GpData>;
  getGpLiveContainerWidget?: Maybe<GpLiveContainerWidget>;
  getGpLiveHeroWidget?: Maybe<GpLiveHeroWidget>;
  getGpPodiumListWidget?: Maybe<GpPodiumListWidget>;
  getGpResultsContainerWidget?: Maybe<GpResultsContainerWidget>;
  getGpResultsWidget?: Maybe<GpResultsWidget>;
  getGrandPrix?: Maybe<GrandPrix>;
  getLgpHeroStickyWidget?: Maybe<LgpHeroStickyWidget>;
  getLgpHeroWidget?: Maybe<LgpHeroWidget>;
  getLgpPreviewWidget?: Maybe<LgpPreviewWidget>;
  getLgpResultsContainerWidget?: Maybe<LgpResultsContainerWidget>;
  getLgpResultsWidget?: Maybe<LgpResultsWidget>;
  getLiveScoreWidget?: Maybe<LiveScoreWidget>;
  getObjectByKey?: Maybe<Scalars['String']['output']>;
  getSeason?: Maybe<Season>;
  getSeasonRankingGalleryWidget?: Maybe<SeasonRankingGalleryWidget>;
  getSession?: Maybe<Session>;
  getSessionByGpId?: Maybe<ModelSessionConnection>;
  getSessionById?: Maybe<ModelSessionConnection>;
  getSessionBySeasonAndCompId?: Maybe<ModelSessionConnection>;
  getTeam?: Maybe<Team>;
  getTeamById?: Maybe<ModelTeamConnection>;
  getTeamDriverPageWidget?: Maybe<TeamDriverPageWidget>;
  getTeamRankingWidget?: Maybe<TeamRankingWidget>;
  listCardDriverRankingWidgets?: Maybe<ModelCardDriverRankingWidgetConnection>;
  listCardGpCalendarWidgets?: Maybe<ModelCardGpCalendarWidgetConnection>;
  listCardGpResultsWidgets?: Maybe<ModelCardGpResultsWidgetConnection>;
  listCardTeamRankingWidgets?: Maybe<ModelCardTeamRankingWidgetConnection>;
  listCompetitions?: Maybe<ModelCompetitionConnection>;
  listCrossLinks?: Maybe<ModelCrossLinkConnection>;
  listDriverRankingWidgets?: Maybe<ModelDriverRankingWidgetConnection>;
  listDriverStatsWidgets?: Maybe<ModelDriverStatsWidgetConnection>;
  listDrivers?: Maybe<ModelDriverConnection>;
  listEditorialDatas?: Maybe<ModelEditorialDataConnection>;
  listGpCalendarWidgets?: Maybe<ModelGpCalendarWidgetConnection>;
  listGpCurrentCalendarWidgets?: Maybe<ModelGpCurrentCalendarWidgetConnection>;
  listGpDatas?: Maybe<ModelGpDataConnection>;
  listGpLiveContainerWidgets?: Maybe<ModelGpLiveContainerWidgetConnection>;
  listGpLiveHeroWidgets?: Maybe<ModelGpLiveHeroWidgetConnection>;
  listGpPodiumListWidgets?: Maybe<ModelGpPodiumListWidgetConnection>;
  listGpResultsContainerWidgets?: Maybe<ModelGpResultsContainerWidgetConnection>;
  listGpResultsWidgets?: Maybe<ModelGpResultsWidgetConnection>;
  listGrandPrixs?: Maybe<ModelGrandPrixConnection>;
  listLgpHeroStickyWidgets?: Maybe<ModelLgpHeroStickyWidgetConnection>;
  listLgpHeroWidgets?: Maybe<ModelLgpHeroWidgetConnection>;
  listLgpPreviewWidgets?: Maybe<ModelLgpPreviewWidgetConnection>;
  listLgpResultsContainerWidgets?: Maybe<ModelLgpResultsContainerWidgetConnection>;
  listLgpResultsWidgets?: Maybe<ModelLgpResultsWidgetConnection>;
  listLiveScoreWidgets?: Maybe<ModelLiveScoreWidgetConnection>;
  listSeasonRankingGalleryWidgets?: Maybe<ModelSeasonRankingGalleryWidgetConnection>;
  listSeasons?: Maybe<ModelSeasonConnection>;
  listSessions?: Maybe<ModelSessionConnection>;
  listTeamDriverPageWidgets?: Maybe<ModelTeamDriverPageWidgetConnection>;
  listTeamRankingWidgets?: Maybe<ModelTeamRankingWidgetConnection>;
  listTeams?: Maybe<ModelTeamConnection>;
};


export type QuerydirectLambdaArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetCardDriverRankingWidgetArgs = {
  competitionId: Scalars['ID']['input'];
};


export type QuerygetCardGpCalendarWidgetArgs = {
  competitionId: Scalars['ID']['input'];
};


export type QuerygetCardGpResultsWidgetArgs = {
  competitionId: Scalars['ID']['input'];
};


export type QuerygetCardTeamRankingWidgetArgs = {
  competitionId: Scalars['ID']['input'];
};


export type QuerygetCompetitionArgs = {
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetCompetitionByIdArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetCompetitionBySeasonIdArgs = {
  filter?: InputMaybe<ModelCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetCrossLinkArgs = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetCrossLinkByGpIdArgs = {
  filter?: InputMaybe<ModelCrossLinkFilterInput>;
  gpId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetDriverArgs = {
  driverId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetDriverByIdArgs = {
  driverId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelDriverFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetDriverByTeamIdArgs = {
  filter?: InputMaybe<ModelDriverFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  teamId?: InputMaybe<ModelIDKeyConditionInput>;
};


export type QuerygetDriverRankingWidgetArgs = {
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetDriverStatsWidgetArgs = {
  driverId: Scalars['ID']['input'];
};


export type QuerygetEditorialDataArgs = {
  editorialDataId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetEditorialDataByIdArgs = {
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelEditorialDataFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetGpByIdArgs = {
  filter?: InputMaybe<ModelGrandPrixFilterInput>;
  gpId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetGpBySeasonAndCompIdArgs = {
  date?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelGrandPrixFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetGpCalendarWidgetArgs = {
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetGpCurrentCalendarWidgetArgs = {
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetGpDataArgs = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetGpLiveContainerWidgetArgs = {
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetGpLiveHeroWidgetArgs = {
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetGpPodiumListWidgetArgs = {
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetGpResultsContainerWidgetArgs = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetGpResultsWidgetArgs = {
  gpId: Scalars['ID']['input'];
  sessionName: Scalars['String']['input'];
};


export type QuerygetGrandPrixArgs = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetLgpHeroStickyWidgetArgs = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetLgpHeroWidgetArgs = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetLgpPreviewWidgetArgs = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetLgpResultsContainerWidgetArgs = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetLgpResultsWidgetArgs = {
  gpId: Scalars['ID']['input'];
  sessionName: Scalars['String']['input'];
};


export type QuerygetLiveScoreWidgetArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetObjectByKeyArgs = {
  key: Scalars['String']['input'];
};


export type QuerygetSeasonArgs = {
  seasonId: Scalars['ID']['input'];
};


export type QuerygetSeasonRankingGalleryWidgetArgs = {
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetSessionArgs = {
  gpId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};


export type QuerygetSessionByGpIdArgs = {
  date?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSessionFilterInput>;
  gpId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetSessionByIdArgs = {
  filter?: InputMaybe<ModelSessionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetSessionBySeasonAndCompIdArgs = {
  date?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSessionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetTeamArgs = {
  seasonAndCompId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type QuerygetTeamByIdArgs = {
  filter?: InputMaybe<ModelTeamFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<ModelIDKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerygetTeamDriverPageWidgetArgs = {
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetTeamRankingWidgetArgs = {
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerylistCardDriverRankingWidgetsArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelCardDriverRankingWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistCardGpCalendarWidgetsArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelCardGpCalendarWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistCardGpResultsWidgetsArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelCardGpResultsWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistCardTeamRankingWidgetsArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelCardTeamRankingWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistCompetitionsArgs = {
  filter?: InputMaybe<ModelCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistCrossLinksArgs = {
  filter?: InputMaybe<ModelCrossLinkFilterInput>;
  gpId?: InputMaybe<ModelIDKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistDriverRankingWidgetsArgs = {
  filter?: InputMaybe<ModelDriverRankingWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistDriverStatsWidgetsArgs = {
  driverId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelDriverStatsWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistDriversArgs = {
  driverId?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelDriverFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistEditorialDatasArgs = {
  editorialDataId?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelEditorialDataFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistGpCalendarWidgetsArgs = {
  filter?: InputMaybe<ModelGpCalendarWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistGpCurrentCalendarWidgetsArgs = {
  filter?: InputMaybe<ModelGpCurrentCalendarWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistGpDatasArgs = {
  filter?: InputMaybe<ModelGpDataFilterInput>;
  gpId?: InputMaybe<ModelIDKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistGpLiveContainerWidgetsArgs = {
  filter?: InputMaybe<ModelGpLiveContainerWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistGpLiveHeroWidgetsArgs = {
  filter?: InputMaybe<ModelGpLiveHeroWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistGpPodiumListWidgetsArgs = {
  filter?: InputMaybe<ModelGpPodiumListWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistGpResultsContainerWidgetsArgs = {
  filter?: InputMaybe<ModelGpResultsContainerWidgetFilterInput>;
  gpId?: InputMaybe<ModelIDKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistGpResultsWidgetsArgs = {
  filter?: InputMaybe<ModelGpResultsWidgetFilterInput>;
  gpId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sessionName?: InputMaybe<ModelStringKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistGrandPrixsArgs = {
  filter?: InputMaybe<ModelGrandPrixFilterInput>;
  gpId?: InputMaybe<ModelIDKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistLgpHeroStickyWidgetsArgs = {
  filter?: InputMaybe<ModelLgpHeroStickyWidgetFilterInput>;
  gpId?: InputMaybe<ModelIDKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistLgpHeroWidgetsArgs = {
  filter?: InputMaybe<ModelLgpHeroWidgetFilterInput>;
  gpId?: InputMaybe<ModelIDKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistLgpPreviewWidgetsArgs = {
  filter?: InputMaybe<ModelLgpPreviewWidgetFilterInput>;
  gpId?: InputMaybe<ModelIDKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistLgpResultsContainerWidgetsArgs = {
  filter?: InputMaybe<ModelLgpResultsContainerWidgetFilterInput>;
  gpId?: InputMaybe<ModelIDKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistLgpResultsWidgetsArgs = {
  filter?: InputMaybe<ModelLgpResultsWidgetFilterInput>;
  gpId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sessionName?: InputMaybe<ModelStringKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistLiveScoreWidgetsArgs = {
  filter?: InputMaybe<ModelLiveScoreWidgetFilterInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistSeasonRankingGalleryWidgetsArgs = {
  filter?: InputMaybe<ModelSeasonRankingGalleryWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistSeasonsArgs = {
  filter?: InputMaybe<ModelSeasonFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistSessionsArgs = {
  filter?: InputMaybe<ModelSessionFilterInput>;
  gpId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<ModelIDKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistTeamDriverPageWidgetsArgs = {
  filter?: InputMaybe<ModelTeamDriverPageWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistTeamRankingWidgetsArgs = {
  filter?: InputMaybe<ModelTeamRankingWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistTeamsArgs = {
  filter?: InputMaybe<ModelTeamFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  teamId?: InputMaybe<ModelIDKeyConditionInput>;
};

export type S3Object = {
  content?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type Season = {
  __typename?: 'Season';
  competitions?: Maybe<ModelCompetitionConnection>;
  createdAt: Scalars['AWSDateTime']['output'];
  seasonId: Scalars['ID']['output'];
  seasonJson: Scalars['AWSJSON']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type SeasoncompetitionsArgs = {
  filter?: InputMaybe<ModelCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type SeasonDriverRanking = {
  __typename?: 'SeasonDriverRanking';
  driverFirstname?: Maybe<Scalars['String']['output']>;
  driverId: Scalars['ID']['output'];
  driverImageUrl?: Maybe<Scalars['String']['output']>;
  driverPageLink?: Maybe<Scalars['String']['output']>;
  driverSurname?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['ID']['output'];
  teamName?: Maybe<Scalars['String']['output']>;
  teamUrl?: Maybe<Scalars['String']['output']>;
};

export type SeasonDriverRankingInput = {
  driverFirstname?: InputMaybe<Scalars['String']['input']>;
  driverId: Scalars['ID']['input'];
  driverImageUrl?: InputMaybe<Scalars['String']['input']>;
  driverPageLink?: InputMaybe<Scalars['String']['input']>;
  driverSurname?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['ID']['input'];
  teamName?: InputMaybe<Scalars['String']['input']>;
  teamUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SeasonRankingGalleryWidget = {
  __typename?: 'SeasonRankingGalleryWidget';
  competitionId: Scalars['ID']['output'];
  competitionName?: Maybe<Scalars['String']['output']>;
  competitionsSlugName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  drivers?: Maybe<Array<Maybe<SeasonDriverRanking>>>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  teams?: Maybe<Array<Maybe<SeasonTeamRanking>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type SeasonTeamRanking = {
  __typename?: 'SeasonTeamRanking';
  logoUrl?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['ID']['output'];
  teamImageUrl?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  teamUrl?: Maybe<Scalars['String']['output']>;
};

export type SeasonTeamRankingInput = {
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['ID']['input'];
  teamImageUrl?: InputMaybe<Scalars['String']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  teamUrl?: InputMaybe<Scalars['String']['input']>;
};

export type Session = {
  __typename?: 'Session';
  createdAt: Scalars['AWSDateTime']['output'];
  date?: Maybe<Scalars['AWSDateTime']['output']>;
  gpId: Scalars['ID']['output'];
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  seasonAndCompId: Scalars['ID']['output'];
  sessionId: Scalars['ID']['output'];
  sessionJson?: Maybe<Scalars['AWSJSON']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  onCreateCardDriverRankingWidget?: Maybe<CardDriverRankingWidget>;
  onCreateCardGpCalendarWidget?: Maybe<CardGpCalendarWidget>;
  onCreateCardGpResultsWidget?: Maybe<CardGpResultsWidget>;
  onCreateCardTeamRankingWidget?: Maybe<CardTeamRankingWidget>;
  onCreateCompetition?: Maybe<Competition>;
  onCreateCrossLink?: Maybe<CrossLink>;
  onCreateDriver?: Maybe<Driver>;
  onCreateDriverRankingWidget?: Maybe<DriverRankingWidget>;
  onCreateDriverStatsWidget?: Maybe<DriverStatsWidget>;
  onCreateEditorialData?: Maybe<EditorialData>;
  onCreateGpCalendarWidget?: Maybe<GpCalendarWidget>;
  onCreateGpCurrentCalendarWidget?: Maybe<GpCurrentCalendarWidget>;
  onCreateGpData?: Maybe<GpData>;
  onCreateGpLiveContainerWidget?: Maybe<GpLiveContainerWidget>;
  onCreateGpLiveHeroWidget?: Maybe<GpLiveHeroWidget>;
  onCreateGpPodiumListWidget?: Maybe<GpPodiumListWidget>;
  onCreateGpResultsContainerWidget?: Maybe<GpResultsContainerWidget>;
  onCreateGpResultsWidget?: Maybe<GpResultsWidget>;
  onCreateGrandPrix?: Maybe<GrandPrix>;
  onCreateLgpHeroStickyWidget?: Maybe<LgpHeroStickyWidget>;
  onCreateLgpHeroWidget?: Maybe<LgpHeroWidget>;
  onCreateLgpPreviewWidget?: Maybe<LgpPreviewWidget>;
  onCreateLgpResultsContainerWidget?: Maybe<LgpResultsContainerWidget>;
  onCreateLgpResultsWidget?: Maybe<LgpResultsWidget>;
  onCreateLiveScoreWidget?: Maybe<LiveScoreWidget>;
  onCreateSeason?: Maybe<Season>;
  onCreateSeasonRankingGalleryWidget?: Maybe<SeasonRankingGalleryWidget>;
  onCreateSession?: Maybe<Session>;
  onCreateTeam?: Maybe<Team>;
  onCreateTeamDriverPageWidget?: Maybe<TeamDriverPageWidget>;
  onCreateTeamRankingWidget?: Maybe<TeamRankingWidget>;
  onDeleteCardDriverRankingWidget?: Maybe<CardDriverRankingWidget>;
  onDeleteCardGpCalendarWidget?: Maybe<CardGpCalendarWidget>;
  onDeleteCardGpResultsWidget?: Maybe<CardGpResultsWidget>;
  onDeleteCardTeamRankingWidget?: Maybe<CardTeamRankingWidget>;
  onDeleteCompetition?: Maybe<Competition>;
  onDeleteCrossLink?: Maybe<CrossLink>;
  onDeleteDriver?: Maybe<Driver>;
  onDeleteDriverRankingWidget?: Maybe<DriverRankingWidget>;
  onDeleteDriverStatsWidget?: Maybe<DriverStatsWidget>;
  onDeleteEditorialData?: Maybe<EditorialData>;
  onDeleteGpCalendarWidget?: Maybe<GpCalendarWidget>;
  onDeleteGpCurrentCalendarWidget?: Maybe<GpCurrentCalendarWidget>;
  onDeleteGpData?: Maybe<GpData>;
  onDeleteGpLiveContainerWidget?: Maybe<GpLiveContainerWidget>;
  onDeleteGpLiveHeroWidget?: Maybe<GpLiveHeroWidget>;
  onDeleteGpPodiumListWidget?: Maybe<GpPodiumListWidget>;
  onDeleteGpResultsContainerWidget?: Maybe<GpResultsContainerWidget>;
  onDeleteGpResultsWidget?: Maybe<GpResultsWidget>;
  onDeleteGrandPrix?: Maybe<GrandPrix>;
  onDeleteLgpHeroStickyWidget?: Maybe<LgpHeroStickyWidget>;
  onDeleteLgpHeroWidget?: Maybe<LgpHeroWidget>;
  onDeleteLgpPreviewWidget?: Maybe<LgpPreviewWidget>;
  onDeleteLgpResultsContainerWidget?: Maybe<LgpResultsContainerWidget>;
  onDeleteLgpResultsWidget?: Maybe<LgpResultsWidget>;
  onDeleteLiveScoreWidget?: Maybe<LiveScoreWidget>;
  onDeleteSeason?: Maybe<Season>;
  onDeleteSeasonRankingGalleryWidget?: Maybe<SeasonRankingGalleryWidget>;
  onDeleteSession?: Maybe<Session>;
  onDeleteTeam?: Maybe<Team>;
  onDeleteTeamDriverPageWidget?: Maybe<TeamDriverPageWidget>;
  onDeleteTeamRankingWidget?: Maybe<TeamRankingWidget>;
  onUpdateCardDriverRankingWidget?: Maybe<CardDriverRankingWidget>;
  onUpdateCardGpCalendarWidget?: Maybe<CardGpCalendarWidget>;
  onUpdateCardGpResultsWidget?: Maybe<CardGpResultsWidget>;
  onUpdateCardTeamRankingWidget?: Maybe<CardTeamRankingWidget>;
  onUpdateCompetition?: Maybe<Competition>;
  onUpdateCrossLink?: Maybe<CrossLink>;
  onUpdateDriver?: Maybe<Driver>;
  onUpdateDriverRankingWidget?: Maybe<DriverRankingWidget>;
  onUpdateDriverStatsWidget?: Maybe<DriverStatsWidget>;
  onUpdateEditorialData?: Maybe<EditorialData>;
  onUpdateGpCalendarWidget?: Maybe<GpCalendarWidget>;
  onUpdateGpCurrentCalendarWidget?: Maybe<GpCurrentCalendarWidget>;
  onUpdateGpData?: Maybe<GpData>;
  onUpdateGpLiveContainerWidget?: Maybe<GpLiveContainerWidget>;
  onUpdateGpLiveHeroWidget?: Maybe<GpLiveHeroWidget>;
  onUpdateGpPodiumListWidget?: Maybe<GpPodiumListWidget>;
  onUpdateGpResultsContainerWidget?: Maybe<GpResultsContainerWidget>;
  onUpdateGpResultsWidget?: Maybe<GpResultsWidget>;
  onUpdateGpResultsWidgetByGpIdAndSessionName?: Maybe<GpResultsWidget>;
  onUpdateGrandPrix?: Maybe<GrandPrix>;
  onUpdateLgpHeroStickyBySeasonAndCompIdAndGpId?: Maybe<LgpHeroStickyWidget>;
  onUpdateLgpHeroStickyWidget?: Maybe<LgpHeroStickyWidget>;
  onUpdateLgpHeroWidget?: Maybe<LgpHeroWidget>;
  onUpdateLgpHeroWidgetBySeasonAndCompIdAndGpId?: Maybe<LgpHeroWidget>;
  onUpdateLgpPreviewWidget?: Maybe<LgpPreviewWidget>;
  onUpdateLgpPreviewWidgetBySeasonAndCompIdAndGpId?: Maybe<LgpPreviewWidget>;
  onUpdateLgpResContainerBySeasonAndCompIdAndGpId?: Maybe<LgpResultsContainerWidget>;
  onUpdateLgpResultsContainerWidget?: Maybe<LgpResultsContainerWidget>;
  onUpdateLgpResultsWidget?: Maybe<LgpResultsWidget>;
  onUpdateLgpResultsWidgetByGpIdAndSessionName?: Maybe<LgpResultsWidget>;
  onUpdateLiveScoreWidget?: Maybe<LiveScoreWidget>;
  onUpdateLiveScoreWidgetById?: Maybe<LiveScoreWidget>;
  onUpdateSeason?: Maybe<Season>;
  onUpdateSeasonRankingGalleryWidget?: Maybe<SeasonRankingGalleryWidget>;
  onUpdateSession?: Maybe<Session>;
  onUpdateTeam?: Maybe<Team>;
  onUpdateTeamDriverPageWidget?: Maybe<TeamDriverPageWidget>;
  onUpdateTeamRankingWidget?: Maybe<TeamRankingWidget>;
};


export type SubscriptiononUpdateGpResultsWidgetByGpIdAndSessionNameArgs = {
  gpId: Scalars['ID']['input'];
  sessionName: Scalars['String']['input'];
};


export type SubscriptiononUpdateLgpHeroStickyBySeasonAndCompIdAndGpIdArgs = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type SubscriptiononUpdateLgpHeroWidgetBySeasonAndCompIdAndGpIdArgs = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type SubscriptiononUpdateLgpPreviewWidgetBySeasonAndCompIdAndGpIdArgs = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type SubscriptiononUpdateLgpResContainerBySeasonAndCompIdAndGpIdArgs = {
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type SubscriptiononUpdateLgpResultsWidgetByGpIdAndSessionNameArgs = {
  gpId: Scalars['ID']['input'];
  sessionName: Scalars['String']['input'];
};


export type SubscriptiononUpdateLiveScoreWidgetByIdArgs = {
  id: Scalars['ID']['input'];
};

export type Team = {
  __typename?: 'Team';
  competition?: Maybe<Competition>;
  createdAt: Scalars['AWSDateTime']['output'];
  drivers?: Maybe<ModelDriverConnection>;
  editorialData?: Maybe<EditorialData>;
  editorialDataId: Scalars['ID']['output'];
  seasonAndCompId: Scalars['ID']['output'];
  teamId: Scalars['ID']['output'];
  teamJson: Scalars['AWSJSON']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type TeamdriversArgs = {
  filter?: InputMaybe<ModelDriverFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type TeamDriverDriver = {
  __typename?: 'TeamDriverDriver';
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type TeamDriverDriverInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type TeamDriverPageWidget = {
  __typename?: 'TeamDriverPageWidget';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  teamList?: Maybe<Array<Maybe<TeamDriverTeam>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type TeamDriverTeam = {
  __typename?: 'TeamDriverTeam';
  drivers?: Maybe<Array<Maybe<TeamDriverDriver>>>;
  position?: Maybe<Scalars['Int']['output']>;
  teamLogoUrl?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  teamUrl?: Maybe<Scalars['String']['output']>;
};

export type TeamDriverTeamInput = {
  drivers?: InputMaybe<Array<InputMaybe<TeamDriverDriverInput>>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  teamLogoUrl?: InputMaybe<Scalars['String']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  teamUrl?: InputMaybe<Scalars['String']['input']>;
};

export type TeamRankingTeam = {
  __typename?: 'TeamRankingTeam';
  customTeamPageUrl?: Maybe<Scalars['String']['output']>;
  pos?: Maybe<Scalars['String']['output']>;
  pts?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
};

export type TeamRankingTeamInput = {
  customTeamPageUrl?: InputMaybe<Scalars['String']['input']>;
  pos?: InputMaybe<Scalars['String']['input']>;
  pts?: InputMaybe<Scalars['String']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
};

export type TeamRankingWidget = {
  __typename?: 'TeamRankingWidget';
  competitionId: Scalars['ID']['output'];
  competitionLabel?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  items?: Maybe<Array<Maybe<TeamRankingTeam>>>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type UpdateCardDriverRankingWidgetInput = {
  competitionId: Scalars['ID']['input'];
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  drivers?: InputMaybe<Array<InputMaybe<CardDriverRankingDriverInfoInput>>>;
  rankingLink?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCardGpCalendarWidgetInput = {
  calendarLink?: InputMaybe<Scalars['String']['input']>;
  competitionId: Scalars['ID']['input'];
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  gpList?: InputMaybe<Array<InputMaybe<CardGpCalendarGpInfoInput>>>;
};

export type UpdateCardGpResultsWidgetInput = {
  competitionId: Scalars['ID']['input'];
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  customGpName?: InputMaybe<Scalars['String']['input']>;
  isSprint?: InputMaybe<Scalars['Boolean']['input']>;
  results?: InputMaybe<Array<InputMaybe<CardGpResultsResultInfoInput>>>;
  resultsLink?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCardTeamRankingWidgetInput = {
  competitionId: Scalars['ID']['input'];
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  rankingLink?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<InputMaybe<CardTeamRankingTeamInfoInput>>>;
};

export type UpdateCompetitionInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  competitionJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  previousSeasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCrossLinkInput = {
  crossLinkJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type UpdateDriverInput = {
  driverId: Scalars['ID']['input'];
  driverJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDriverRankingWidgetInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  competitionLabel?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<DriverRankingDriverInput>>>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDriverStatsWidgetInput = {
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  customSeasonName?: InputMaybe<Scalars['String']['input']>;
  driverId: Scalars['ID']['input'];
  seasonAndCompId?: InputMaybe<Scalars['String']['input']>;
  statistics?: InputMaybe<Array<InputMaybe<DriverStatInput>>>;
};

export type UpdateEditorialDataInput = {
  editorialDataId: Scalars['ID']['input'];
  editorialJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
};

export type UpdateGpCalendarWidgetInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<InputMaybe<GpCalendarItemInput>>>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateGpCurrentCalendarWidgetInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<InputMaybe<GpCalendarItemInput>>>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateGpDataInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  data?: InputMaybe<Scalars['AWSJSON']['input']>;
  gpId: Scalars['ID']['input'];
  messageType?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateGpLiveContainerWidgetInput = {
  DS?: InputMaybe<GpLiveContainerWrapperInput>;
  G?: InputMaybe<GpLiveContainerWrapperInput>;
  R?: InputMaybe<GpLiveContainerWrapperInput>;
  TS?: InputMaybe<GpLiveContainerWrapperInput>;
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateGpLiveHeroWidgetInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  gpInfo?: InputMaybe<GpLiveHeroGpInfoInput>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateGpPodiumListWidgetInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  grandPrixList?: InputMaybe<Array<InputMaybe<GpPodiumListGrandPrixInput>>>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateGpResultsContainerWidgetInput = {
  FP1?: InputMaybe<GpResultsContainerWrapperInput>;
  FP2?: InputMaybe<GpResultsContainerWrapperInput>;
  FP3?: InputMaybe<GpResultsContainerWrapperInput>;
  FP4?: InputMaybe<GpResultsContainerWrapperInput>;
  G?: InputMaybe<GpResultsContainerWrapperInput>;
  GS?: InputMaybe<GpResultsContainerWrapperInput>;
  Q?: InputMaybe<GpResultsContainerWrapperInput>;
  QS?: InputMaybe<GpResultsContainerWrapperInput>;
  R?: InputMaybe<GpResultsContainerWrapperInput>;
  SPRINT?: InputMaybe<GpResultsContainerWrapperInput>;
  SS?: InputMaybe<GpResultsContainerWrapperInput>;
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateGpResultsWidgetInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  gpId: Scalars['ID']['input'];
  gpInfo?: InputMaybe<GpResultsGpInfoInput>;
  gpStatus?: InputMaybe<Scalars['String']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sessionName: Scalars['String']['input'];
  sessions?: InputMaybe<Array<InputMaybe<GpResultsSessionInput>>>;
};

export type UpdateGrandPrixInput = {
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  gpId: Scalars['ID']['input'];
  gpJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLgpHeroStickyWidgetInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  gpId: Scalars['ID']['input'];
  info?: InputMaybe<LgpHeroStickyInfoInput>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  session?: InputMaybe<LgpHeroStickySessionInput>;
};

export type UpdateLgpHeroWidgetInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  gpId: Scalars['ID']['input'];
  info?: InputMaybe<LgpHeroInfoInput>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  session?: InputMaybe<LgpHeroSessionInput>;
};

export type UpdateLgpPreviewWidgetInput = {
  calendar?: InputMaybe<LgpInfoLinkInput>;
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  gpId: Scalars['ID']['input'];
  gpName?: InputMaybe<Scalars['String']['input']>;
  gpStartDateTime?: InputMaybe<Scalars['String']['input']>;
  laps?: InputMaybe<Scalars['String']['input']>;
  lengthKm?: InputMaybe<Scalars['String']['input']>;
  news?: InputMaybe<LgpInfoLinkInput>;
  ranking?: InputMaybe<LgpInfoLinkInput>;
  results?: InputMaybe<LgpInfoLinkInput>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sessions?: InputMaybe<Array<InputMaybe<LgpPreviewSessionInput>>>;
  sportLabel?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLgpResultsContainerWidgetInput = {
  FP1?: InputMaybe<LgpResultsContainerWrapperInput>;
  FP2?: InputMaybe<LgpResultsContainerWrapperInput>;
  FP3?: InputMaybe<LgpResultsContainerWrapperInput>;
  FP4?: InputMaybe<LgpResultsContainerWrapperInput>;
  G?: InputMaybe<LgpResultsContainerWrapperInput>;
  GS?: InputMaybe<LgpResultsContainerWrapperInput>;
  Q?: InputMaybe<LgpResultsContainerWrapperInput>;
  QS?: InputMaybe<LgpResultsContainerWrapperInput>;
  R?: InputMaybe<LgpResultsContainerWrapperInput>;
  SPRINT?: InputMaybe<LgpResultsContainerWrapperInput>;
  SS?: InputMaybe<LgpResultsContainerWrapperInput>;
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateLgpResultsWidgetInput = {
  calendar?: InputMaybe<LgpInfoLinkInput>;
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  gpId: Scalars['ID']['input'];
  gpInfo?: InputMaybe<LgpResultsGpInfoInput>;
  gpStatus?: InputMaybe<Scalars['String']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  ranking?: InputMaybe<LgpInfoLinkInput>;
  results?: InputMaybe<LgpInfoLinkInput>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sessionName: Scalars['String']['input'];
  sessions?: InputMaybe<Array<InputMaybe<LgpResultsSessionInput>>>;
};

export type UpdateLiveScoreWidgetInput = {
  currentDay?: InputMaybe<Array<InputMaybe<LiveScoreWidgetDayInput>>>;
  id: Scalars['ID']['input'];
  nextDay?: InputMaybe<Array<InputMaybe<LiveScoreWidgetDayInput>>>;
  previousDay?: InputMaybe<Array<InputMaybe<LiveScoreWidgetDayInput>>>;
};

export type UpdateSeasonInput = {
  seasonId: Scalars['ID']['input'];
  seasonJson?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type UpdateSeasonRankingGalleryWidgetInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  competitionName?: InputMaybe<Scalars['String']['input']>;
  competitionsSlugName?: InputMaybe<Scalars['String']['input']>;
  drivers?: InputMaybe<Array<InputMaybe<SeasonDriverRankingInput>>>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  teams?: InputMaybe<Array<InputMaybe<SeasonTeamRankingInput>>>;
};

export type UpdateSessionInput = {
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  gpId: Scalars['ID']['input'];
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sessionId: Scalars['ID']['input'];
  sessionJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamDriverPageWidgetInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  teamList?: InputMaybe<Array<InputMaybe<TeamDriverTeamInput>>>;
};

export type UpdateTeamInput = {
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  teamJson?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type UpdateTeamRankingWidgetInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  competitionLabel?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<TeamRankingTeamInput>>>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetCardDriverRankingWidgetQueryVariables = Exact<{
  competitionId: Scalars['ID']['input'];
}>;


export type GetCardDriverRankingWidgetQuery = { __typename?: 'Query', getCardDriverRankingWidget?: { __typename?: 'CardDriverRankingWidget', competitionId: string, customCompetitionName?: string | null, rankingLink?: string | null, drivers?: Array<{ __typename?: 'CardDriverRankingDriverInfo', customDriverName?: string | null, customDriverPageUrl?: string | null, customDriverSurname?: string | null, flagUrl?: string | null, pos?: string | null, pts?: string | null } | null> | null } | null };

export type GetCardGpCalendarWidgetQueryVariables = Exact<{
  competitionId: Scalars['ID']['input'];
}>;


export type GetCardGpCalendarWidgetQuery = { __typename?: 'Query', getCardGpCalendarWidget?: { __typename?: 'CardGpCalendarWidget', competitionId: string, customCompetitionName?: string | null, calendarLink?: string | null, gpList?: Array<{ __typename?: 'CardGpCalendarGpInfo', customGpName?: string | null, flagUrl?: string | null, isExclusive?: boolean | null, startDateTime?: string | null, endDateTime?: string | null, lgpPreviewUrl?: string | null } | null> | null } | null };

export type GetCardGpResultsQueryVariables = Exact<{
  competitionId: Scalars['ID']['input'];
}>;


export type GetCardGpResultsQuery = { __typename?: 'Query', getCardGpResultsWidget?: { __typename?: 'CardGpResultsWidget', competitionId: string, customCompetitionName?: string | null, customGpName?: string | null, resultsLink?: string | null, isSprint?: boolean | null, results?: Array<{ __typename?: 'CardGpResultsResultInfo', customDriverName?: string | null, customDriverPageUrl?: string | null, customDriverSurname?: string | null, flagUrl?: string | null, gap?: string | null, pos?: string | null, timing?: { __typename?: 'CardGpResultsResultInfoTiming', timeSeconds?: string | null, timeMilliseconds?: string | null, timeHours?: string | null, timeMinutes?: string | null } | null } | null> | null } | null };

export type GetCardTeamRankingWidgetQueryVariables = Exact<{
  competitionId: Scalars['ID']['input'];
}>;


export type GetCardTeamRankingWidgetQuery = { __typename?: 'Query', getCardTeamRankingWidget?: { __typename?: 'CardTeamRankingWidget', competitionId: string, customCompetitionName?: string | null, rankingLink?: string | null, teams?: Array<{ __typename?: 'CardTeamRankingTeamInfo', customTeamName?: string | null, customTeamPageUrl?: string | null, logoUrl?: string | null, pos?: string | null, pts?: string | null } | null> | null } | null };

export type CompetitionCalendarWidgetQueryVariables = Exact<{
  seasonAndCompId: Scalars['ID']['input'];
}>;


export type CompetitionCalendarWidgetQuery = { __typename?: 'Query', getGpCalendarWidget?: { __typename?: 'GpCalendarWidget', seasonAndCompId: string, seasonId: string, competitionId: string, items?: Array<{ __typename?: 'GpCalendarItem', gpInfo?: { __typename?: 'GpCalendarGpInfo', circuitUrl?: string | null, customGpName?: string | null, flagUrl?: string | null, gpPageUrl?: string | null, gpStatus?: string | null, isCurrent?: boolean | null, isExclusive?: boolean | null, isSprint?: boolean | null, lapRecord?: string | null, laps?: string | null, lengthKm?: string | null, startDateTime?: string | null } | null, sessions?: { __typename?: 'GpCalendarItemSessions', items?: Array<{ __typename?: 'GpCalendarSession', sessionLabel?: string | null, sessionStatus?: string | null, sessionResultUrl?: string | null, sessionInfo?: { __typename?: 'GpCalendarSessionInfo', isCurrent?: boolean | null, sessionLabel?: string | null, sessionName?: string | null, sessionStatus?: string | null, startDateTime?: string | null } | null } | null> | null } | null } | null> | null } | null };

export type CurrentCalendarWidgetQueryVariables = Exact<{
  seasonAndCompId: Scalars['ID']['input'];
}>;


export type CurrentCalendarWidgetQuery = { __typename?: 'Query', getGpCurrentCalendarWidget?: { __typename?: 'GpCurrentCalendarWidget', seasonAndCompId: string, seasonId: string, competitionId: string, items?: Array<{ __typename?: 'GpCalendarItem', gpInfo?: { __typename?: 'GpCalendarGpInfo', circuitUrl?: string | null, customGpName?: string | null, flagUrl?: string | null, gpPageUrl?: string | null, gpStatus?: string | null, isCurrent?: boolean | null, isExclusive?: boolean | null, isSprint?: boolean | null, lapRecord?: string | null, laps?: string | null, lengthKm?: string | null, startDateTime?: string | null } | null, sessions?: { __typename?: 'GpCalendarItemSessions', items?: Array<{ __typename?: 'GpCalendarSession', sessionLabel?: string | null, sessionStatus?: string | null, sessionResultUrl?: string | null, sessionInfo?: { __typename?: 'GpCalendarSessionInfo', isCurrent?: boolean | null, sessionLabel?: string | null, sessionName?: string | null, sessionStatus?: string | null, startDateTime?: string | null } | null } | null> | null } | null } | null> | null } | null };

export type GetDriverRankingWidgetQueryVariables = Exact<{
  seasonAndCompId: Scalars['ID']['input'];
}>;


export type GetDriverRankingWidgetQuery = { __typename?: 'Query', getDriverRankingWidget?: { __typename?: 'DriverRankingWidget', seasonAndCompId: string, seasonId: string, competitionId: string, competitionLabel?: string | null, items?: Array<{ __typename?: 'DriverRankingDriver', driverInfo?: { __typename?: 'DriverRankingDriverInfo', customDriverName?: string | null, customDriverPageUrl?: string | null, customDriverSurname?: string | null, customTeamName?: string | null, customTeamPageUrl?: string | null, firstName?: string | null, flagUrl?: string | null, lastName?: string | null, nationality?: string | null, pos?: string | null, pts?: string | null } | null } | null> | null } | null };

export type GetDriverStatsWidgetQueryVariables = Exact<{
  driverId: Scalars['ID']['input'];
}>;


export type GetDriverStatsWidgetQuery = { __typename?: 'Query', getDriverStatsWidget?: { __typename?: 'DriverStatsWidget', driverId: string, seasonAndCompId?: string | null, customSeasonName?: string | null, customCompetitionName?: string | null, statistics?: Array<{ __typename?: 'DriverStat', type?: string | null, value?: number | null } | null> | null } | null };

export type GetLgpHeroStickyWidgetQueryVariables = Exact<{
  seasonAndCompId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
}>;


export type GetLgpHeroStickyWidgetQuery = { __typename?: 'Query', getLgpHeroStickyWidget?: { __typename?: 'LgpHeroStickyWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, info?: { __typename?: 'LgpHeroStickyInfo', flagImgUrl?: string | null, customGpName?: string | null, startDate?: string | null, endDate?: string | null } | null, session?: { __typename?: 'LgpHeroStickySession', status?: string | null, name?: string | null, label?: string | null } | null } | null };

export type GetLgpHeroWidgetQueryVariables = Exact<{
  seasonAndCompId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
}>;


export type GetLgpHeroWidgetQuery = { __typename?: 'Query', getLgpHeroWidget?: { __typename?: 'LgpHeroWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, info?: { __typename?: 'LgpHeroInfo', flagImgUrl?: string | null, circuitImgUrl?: string | null, customGpName?: string | null, startDate?: string | null, endDate?: string | null, sportTag?: string | null } | null, session?: { __typename?: 'LgpHeroSession', status?: string | null, name?: string | null, label?: string | null, podium?: Array<{ __typename?: 'LgpHeroPodium', customDriverName?: string | null, customDriverSurname?: string | null, customDriverShortName?: string | null, flagImgUrl?: string | null, driverImgUrl?: string | null, position?: number | null }> | null } | null } | null };

export type GetLgpPreviewWidgetQueryVariables = Exact<{
  seasonAndCompId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
}>;


export type GetLgpPreviewWidgetQuery = { __typename?: 'Query', getLgpPreviewWidget?: { __typename?: 'LgpPreviewWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, gpStartDateTime?: string | null, gpName?: string | null, laps?: string | null, lengthKm?: string | null, sportLabel?: string | null, sessions?: Array<{ __typename?: 'LgpPreviewSession', sessionName?: string | null, date?: string | null } | null> | null, calendar?: { __typename?: 'LgpInfoLink', link?: string | null, text?: string | null } | null, ranking?: { __typename?: 'LgpInfoLink', link?: string | null, text?: string | null } | null, results?: { __typename?: 'LgpInfoLink', link?: string | null, text?: string | null } | null, news?: { __typename?: 'LgpInfoLink', link?: string | null, text?: string | null } | null } | null };

export type GetLgpResultsContainerWidgetQueryVariables = Exact<{
  seasonAndCompId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
}>;


export type GetLgpResultsContainerWidgetQuery = { __typename?: 'Query', getLgpResultsContainerWidget?: { __typename?: 'LgpResultsContainerWidget', gpId: string, seasonAndCompId: string, seasonId: string, competitionId: string, FP1?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, FP2?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, FP3?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, FP4?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, G?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, GS?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, Q?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, QS?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, R?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, SPRINT?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, SS?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null } | null };

export type GetLgpResultsWidgetQueryVariables = Exact<{
  gpId: Scalars['ID']['input'];
  sessionName: Scalars['String']['input'];
}>;


export type GetLgpResultsWidgetQuery = { __typename?: 'Query', getLgpResultsWidget?: { __typename?: 'LgpResultsWidget', gpId: string, gpStatus?: string | null, isCurrent?: boolean | null, seasonAndCompId: string, sessionName: string, seasonId: string, competitionId: string, calendar?: { __typename?: 'LgpInfoLink', link?: string | null, text?: string | null } | null, ranking?: { __typename?: 'LgpInfoLink', link?: string | null, text?: string | null } | null, results?: { __typename?: 'LgpInfoLink', link?: string | null, text?: string | null } | null, gpInfo?: { __typename?: 'LgpResultsGpInfo', customGpName?: string | null, gpStatus?: string | null, isCurrent?: boolean | null, isExclusive?: boolean | null, isSprint?: boolean | null, lapRecord?: string | null, laps?: string | null, lengthKm?: string | null, startDateTime?: string | null } | null, sessions?: Array<{ __typename?: 'LgpResultsSession', isCurrent?: boolean | null, sessionInfo?: { __typename?: 'LgpResultsSessionInfo', isCurrent?: boolean | null, sessionLabel?: string | null, sessionName?: string | null, sessionStatus?: string | null, startDateTime?: string | null, details?: Array<{ __typename?: 'LgpResultsSessionInfoDetails', customDriverName?: string | null, customDriverPageUrl?: string | null, customDriverSurname?: string | null, customTeamName?: string | null, customTeamPageUrl?: string | null, fastestLap?: string | null, flagUrl?: string | null, gap?: string | null, isFastestLap?: boolean | null, laps?: string | null, position?: string | null, status?: string | null, timing?: { __typename?: 'LgpResultsSessionInfoDetailsTiming', timeHours?: string | null, timeMilliseconds?: string | null, timeMinutes?: string | null, timeSeconds?: string | null } | null } | null> | null } | null } | null> | null } | null };

export type GetLiveScoreWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLiveScoreWidgetQuery = { __typename?: 'Query', getLiveScoreWidget?: { __typename?: 'LiveScoreWidget', id: string, previousDay?: Array<{ __typename?: 'LiveScoreWidgetDay', sportTag?: string | null, gpInfo?: { __typename?: 'LiveScoreWidgetGpInfo', calendarUrl?: string | null, customGpName?: string | null, gpPageUrl?: string | null, rankingUrl?: string | null, gpFlag?: string | null, gpCrosslink?: string | null } | null, sessions?: Array<{ __typename?: 'LiveScoreWidgetSession', sessionDate?: string | null, sessionName?: string | null, sessionStatus?: string | null, resultsUrl?: string | null, results?: Array<{ __typename?: 'LiveScoreWidgetResults', customDriverName?: string | null, customDriverPageUrl?: string | null, customDriverSurname?: string | null, customTeamName?: string | null, customTeamPageUrl?: string | null, fastestLap?: string | null, firstName?: string | null, flagUrl?: string | null, gap?: string | null, isFastestLap?: boolean | null, lastName?: string | null, position?: string | null, teamName?: string | null, timing?: { __typename?: 'LiveScoreWidgetResultsTiming', timeHours?: string | null, timeMilliseconds?: string | null, timeMinutes?: string | null, timeSeconds?: string | null } | null } | null> | null } | null> | null } | null> | null, currentDay?: Array<{ __typename?: 'LiveScoreWidgetDay', sportTag?: string | null, gpInfo?: { __typename?: 'LiveScoreWidgetGpInfo', calendarUrl?: string | null, customGpName?: string | null, gpPageUrl?: string | null, rankingUrl?: string | null, gpFlag?: string | null, gpCrosslink?: string | null } | null, sessions?: Array<{ __typename?: 'LiveScoreWidgetSession', sessionDate?: string | null, sessionName?: string | null, sessionStatus?: string | null, resultsUrl?: string | null, results?: Array<{ __typename?: 'LiveScoreWidgetResults', customDriverName?: string | null, customDriverPageUrl?: string | null, customDriverSurname?: string | null, customTeamName?: string | null, customTeamPageUrl?: string | null, fastestLap?: string | null, firstName?: string | null, flagUrl?: string | null, gap?: string | null, isFastestLap?: boolean | null, lastName?: string | null, position?: string | null, teamName?: string | null, timing?: { __typename?: 'LiveScoreWidgetResultsTiming', timeHours?: string | null, timeMilliseconds?: string | null, timeMinutes?: string | null, timeSeconds?: string | null } | null } | null> | null } | null> | null } | null> | null, nextDay?: Array<{ __typename?: 'LiveScoreWidgetDay', sportTag?: string | null, gpInfo?: { __typename?: 'LiveScoreWidgetGpInfo', calendarUrl?: string | null, customGpName?: string | null, gpPageUrl?: string | null, rankingUrl?: string | null, gpFlag?: string | null, gpCrosslink?: string | null } | null, sessions?: Array<{ __typename?: 'LiveScoreWidgetSession', sessionDate?: string | null, sessionName?: string | null, sessionStatus?: string | null, resultsUrl?: string | null, results?: Array<{ __typename?: 'LiveScoreWidgetResults', customDriverName?: string | null, customDriverPageUrl?: string | null, customDriverSurname?: string | null, customTeamName?: string | null, customTeamPageUrl?: string | null, fastestLap?: string | null, firstName?: string | null, flagUrl?: string | null, gap?: string | null, isFastestLap?: boolean | null, lastName?: string | null, position?: string | null, teamName?: string | null, timing?: { __typename?: 'LiveScoreWidgetResultsTiming', timeHours?: string | null, timeMilliseconds?: string | null, timeMinutes?: string | null, timeSeconds?: string | null } | null } | null> | null } | null> | null } | null> | null } | null };

export type GetGpPodiumListWidgetQueryVariables = Exact<{
  seasonAndCompId: Scalars['ID']['input'];
}>;


export type GetGpPodiumListWidgetQuery = { __typename?: 'Query', getGpPodiumListWidget?: { __typename?: 'GpPodiumListWidget', competitionId: string, seasonAndCompId: string, seasonId: string, grandPrixList?: Array<{ __typename?: 'GpPodiumListGrandPrix', gpStatus?: string | null, isCurrent?: boolean | null, gpInfo?: { __typename?: 'GpPodiumListGpInfo', customGpName?: string | null, gpPageUrl?: string | null, gpStatus?: string | null, isCurrent?: boolean | null, isExclusive?: boolean | null, isSprint?: boolean | null, lapRecord?: string | null, laps?: string | null, lengthKm?: string | null, startDateTime?: string | null, gpCrosslink?: string | null } | null, session?: { __typename?: 'GpPodiumListSession', isCurrent?: boolean | null, sessionLabel?: string | null, sessionStatus?: string | null, sessionInfo?: { __typename?: 'GpPodiumListSessionInfo', isCurrent?: boolean | null, sessionLabel?: string | null, sessionName?: string | null, sessionStatus?: string | null, startDateTime?: string | null, details?: Array<{ __typename?: 'GpPodiumListSessionInfoDetails', customDriverName?: string | null, customDriverSurname?: string | null, customDriverPageUrl?: string | null, customTeamName?: string | null, customTeamPageUrl?: string | null, fastestLap?: string | null, firstName?: string | null, flagUrl?: string | null, gap?: string | null, isFastestLap?: boolean | null, laps?: string | null, lastName?: string | null, position?: string | null, status?: string | null, points?: { __typename?: 'GpPodiumListSessionInfoDetailsPoints', personPoints?: string | null, teamPoints?: string | null } | null, team?: { __typename?: 'GpPodiumListSessionInfoDetailsTeam', name?: string | null } | null, timing?: { __typename?: 'GpPodiumListSessionInfoDetailsTiming', timeHours?: string | null, timeMilliseconds?: string | null, timeMinutes?: string | null, timeSeconds?: string | null } | null } | null> | null } | null } | null } | null> | null } | null };

export type GetSeasonRankingGalleryWidgetQueryVariables = Exact<{
  seasonAndCompId: Scalars['ID']['input'];
}>;


export type GetSeasonRankingGalleryWidgetQuery = { __typename?: 'Query', getSeasonRankingGalleryWidget?: { __typename?: 'SeasonRankingGalleryWidget', seasonAndCompId: string, seasonId: string, competitionId: string, competitionsSlugName?: string | null, competitionName?: string | null, drivers?: Array<{ __typename?: 'SeasonDriverRanking', teamId: string, driverId: string, driverFirstname?: string | null, driverSurname?: string | null, teamName?: string | null, teamUrl?: string | null, logoUrl?: string | null, position?: string | null, points?: string | null, driverPageLink?: string | null, driverImageUrl?: string | null } | null> | null, teams?: Array<{ __typename?: 'SeasonTeamRanking', teamId: string, teamName?: string | null, teamUrl?: string | null, logoUrl?: string | null, position?: string | null, points?: string | null, teamImageUrl?: string | null } | null> | null } | null };

export type GetTeamDriverPageWidgetQueryVariables = Exact<{
  seasonAndCompId: Scalars['ID']['input'];
}>;


export type GetTeamDriverPageWidgetQuery = { __typename?: 'Query', getTeamDriverPageWidget?: { __typename?: 'TeamDriverPageWidget', seasonAndCompId: string, seasonId: string, competitionId: string, teamList?: Array<{ __typename?: 'TeamDriverTeam', position?: number | null, teamLogoUrl?: string | null, teamName?: string | null, teamUrl?: string | null, drivers?: Array<{ __typename?: 'TeamDriverDriver', name?: string | null, imageUrl?: string | null, position?: number | null, url?: string | null } | null> | null } | null> | null } | null };

export type GetTeamRankingWidgetQueryVariables = Exact<{
  seasonAndCompId: Scalars['ID']['input'];
}>;


export type GetTeamRankingWidgetQuery = { __typename?: 'Query', getTeamRankingWidget?: { __typename?: 'TeamRankingWidget', competitionLabel?: string | null, seasonAndCompId: string, seasonId: string, competitionId: string, items?: Array<{ __typename?: 'TeamRankingTeam', customTeamPageUrl?: string | null, pos?: string | null, pts?: string | null, teamName?: string | null } | null> | null } | null };

export type onCreateCardDriverRankingWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateCardDriverRankingWidgetSubscription = { __typename?: 'Subscription', onCreateCardDriverRankingWidget?: { __typename?: 'CardDriverRankingWidget', competitionId: string, customCompetitionName?: string | null, rankingLink?: string | null, drivers?: Array<{ __typename: 'CardDriverRankingDriverInfo' } | null> | null } | null };

export type onCreateCardGpCalendarWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateCardGpCalendarWidgetSubscription = { __typename?: 'Subscription', onCreateCardGpCalendarWidget?: { __typename?: 'CardGpCalendarWidget', competitionId: string, customCompetitionName?: string | null, calendarLink?: string | null, gpList?: Array<{ __typename: 'CardGpCalendarGpInfo' } | null> | null } | null };

export type onCreateCardGpResultsWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateCardGpResultsWidgetSubscription = { __typename?: 'Subscription', onCreateCardGpResultsWidget?: { __typename?: 'CardGpResultsWidget', competitionId: string, customCompetitionName?: string | null, customGpName?: string | null, resultsLink?: string | null, isSprint?: boolean | null, results?: Array<{ __typename: 'CardGpResultsResultInfo' } | null> | null } | null };

export type onCreateCardTeamRankingWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateCardTeamRankingWidgetSubscription = { __typename?: 'Subscription', onCreateCardTeamRankingWidget?: { __typename?: 'CardTeamRankingWidget', competitionId: string, customCompetitionName?: string | null, rankingLink?: string | null, teams?: Array<{ __typename: 'CardTeamRankingTeamInfo' } | null> | null } | null };

export type onCreateCompetitionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateCompetitionSubscription = { __typename?: 'Subscription', onCreateCompetition?: { __typename?: 'Competition', seasonAndCompId: string, seasonId: string, competitionId: string, competitionJson: any, editorialDataId: string, previousSeasonAndCompId?: string | null, season?: { __typename: 'Season' } | null, previousCompetition?: { __typename: 'Competition' } | null, editorialData?: { __typename: 'EditorialData' } | null, teams?: { __typename: 'ModelTeamConnection' } | null, drivers?: { __typename: 'ModelDriverConnection' } | null, grandPrixes?: { __typename: 'ModelGrandPrixConnection' } | null } | null };

export type onCreateCrossLinkSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateCrossLinkSubscription = { __typename?: 'Subscription', onCreateCrossLink?: { __typename?: 'CrossLink', seasonAndCompId: string, gpId: string, crossLinkJson: any } | null };

export type onCreateDriverSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateDriverSubscription = { __typename?: 'Subscription', onCreateDriver?: { __typename?: 'Driver', seasonAndCompId: string, driverId: string, teamId: string, editorialDataId: string, driverJson: any, competition?: { __typename: 'Competition' } | null, editorialData?: { __typename: 'EditorialData' } | null, team?: { __typename: 'Team' } | null } | null };

export type onCreateDriverRankingWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateDriverRankingWidgetSubscription = { __typename?: 'Subscription', onCreateDriverRankingWidget?: { __typename?: 'DriverRankingWidget', seasonAndCompId: string, seasonId: string, competitionId: string, competitionLabel?: string | null, items?: Array<{ __typename: 'DriverRankingDriver' } | null> | null } | null };

export type onCreateDriverStatsWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateDriverStatsWidgetSubscription = { __typename?: 'Subscription', onCreateDriverStatsWidget?: { __typename?: 'DriverStatsWidget', driverId: string, seasonAndCompId?: string | null, customSeasonName?: string | null, customCompetitionName?: string | null, statistics?: Array<{ __typename: 'DriverStat' } | null> | null } | null };

export type onCreateEditorialDataSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateEditorialDataSubscription = { __typename?: 'Subscription', onCreateEditorialData?: { __typename?: 'EditorialData', editorialDataId: string, seasonAndCompId: string, isCurrent?: boolean | null, editorialJson: any, competition?: { __typename: 'Competition' } | null } | null };

export type onCreateGpCalendarWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateGpCalendarWidgetSubscription = { __typename?: 'Subscription', onCreateGpCalendarWidget?: { __typename?: 'GpCalendarWidget', seasonAndCompId: string, seasonId: string, competitionId: string, items?: Array<{ __typename: 'GpCalendarItem' } | null> | null } | null };

export type onCreateGpCurrentCalendarWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateGpCurrentCalendarWidgetSubscription = { __typename?: 'Subscription', onCreateGpCurrentCalendarWidget?: { __typename?: 'GpCurrentCalendarWidget', seasonAndCompId: string, seasonId: string, competitionId: string, items?: Array<{ __typename: 'GpCalendarItem' } | null> | null } | null };

export type onCreateGpDataSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateGpDataSubscription = { __typename?: 'Subscription', onCreateGpData?: { __typename?: 'GpData', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, messageType: string, data: any } | null };

export type onCreateGpLiveContainerWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateGpLiveContainerWidgetSubscription = { __typename?: 'Subscription', onCreateGpLiveContainerWidget?: { __typename?: 'GpLiveContainerWidget', seasonAndCompId: string, seasonId: string, competitionId: string, R?: { __typename: 'GpLiveContainerWrapper' } | null, G?: { __typename: 'GpLiveContainerWrapper' } | null, TS?: { __typename: 'GpLiveContainerWrapper' } | null, DS?: { __typename: 'GpLiveContainerWrapper' } | null } | null };

export type onCreateGpLiveHeroWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateGpLiveHeroWidgetSubscription = { __typename?: 'Subscription', onCreateGpLiveHeroWidget?: { __typename?: 'GpLiveHeroWidget', seasonAndCompId: string, seasonId: string, competitionId: string, isCurrent?: boolean | null, gpInfo?: { __typename: 'GpLiveHeroGpInfo' } | null } | null };

export type onCreateGpPodiumListWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateGpPodiumListWidgetSubscription = { __typename?: 'Subscription', onCreateGpPodiumListWidget?: { __typename?: 'GpPodiumListWidget', seasonAndCompId: string, seasonId: string, competitionId: string, grandPrixList?: Array<{ __typename: 'GpPodiumListGrandPrix' } | null> | null } | null };

export type onCreateGpResultsContainerWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateGpResultsContainerWidgetSubscription = { __typename?: 'Subscription', onCreateGpResultsContainerWidget?: { __typename?: 'GpResultsContainerWidget', seasonAndCompId: string, seasonId: string, competitionId: string, gpId: string, R?: { __typename: 'GpResultsContainerWrapper' } | null, G?: { __typename: 'GpResultsContainerWrapper' } | null, Q?: { __typename: 'GpResultsContainerWrapper' } | null, FP4?: { __typename: 'GpResultsContainerWrapper' } | null, FP3?: { __typename: 'GpResultsContainerWrapper' } | null, FP2?: { __typename: 'GpResultsContainerWrapper' } | null, FP1?: { __typename: 'GpResultsContainerWrapper' } | null, SPRINT?: { __typename: 'GpResultsContainerWrapper' } | null, SS?: { __typename: 'GpResultsContainerWrapper' } | null, GS?: { __typename: 'GpResultsContainerWrapper' } | null, QS?: { __typename: 'GpResultsContainerWrapper' } | null } | null };

export type onCreateGpResultsWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateGpResultsWidgetSubscription = { __typename?: 'Subscription', onCreateGpResultsWidget?: { __typename?: 'GpResultsWidget', seasonAndCompId: string, seasonId: string, competitionId: string, gpId: string, sessionName: string, isCurrent?: boolean | null, gpStatus?: string | null, gpInfo?: { __typename: 'GpResultsGpInfo' } | null, sessions?: Array<{ __typename: 'GpResultsSession' } | null> | null } | null };

export type onCreateGrandPrixSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateGrandPrixSubscription = { __typename?: 'Subscription', onCreateGrandPrix?: { __typename?: 'GrandPrix', gpId: string, seasonAndCompId: string, status?: string | null, isCurrent?: boolean | null, date?: any | null, gpJson?: any | null, editorialDataId: string, editorialData?: { __typename: 'EditorialData' } | null, sessions?: { __typename: 'ModelSessionConnection' } | null, crossLink?: { __typename: 'CrossLink' } | null } | null };

export type onCreateLgpHeroStickyWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateLgpHeroStickyWidgetSubscription = { __typename?: 'Subscription', onCreateLgpHeroStickyWidget?: { __typename?: 'LgpHeroStickyWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, info?: { __typename: 'LgpHeroStickyInfo' } | null, session?: { __typename: 'LgpHeroStickySession' } | null } | null };

export type onCreateLgpHeroWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateLgpHeroWidgetSubscription = { __typename?: 'Subscription', onCreateLgpHeroWidget?: { __typename?: 'LgpHeroWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, info?: { __typename: 'LgpHeroInfo' } | null, session?: { __typename: 'LgpHeroSession' } | null } | null };

export type onCreateLgpPreviewWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateLgpPreviewWidgetSubscription = { __typename?: 'Subscription', onCreateLgpPreviewWidget?: { __typename?: 'LgpPreviewWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, gpStartDateTime?: string | null, gpName?: string | null, laps?: string | null, lengthKm?: string | null, sportLabel?: string | null, sessions?: Array<{ __typename: 'LgpPreviewSession' } | null> | null, calendar?: { __typename: 'LgpInfoLink' } | null, ranking?: { __typename: 'LgpInfoLink' } | null, results?: { __typename: 'LgpInfoLink' } | null, news?: { __typename: 'LgpInfoLink' } | null } | null };

export type onCreateLgpResultsContainerWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateLgpResultsContainerWidgetSubscription = { __typename?: 'Subscription', onCreateLgpResultsContainerWidget?: { __typename?: 'LgpResultsContainerWidget', seasonAndCompId: string, seasonId: string, competitionId: string, gpId: string, R?: { __typename: 'LgpResultsContainerWrapper' } | null, G?: { __typename: 'LgpResultsContainerWrapper' } | null, Q?: { __typename: 'LgpResultsContainerWrapper' } | null, FP4?: { __typename: 'LgpResultsContainerWrapper' } | null, FP3?: { __typename: 'LgpResultsContainerWrapper' } | null, FP2?: { __typename: 'LgpResultsContainerWrapper' } | null, FP1?: { __typename: 'LgpResultsContainerWrapper' } | null, SPRINT?: { __typename: 'LgpResultsContainerWrapper' } | null, SS?: { __typename: 'LgpResultsContainerWrapper' } | null, GS?: { __typename: 'LgpResultsContainerWrapper' } | null, QS?: { __typename: 'LgpResultsContainerWrapper' } | null } | null };

export type onCreateLgpResultsWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateLgpResultsWidgetSubscription = { __typename?: 'Subscription', onCreateLgpResultsWidget?: { __typename?: 'LgpResultsWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, sessionName: string, isCurrent?: boolean | null, gpStatus?: string | null, calendar?: { __typename: 'LgpInfoLink' } | null, ranking?: { __typename: 'LgpInfoLink' } | null, results?: { __typename: 'LgpInfoLink' } | null, gpInfo?: { __typename: 'LgpResultsGpInfo' } | null, sessions?: Array<{ __typename: 'LgpResultsSession' } | null> | null } | null };

export type onCreateLiveScoreWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateLiveScoreWidgetSubscription = { __typename?: 'Subscription', onCreateLiveScoreWidget?: { __typename?: 'LiveScoreWidget', id: string, previousDay?: Array<{ __typename: 'LiveScoreWidgetDay' } | null> | null, currentDay?: Array<{ __typename: 'LiveScoreWidgetDay' } | null> | null, nextDay?: Array<{ __typename: 'LiveScoreWidgetDay' } | null> | null } | null };

export type onCreateSeasonSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateSeasonSubscription = { __typename?: 'Subscription', onCreateSeason?: { __typename?: 'Season', seasonId: string, seasonJson: any, competitions?: { __typename: 'ModelCompetitionConnection' } | null } | null };

export type onCreateSeasonRankingGalleryWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateSeasonRankingGalleryWidgetSubscription = { __typename?: 'Subscription', onCreateSeasonRankingGalleryWidget?: { __typename?: 'SeasonRankingGalleryWidget', seasonAndCompId: string, seasonId: string, competitionId: string, competitionsSlugName?: string | null, competitionName?: string | null, drivers?: Array<{ __typename: 'SeasonDriverRanking' } | null> | null, teams?: Array<{ __typename: 'SeasonTeamRanking' } | null> | null } | null };

export type onCreateSessionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateSessionSubscription = { __typename?: 'Subscription', onCreateSession?: { __typename?: 'Session', sessionId: string, gpId: string, seasonAndCompId: string, status?: string | null, isCurrent?: boolean | null, date?: any | null, sessionJson?: any | null } | null };

export type onCreateTeamSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateTeamSubscription = { __typename?: 'Subscription', onCreateTeam?: { __typename?: 'Team', seasonAndCompId: string, teamId: string, teamJson: any, editorialDataId: string, competition?: { __typename: 'Competition' } | null, editorialData?: { __typename: 'EditorialData' } | null, drivers?: { __typename: 'ModelDriverConnection' } | null } | null };

export type onCreateTeamDriverPageWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateTeamDriverPageWidgetSubscription = { __typename?: 'Subscription', onCreateTeamDriverPageWidget?: { __typename?: 'TeamDriverPageWidget', seasonAndCompId: string, seasonId: string, competitionId: string, teamList?: Array<{ __typename: 'TeamDriverTeam' } | null> | null } | null };

export type onCreateTeamRankingWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onCreateTeamRankingWidgetSubscription = { __typename?: 'Subscription', onCreateTeamRankingWidget?: { __typename?: 'TeamRankingWidget', seasonAndCompId: string, seasonId: string, competitionId: string, competitionLabel?: string | null, items?: Array<{ __typename: 'TeamRankingTeam' } | null> | null } | null };

export type onDeleteCardDriverRankingWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteCardDriverRankingWidgetSubscription = { __typename?: 'Subscription', onDeleteCardDriverRankingWidget?: { __typename?: 'CardDriverRankingWidget', competitionId: string, customCompetitionName?: string | null, rankingLink?: string | null, drivers?: Array<{ __typename: 'CardDriverRankingDriverInfo' } | null> | null } | null };

export type onDeleteCardGpCalendarWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteCardGpCalendarWidgetSubscription = { __typename?: 'Subscription', onDeleteCardGpCalendarWidget?: { __typename?: 'CardGpCalendarWidget', competitionId: string, customCompetitionName?: string | null, calendarLink?: string | null, gpList?: Array<{ __typename: 'CardGpCalendarGpInfo' } | null> | null } | null };

export type onDeleteCardGpResultsWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteCardGpResultsWidgetSubscription = { __typename?: 'Subscription', onDeleteCardGpResultsWidget?: { __typename?: 'CardGpResultsWidget', competitionId: string, customCompetitionName?: string | null, customGpName?: string | null, resultsLink?: string | null, isSprint?: boolean | null, results?: Array<{ __typename: 'CardGpResultsResultInfo' } | null> | null } | null };

export type onDeleteCardTeamRankingWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteCardTeamRankingWidgetSubscription = { __typename?: 'Subscription', onDeleteCardTeamRankingWidget?: { __typename?: 'CardTeamRankingWidget', competitionId: string, customCompetitionName?: string | null, rankingLink?: string | null, teams?: Array<{ __typename: 'CardTeamRankingTeamInfo' } | null> | null } | null };

export type onDeleteCompetitionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteCompetitionSubscription = { __typename?: 'Subscription', onDeleteCompetition?: { __typename?: 'Competition', seasonAndCompId: string, seasonId: string, competitionId: string, competitionJson: any, editorialDataId: string, previousSeasonAndCompId?: string | null, season?: { __typename: 'Season' } | null, previousCompetition?: { __typename: 'Competition' } | null, editorialData?: { __typename: 'EditorialData' } | null, teams?: { __typename: 'ModelTeamConnection' } | null, drivers?: { __typename: 'ModelDriverConnection' } | null, grandPrixes?: { __typename: 'ModelGrandPrixConnection' } | null } | null };

export type onDeleteCrossLinkSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteCrossLinkSubscription = { __typename?: 'Subscription', onDeleteCrossLink?: { __typename?: 'CrossLink', seasonAndCompId: string, gpId: string, crossLinkJson: any } | null };

export type onDeleteDriverSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteDriverSubscription = { __typename?: 'Subscription', onDeleteDriver?: { __typename?: 'Driver', seasonAndCompId: string, driverId: string, teamId: string, editorialDataId: string, driverJson: any, competition?: { __typename: 'Competition' } | null, editorialData?: { __typename: 'EditorialData' } | null, team?: { __typename: 'Team' } | null } | null };

export type onDeleteDriverRankingWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteDriverRankingWidgetSubscription = { __typename?: 'Subscription', onDeleteDriverRankingWidget?: { __typename?: 'DriverRankingWidget', seasonAndCompId: string, seasonId: string, competitionId: string, competitionLabel?: string | null, items?: Array<{ __typename: 'DriverRankingDriver' } | null> | null } | null };

export type onDeleteDriverStatsWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteDriverStatsWidgetSubscription = { __typename?: 'Subscription', onDeleteDriverStatsWidget?: { __typename?: 'DriverStatsWidget', driverId: string, seasonAndCompId?: string | null, customSeasonName?: string | null, customCompetitionName?: string | null, statistics?: Array<{ __typename: 'DriverStat' } | null> | null } | null };

export type onDeleteEditorialDataSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteEditorialDataSubscription = { __typename?: 'Subscription', onDeleteEditorialData?: { __typename?: 'EditorialData', editorialDataId: string, seasonAndCompId: string, isCurrent?: boolean | null, editorialJson: any, competition?: { __typename: 'Competition' } | null } | null };

export type onDeleteGpCalendarWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteGpCalendarWidgetSubscription = { __typename?: 'Subscription', onDeleteGpCalendarWidget?: { __typename?: 'GpCalendarWidget', seasonAndCompId: string, seasonId: string, competitionId: string, items?: Array<{ __typename: 'GpCalendarItem' } | null> | null } | null };

export type onDeleteGpCurrentCalendarWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteGpCurrentCalendarWidgetSubscription = { __typename?: 'Subscription', onDeleteGpCurrentCalendarWidget?: { __typename?: 'GpCurrentCalendarWidget', seasonAndCompId: string, seasonId: string, competitionId: string, items?: Array<{ __typename: 'GpCalendarItem' } | null> | null } | null };

export type onDeleteGpDataSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteGpDataSubscription = { __typename?: 'Subscription', onDeleteGpData?: { __typename?: 'GpData', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, messageType: string, data: any } | null };

export type onDeleteGpLiveContainerWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteGpLiveContainerWidgetSubscription = { __typename?: 'Subscription', onDeleteGpLiveContainerWidget?: { __typename?: 'GpLiveContainerWidget', seasonAndCompId: string, seasonId: string, competitionId: string, R?: { __typename: 'GpLiveContainerWrapper' } | null, G?: { __typename: 'GpLiveContainerWrapper' } | null, TS?: { __typename: 'GpLiveContainerWrapper' } | null, DS?: { __typename: 'GpLiveContainerWrapper' } | null } | null };

export type onDeleteGpLiveHeroWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteGpLiveHeroWidgetSubscription = { __typename?: 'Subscription', onDeleteGpLiveHeroWidget?: { __typename?: 'GpLiveHeroWidget', seasonAndCompId: string, seasonId: string, competitionId: string, isCurrent?: boolean | null, gpInfo?: { __typename: 'GpLiveHeroGpInfo' } | null } | null };

export type onDeleteGpPodiumListWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteGpPodiumListWidgetSubscription = { __typename?: 'Subscription', onDeleteGpPodiumListWidget?: { __typename?: 'GpPodiumListWidget', seasonAndCompId: string, seasonId: string, competitionId: string, grandPrixList?: Array<{ __typename: 'GpPodiumListGrandPrix' } | null> | null } | null };

export type onDeleteGpResultsContainerWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteGpResultsContainerWidgetSubscription = { __typename?: 'Subscription', onDeleteGpResultsContainerWidget?: { __typename?: 'GpResultsContainerWidget', seasonAndCompId: string, seasonId: string, competitionId: string, gpId: string, R?: { __typename: 'GpResultsContainerWrapper' } | null, G?: { __typename: 'GpResultsContainerWrapper' } | null, Q?: { __typename: 'GpResultsContainerWrapper' } | null, FP4?: { __typename: 'GpResultsContainerWrapper' } | null, FP3?: { __typename: 'GpResultsContainerWrapper' } | null, FP2?: { __typename: 'GpResultsContainerWrapper' } | null, FP1?: { __typename: 'GpResultsContainerWrapper' } | null, SPRINT?: { __typename: 'GpResultsContainerWrapper' } | null, SS?: { __typename: 'GpResultsContainerWrapper' } | null, GS?: { __typename: 'GpResultsContainerWrapper' } | null, QS?: { __typename: 'GpResultsContainerWrapper' } | null } | null };

export type onDeleteGpResultsWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteGpResultsWidgetSubscription = { __typename?: 'Subscription', onDeleteGpResultsWidget?: { __typename?: 'GpResultsWidget', seasonAndCompId: string, seasonId: string, competitionId: string, gpId: string, sessionName: string, isCurrent?: boolean | null, gpStatus?: string | null, gpInfo?: { __typename: 'GpResultsGpInfo' } | null, sessions?: Array<{ __typename: 'GpResultsSession' } | null> | null } | null };

export type onDeleteGrandPrixSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteGrandPrixSubscription = { __typename?: 'Subscription', onDeleteGrandPrix?: { __typename?: 'GrandPrix', gpId: string, seasonAndCompId: string, status?: string | null, isCurrent?: boolean | null, date?: any | null, gpJson?: any | null, editorialDataId: string, editorialData?: { __typename: 'EditorialData' } | null, sessions?: { __typename: 'ModelSessionConnection' } | null, crossLink?: { __typename: 'CrossLink' } | null } | null };

export type onDeleteLgpHeroStickyWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteLgpHeroStickyWidgetSubscription = { __typename?: 'Subscription', onDeleteLgpHeroStickyWidget?: { __typename?: 'LgpHeroStickyWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, info?: { __typename: 'LgpHeroStickyInfo' } | null, session?: { __typename: 'LgpHeroStickySession' } | null } | null };

export type onDeleteLgpHeroWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteLgpHeroWidgetSubscription = { __typename?: 'Subscription', onDeleteLgpHeroWidget?: { __typename?: 'LgpHeroWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, info?: { __typename: 'LgpHeroInfo' } | null, session?: { __typename: 'LgpHeroSession' } | null } | null };

export type onDeleteLgpPreviewWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteLgpPreviewWidgetSubscription = { __typename?: 'Subscription', onDeleteLgpPreviewWidget?: { __typename?: 'LgpPreviewWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, gpStartDateTime?: string | null, gpName?: string | null, laps?: string | null, lengthKm?: string | null, sportLabel?: string | null, sessions?: Array<{ __typename: 'LgpPreviewSession' } | null> | null, calendar?: { __typename: 'LgpInfoLink' } | null, ranking?: { __typename: 'LgpInfoLink' } | null, results?: { __typename: 'LgpInfoLink' } | null, news?: { __typename: 'LgpInfoLink' } | null } | null };

export type onDeleteLgpResultsContainerWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteLgpResultsContainerWidgetSubscription = { __typename?: 'Subscription', onDeleteLgpResultsContainerWidget?: { __typename?: 'LgpResultsContainerWidget', seasonAndCompId: string, seasonId: string, competitionId: string, gpId: string, R?: { __typename: 'LgpResultsContainerWrapper' } | null, G?: { __typename: 'LgpResultsContainerWrapper' } | null, Q?: { __typename: 'LgpResultsContainerWrapper' } | null, FP4?: { __typename: 'LgpResultsContainerWrapper' } | null, FP3?: { __typename: 'LgpResultsContainerWrapper' } | null, FP2?: { __typename: 'LgpResultsContainerWrapper' } | null, FP1?: { __typename: 'LgpResultsContainerWrapper' } | null, SPRINT?: { __typename: 'LgpResultsContainerWrapper' } | null, SS?: { __typename: 'LgpResultsContainerWrapper' } | null, GS?: { __typename: 'LgpResultsContainerWrapper' } | null, QS?: { __typename: 'LgpResultsContainerWrapper' } | null } | null };

export type onDeleteLgpResultsWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteLgpResultsWidgetSubscription = { __typename?: 'Subscription', onDeleteLgpResultsWidget?: { __typename?: 'LgpResultsWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, sessionName: string, isCurrent?: boolean | null, gpStatus?: string | null, calendar?: { __typename: 'LgpInfoLink' } | null, ranking?: { __typename: 'LgpInfoLink' } | null, results?: { __typename: 'LgpInfoLink' } | null, gpInfo?: { __typename: 'LgpResultsGpInfo' } | null, sessions?: Array<{ __typename: 'LgpResultsSession' } | null> | null } | null };

export type onDeleteLiveScoreWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteLiveScoreWidgetSubscription = { __typename?: 'Subscription', onDeleteLiveScoreWidget?: { __typename?: 'LiveScoreWidget', id: string, previousDay?: Array<{ __typename: 'LiveScoreWidgetDay' } | null> | null, currentDay?: Array<{ __typename: 'LiveScoreWidgetDay' } | null> | null, nextDay?: Array<{ __typename: 'LiveScoreWidgetDay' } | null> | null } | null };

export type onDeleteSeasonSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteSeasonSubscription = { __typename?: 'Subscription', onDeleteSeason?: { __typename?: 'Season', seasonId: string, seasonJson: any, competitions?: { __typename: 'ModelCompetitionConnection' } | null } | null };

export type onDeleteSeasonRankingGalleryWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteSeasonRankingGalleryWidgetSubscription = { __typename?: 'Subscription', onDeleteSeasonRankingGalleryWidget?: { __typename?: 'SeasonRankingGalleryWidget', seasonAndCompId: string, seasonId: string, competitionId: string, competitionsSlugName?: string | null, competitionName?: string | null, drivers?: Array<{ __typename: 'SeasonDriverRanking' } | null> | null, teams?: Array<{ __typename: 'SeasonTeamRanking' } | null> | null } | null };

export type onDeleteSessionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteSessionSubscription = { __typename?: 'Subscription', onDeleteSession?: { __typename?: 'Session', sessionId: string, gpId: string, seasonAndCompId: string, status?: string | null, isCurrent?: boolean | null, date?: any | null, sessionJson?: any | null } | null };

export type onDeleteTeamSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteTeamSubscription = { __typename?: 'Subscription', onDeleteTeam?: { __typename?: 'Team', seasonAndCompId: string, teamId: string, teamJson: any, editorialDataId: string, competition?: { __typename: 'Competition' } | null, editorialData?: { __typename: 'EditorialData' } | null, drivers?: { __typename: 'ModelDriverConnection' } | null } | null };

export type onDeleteTeamDriverPageWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteTeamDriverPageWidgetSubscription = { __typename?: 'Subscription', onDeleteTeamDriverPageWidget?: { __typename?: 'TeamDriverPageWidget', seasonAndCompId: string, seasonId: string, competitionId: string, teamList?: Array<{ __typename: 'TeamDriverTeam' } | null> | null } | null };

export type onDeleteTeamRankingWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onDeleteTeamRankingWidgetSubscription = { __typename?: 'Subscription', onDeleteTeamRankingWidget?: { __typename?: 'TeamRankingWidget', seasonAndCompId: string, seasonId: string, competitionId: string, competitionLabel?: string | null, items?: Array<{ __typename: 'TeamRankingTeam' } | null> | null } | null };

export type onUpdateCardDriverRankingWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateCardDriverRankingWidgetSubscription = { __typename?: 'Subscription', onUpdateCardDriverRankingWidget?: { __typename?: 'CardDriverRankingWidget', competitionId: string, customCompetitionName?: string | null, rankingLink?: string | null, drivers?: Array<{ __typename: 'CardDriverRankingDriverInfo' } | null> | null } | null };

export type onUpdateCardGpCalendarWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateCardGpCalendarWidgetSubscription = { __typename?: 'Subscription', onUpdateCardGpCalendarWidget?: { __typename?: 'CardGpCalendarWidget', competitionId: string, customCompetitionName?: string | null, calendarLink?: string | null, gpList?: Array<{ __typename: 'CardGpCalendarGpInfo' } | null> | null } | null };

export type onUpdateCardGpResultsWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateCardGpResultsWidgetSubscription = { __typename?: 'Subscription', onUpdateCardGpResultsWidget?: { __typename?: 'CardGpResultsWidget', competitionId: string, customCompetitionName?: string | null, customGpName?: string | null, resultsLink?: string | null, isSprint?: boolean | null, results?: Array<{ __typename: 'CardGpResultsResultInfo' } | null> | null } | null };

export type onUpdateCardTeamRankingWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateCardTeamRankingWidgetSubscription = { __typename?: 'Subscription', onUpdateCardTeamRankingWidget?: { __typename?: 'CardTeamRankingWidget', competitionId: string, customCompetitionName?: string | null, rankingLink?: string | null, teams?: Array<{ __typename: 'CardTeamRankingTeamInfo' } | null> | null } | null };

export type onUpdateCompetitionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateCompetitionSubscription = { __typename?: 'Subscription', onUpdateCompetition?: { __typename?: 'Competition', seasonAndCompId: string, seasonId: string, competitionId: string, competitionJson: any, editorialDataId: string, previousSeasonAndCompId?: string | null, season?: { __typename: 'Season' } | null, previousCompetition?: { __typename: 'Competition' } | null, editorialData?: { __typename: 'EditorialData' } | null, teams?: { __typename: 'ModelTeamConnection' } | null, drivers?: { __typename: 'ModelDriverConnection' } | null, grandPrixes?: { __typename: 'ModelGrandPrixConnection' } | null } | null };

export type onUpdateCrossLinkSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateCrossLinkSubscription = { __typename?: 'Subscription', onUpdateCrossLink?: { __typename?: 'CrossLink', seasonAndCompId: string, gpId: string, crossLinkJson: any } | null };

export type onUpdateDriverSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateDriverSubscription = { __typename?: 'Subscription', onUpdateDriver?: { __typename?: 'Driver', seasonAndCompId: string, driverId: string, teamId: string, editorialDataId: string, driverJson: any, competition?: { __typename: 'Competition' } | null, editorialData?: { __typename: 'EditorialData' } | null, team?: { __typename: 'Team' } | null } | null };

export type onUpdateDriverRankingWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateDriverRankingWidgetSubscription = { __typename?: 'Subscription', onUpdateDriverRankingWidget?: { __typename?: 'DriverRankingWidget', seasonAndCompId: string, seasonId: string, competitionId: string, competitionLabel?: string | null, items?: Array<{ __typename: 'DriverRankingDriver' } | null> | null } | null };

export type onUpdateDriverStatsWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateDriverStatsWidgetSubscription = { __typename?: 'Subscription', onUpdateDriverStatsWidget?: { __typename?: 'DriverStatsWidget', driverId: string, seasonAndCompId?: string | null, customSeasonName?: string | null, customCompetitionName?: string | null, statistics?: Array<{ __typename: 'DriverStat' } | null> | null } | null };

export type onUpdateEditorialDataSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateEditorialDataSubscription = { __typename?: 'Subscription', onUpdateEditorialData?: { __typename?: 'EditorialData', editorialDataId: string, seasonAndCompId: string, isCurrent?: boolean | null, editorialJson: any, competition?: { __typename: 'Competition' } | null } | null };

export type onUpdateGpCalendarWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateGpCalendarWidgetSubscription = { __typename?: 'Subscription', onUpdateGpCalendarWidget?: { __typename?: 'GpCalendarWidget', seasonAndCompId: string, seasonId: string, competitionId: string, items?: Array<{ __typename: 'GpCalendarItem' } | null> | null } | null };

export type onUpdateGpCurrentCalendarWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateGpCurrentCalendarWidgetSubscription = { __typename?: 'Subscription', onUpdateGpCurrentCalendarWidget?: { __typename?: 'GpCurrentCalendarWidget', seasonAndCompId: string, seasonId: string, competitionId: string, items?: Array<{ __typename: 'GpCalendarItem' } | null> | null } | null };

export type onUpdateGpDataSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateGpDataSubscription = { __typename?: 'Subscription', onUpdateGpData?: { __typename?: 'GpData', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, messageType: string, data: any } | null };

export type onUpdateGpLiveContainerWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateGpLiveContainerWidgetSubscription = { __typename?: 'Subscription', onUpdateGpLiveContainerWidget?: { __typename?: 'GpLiveContainerWidget', seasonAndCompId: string, seasonId: string, competitionId: string, R?: { __typename: 'GpLiveContainerWrapper' } | null, G?: { __typename: 'GpLiveContainerWrapper' } | null, TS?: { __typename: 'GpLiveContainerWrapper' } | null, DS?: { __typename: 'GpLiveContainerWrapper' } | null } | null };

export type onUpdateGpLiveHeroWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateGpLiveHeroWidgetSubscription = { __typename?: 'Subscription', onUpdateGpLiveHeroWidget?: { __typename?: 'GpLiveHeroWidget', seasonAndCompId: string, seasonId: string, competitionId: string, isCurrent?: boolean | null, gpInfo?: { __typename: 'GpLiveHeroGpInfo' } | null } | null };

export type onUpdateGpPodiumListWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateGpPodiumListWidgetSubscription = { __typename?: 'Subscription', onUpdateGpPodiumListWidget?: { __typename?: 'GpPodiumListWidget', seasonAndCompId: string, seasonId: string, competitionId: string, grandPrixList?: Array<{ __typename: 'GpPodiumListGrandPrix' } | null> | null } | null };

export type onUpdateGpResultsContainerWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateGpResultsContainerWidgetSubscription = { __typename?: 'Subscription', onUpdateGpResultsContainerWidget?: { __typename?: 'GpResultsContainerWidget', seasonAndCompId: string, seasonId: string, competitionId: string, gpId: string, R?: { __typename: 'GpResultsContainerWrapper' } | null, G?: { __typename: 'GpResultsContainerWrapper' } | null, Q?: { __typename: 'GpResultsContainerWrapper' } | null, FP4?: { __typename: 'GpResultsContainerWrapper' } | null, FP3?: { __typename: 'GpResultsContainerWrapper' } | null, FP2?: { __typename: 'GpResultsContainerWrapper' } | null, FP1?: { __typename: 'GpResultsContainerWrapper' } | null, SPRINT?: { __typename: 'GpResultsContainerWrapper' } | null, SS?: { __typename: 'GpResultsContainerWrapper' } | null, GS?: { __typename: 'GpResultsContainerWrapper' } | null, QS?: { __typename: 'GpResultsContainerWrapper' } | null } | null };

export type onUpdateGpResultsWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateGpResultsWidgetSubscription = { __typename?: 'Subscription', onUpdateGpResultsWidget?: { __typename?: 'GpResultsWidget', seasonAndCompId: string, seasonId: string, competitionId: string, gpId: string, sessionName: string, isCurrent?: boolean | null, gpStatus?: string | null, gpInfo?: { __typename: 'GpResultsGpInfo' } | null, sessions?: Array<{ __typename: 'GpResultsSession' } | null> | null } | null };

export type onUpdateGpResultsWidgetByGpIdAndSessionNameSubscriptionVariables = Exact<{
  gpId: Scalars['ID']['input'];
  sessionName: Scalars['String']['input'];
}>;


export type onUpdateGpResultsWidgetByGpIdAndSessionNameSubscription = { __typename?: 'Subscription', onUpdateGpResultsWidgetByGpIdAndSessionName?: { __typename?: 'GpResultsWidget', seasonAndCompId: string, seasonId: string, competitionId: string, gpId: string, sessionName: string, isCurrent?: boolean | null, gpStatus?: string | null, gpInfo?: { __typename: 'GpResultsGpInfo' } | null, sessions?: Array<{ __typename: 'GpResultsSession' } | null> | null } | null };

export type onUpdateGrandPrixSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateGrandPrixSubscription = { __typename?: 'Subscription', onUpdateGrandPrix?: { __typename?: 'GrandPrix', gpId: string, seasonAndCompId: string, status?: string | null, isCurrent?: boolean | null, date?: any | null, gpJson?: any | null, editorialDataId: string, editorialData?: { __typename: 'EditorialData' } | null, sessions?: { __typename: 'ModelSessionConnection' } | null, crossLink?: { __typename: 'CrossLink' } | null } | null };

export type onUpdateLgpHeroStickyBySeasonAndCompIdAndGpIdSubscriptionVariables = Exact<{
  seasonAndCompId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
}>;


export type onUpdateLgpHeroStickyBySeasonAndCompIdAndGpIdSubscription = { __typename?: 'Subscription', onUpdateLgpHeroStickyBySeasonAndCompIdAndGpId?: { __typename?: 'LgpHeroStickyWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, info?: { __typename: 'LgpHeroStickyInfo' } | null, session?: { __typename: 'LgpHeroStickySession' } | null } | null };

export type onUpdateLgpHeroStickyWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateLgpHeroStickyWidgetSubscription = { __typename?: 'Subscription', onUpdateLgpHeroStickyWidget?: { __typename?: 'LgpHeroStickyWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, info?: { __typename: 'LgpHeroStickyInfo' } | null, session?: { __typename: 'LgpHeroStickySession' } | null } | null };

export type onUpdateLgpHeroWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateLgpHeroWidgetSubscription = { __typename?: 'Subscription', onUpdateLgpHeroWidget?: { __typename?: 'LgpHeroWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, info?: { __typename: 'LgpHeroInfo' } | null, session?: { __typename: 'LgpHeroSession' } | null } | null };

export type onUpdateLgpHeroWidgetBySeasonAndCompIdAndGpIdSubscriptionVariables = Exact<{
  seasonAndCompId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
}>;


export type onUpdateLgpHeroWidgetBySeasonAndCompIdAndGpIdSubscription = { __typename?: 'Subscription', onUpdateLgpHeroWidgetBySeasonAndCompIdAndGpId?: { __typename?: 'LgpHeroWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, info?: { __typename: 'LgpHeroInfo' } | null, session?: { __typename: 'LgpHeroSession' } | null } | null };

export type onUpdateLgpPreviewWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateLgpPreviewWidgetSubscription = { __typename?: 'Subscription', onUpdateLgpPreviewWidget?: { __typename?: 'LgpPreviewWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, gpStartDateTime?: string | null, gpName?: string | null, laps?: string | null, lengthKm?: string | null, sportLabel?: string | null, sessions?: Array<{ __typename: 'LgpPreviewSession' } | null> | null, calendar?: { __typename: 'LgpInfoLink' } | null, ranking?: { __typename: 'LgpInfoLink' } | null, results?: { __typename: 'LgpInfoLink' } | null, news?: { __typename: 'LgpInfoLink' } | null } | null };

export type onUpdateLgpPreviewWidgetBySeasonAndCompIdAndGpIdSubscriptionVariables = Exact<{
  seasonAndCompId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
}>;


export type onUpdateLgpPreviewWidgetBySeasonAndCompIdAndGpIdSubscription = { __typename?: 'Subscription', onUpdateLgpPreviewWidgetBySeasonAndCompIdAndGpId?: { __typename?: 'LgpPreviewWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, gpStartDateTime?: string | null, gpName?: string | null, laps?: string | null, lengthKm?: string | null, sportLabel?: string | null, sessions?: Array<{ __typename: 'LgpPreviewSession' } | null> | null, calendar?: { __typename: 'LgpInfoLink' } | null, ranking?: { __typename: 'LgpInfoLink' } | null, results?: { __typename: 'LgpInfoLink' } | null, news?: { __typename: 'LgpInfoLink' } | null } | null };

export type onUpdateLgpResContainerBySeasonAndCompIdAndGpIdSubscriptionVariables = Exact<{
  seasonAndCompId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
}>;


export type onUpdateLgpResContainerBySeasonAndCompIdAndGpIdSubscription = { __typename?: 'Subscription', onUpdateLgpResContainerBySeasonAndCompIdAndGpId?: { __typename?: 'LgpResultsContainerWidget', seasonAndCompId: string, seasonId: string, competitionId: string, gpId: string, R?: { __typename: 'LgpResultsContainerWrapper' } | null, G?: { __typename: 'LgpResultsContainerWrapper' } | null, Q?: { __typename: 'LgpResultsContainerWrapper' } | null, FP4?: { __typename: 'LgpResultsContainerWrapper' } | null, FP3?: { __typename: 'LgpResultsContainerWrapper' } | null, FP2?: { __typename: 'LgpResultsContainerWrapper' } | null, FP1?: { __typename: 'LgpResultsContainerWrapper' } | null, SPRINT?: { __typename: 'LgpResultsContainerWrapper' } | null, SS?: { __typename: 'LgpResultsContainerWrapper' } | null, GS?: { __typename: 'LgpResultsContainerWrapper' } | null, QS?: { __typename: 'LgpResultsContainerWrapper' } | null } | null };

export type onUpdateLgpResultsContainerWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateLgpResultsContainerWidgetSubscription = { __typename?: 'Subscription', onUpdateLgpResultsContainerWidget?: { __typename?: 'LgpResultsContainerWidget', seasonAndCompId: string, seasonId: string, competitionId: string, gpId: string, R?: { __typename: 'LgpResultsContainerWrapper' } | null, G?: { __typename: 'LgpResultsContainerWrapper' } | null, Q?: { __typename: 'LgpResultsContainerWrapper' } | null, FP4?: { __typename: 'LgpResultsContainerWrapper' } | null, FP3?: { __typename: 'LgpResultsContainerWrapper' } | null, FP2?: { __typename: 'LgpResultsContainerWrapper' } | null, FP1?: { __typename: 'LgpResultsContainerWrapper' } | null, SPRINT?: { __typename: 'LgpResultsContainerWrapper' } | null, SS?: { __typename: 'LgpResultsContainerWrapper' } | null, GS?: { __typename: 'LgpResultsContainerWrapper' } | null, QS?: { __typename: 'LgpResultsContainerWrapper' } | null } | null };

export type onUpdateLgpResultsWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateLgpResultsWidgetSubscription = { __typename?: 'Subscription', onUpdateLgpResultsWidget?: { __typename?: 'LgpResultsWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, sessionName: string, isCurrent?: boolean | null, gpStatus?: string | null, calendar?: { __typename: 'LgpInfoLink' } | null, ranking?: { __typename: 'LgpInfoLink' } | null, results?: { __typename: 'LgpInfoLink' } | null, gpInfo?: { __typename: 'LgpResultsGpInfo' } | null, sessions?: Array<{ __typename: 'LgpResultsSession' } | null> | null } | null };

export type onUpdateLgpResultsWidgetByGpIdAndSessionNameSubscriptionVariables = Exact<{
  gpId: Scalars['ID']['input'];
  sessionName: Scalars['String']['input'];
}>;


export type onUpdateLgpResultsWidgetByGpIdAndSessionNameSubscription = { __typename?: 'Subscription', onUpdateLgpResultsWidgetByGpIdAndSessionName?: { __typename?: 'LgpResultsWidget', seasonAndCompId: string, gpId: string, seasonId: string, competitionId: string, sessionName: string, isCurrent?: boolean | null, gpStatus?: string | null, calendar?: { __typename: 'LgpInfoLink' } | null, ranking?: { __typename: 'LgpInfoLink' } | null, results?: { __typename: 'LgpInfoLink' } | null, gpInfo?: { __typename: 'LgpResultsGpInfo' } | null, sessions?: Array<{ __typename: 'LgpResultsSession' } | null> | null } | null };

export type onUpdateLiveScoreWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateLiveScoreWidgetSubscription = { __typename?: 'Subscription', onUpdateLiveScoreWidget?: { __typename?: 'LiveScoreWidget', id: string, previousDay?: Array<{ __typename: 'LiveScoreWidgetDay' } | null> | null, currentDay?: Array<{ __typename: 'LiveScoreWidgetDay' } | null> | null, nextDay?: Array<{ __typename: 'LiveScoreWidgetDay' } | null> | null } | null };

export type onUpdateLiveScoreWidgetByIdSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type onUpdateLiveScoreWidgetByIdSubscription = { __typename?: 'Subscription', onUpdateLiveScoreWidgetById?: { __typename?: 'LiveScoreWidget', id: string, previousDay?: Array<{ __typename: 'LiveScoreWidgetDay' } | null> | null, currentDay?: Array<{ __typename: 'LiveScoreWidgetDay' } | null> | null, nextDay?: Array<{ __typename: 'LiveScoreWidgetDay' } | null> | null } | null };

export type onUpdateSeasonSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateSeasonSubscription = { __typename?: 'Subscription', onUpdateSeason?: { __typename?: 'Season', seasonId: string, seasonJson: any, competitions?: { __typename: 'ModelCompetitionConnection' } | null } | null };

export type onUpdateSeasonRankingGalleryWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateSeasonRankingGalleryWidgetSubscription = { __typename?: 'Subscription', onUpdateSeasonRankingGalleryWidget?: { __typename?: 'SeasonRankingGalleryWidget', seasonAndCompId: string, seasonId: string, competitionId: string, competitionsSlugName?: string | null, competitionName?: string | null, drivers?: Array<{ __typename: 'SeasonDriverRanking' } | null> | null, teams?: Array<{ __typename: 'SeasonTeamRanking' } | null> | null } | null };

export type onUpdateSessionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateSessionSubscription = { __typename?: 'Subscription', onUpdateSession?: { __typename?: 'Session', sessionId: string, gpId: string, seasonAndCompId: string, status?: string | null, isCurrent?: boolean | null, date?: any | null, sessionJson?: any | null } | null };

export type onUpdateTeamSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateTeamSubscription = { __typename?: 'Subscription', onUpdateTeam?: { __typename?: 'Team', seasonAndCompId: string, teamId: string, teamJson: any, editorialDataId: string, competition?: { __typename: 'Competition' } | null, editorialData?: { __typename: 'EditorialData' } | null, drivers?: { __typename: 'ModelDriverConnection' } | null } | null };

export type onUpdateTeamDriverPageWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateTeamDriverPageWidgetSubscription = { __typename?: 'Subscription', onUpdateTeamDriverPageWidget?: { __typename?: 'TeamDriverPageWidget', seasonAndCompId: string, seasonId: string, competitionId: string, teamList?: Array<{ __typename: 'TeamDriverTeam' } | null> | null } | null };

export type onUpdateTeamRankingWidgetSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type onUpdateTeamRankingWidgetSubscription = { __typename?: 'Subscription', onUpdateTeamRankingWidget?: { __typename?: 'TeamRankingWidget', seasonAndCompId: string, seasonId: string, competitionId: string, competitionLabel?: string | null, items?: Array<{ __typename: 'TeamRankingTeam' } | null> | null } | null };

export type UpdateLgpHeroStickyWidgetSubscriptionVariables = Exact<{
  gpId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
}>;


export type UpdateLgpHeroStickyWidgetSubscription = { __typename?: 'Subscription', onUpdateLgpHeroStickyBySeasonAndCompIdAndGpId?: { __typename?: 'LgpHeroStickyWidget', gpId: string, seasonAndCompId: string, session?: { __typename?: 'LgpHeroStickySession', label?: string | null, name?: string | null, status?: string | null } | null, info?: { __typename?: 'LgpHeroStickyInfo', customGpName?: string | null, endDate?: string | null, flagImgUrl?: string | null, startDate?: string | null } | null } | null };

export type UpdateLgpHeroWidgetSubscriptionVariables = Exact<{
  seasonAndCompId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
}>;


export type UpdateLgpHeroWidgetSubscription = { __typename?: 'Subscription', onUpdateLgpHeroWidgetBySeasonAndCompIdAndGpId?: { __typename?: 'LgpHeroWidget', gpId: string, seasonAndCompId: string, session?: { __typename?: 'LgpHeroSession', label?: string | null, name?: string | null, status?: string | null, podium?: Array<{ __typename?: 'LgpHeroPodium', customDriverName?: string | null, customDriverSurname?: string | null, customDriverShortName?: string | null, driverImgUrl?: string | null, flagImgUrl?: string | null, position?: number | null }> | null } | null, info?: { __typename?: 'LgpHeroInfo', circuitImgUrl?: string | null, customGpName?: string | null, flagImgUrl?: string | null, startDate?: string | null, sportTag?: string | null, endDate?: string | null } | null } | null };

export type UpdateLgpResultsContainerWidgetSubscriptionVariables = Exact<{
  seasonAndCompId: Scalars['ID']['input'];
  gpId: Scalars['ID']['input'];
}>;


export type UpdateLgpResultsContainerWidgetSubscription = { __typename?: 'Subscription', onUpdateLgpResContainerBySeasonAndCompIdAndGpId?: { __typename: 'LgpResultsContainerWidget', gpId: string, seasonAndCompId: string, createdAt: any, updatedAt: any, competitionId: string, seasonId: string, FP1?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, FP2?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, FP3?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, FP4?: { __typename?: 'LgpResultsContainerWrapper', startDateTime?: string | null, ssi?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, G?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, GS?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, Q?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, QS?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, R?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null, SPRINT?: { __typename?: 'LgpResultsContainerWrapper', ssi?: string | null, startDateTime?: string | null, customDataAttributes?: { __typename?: 'LgpResultsContainerWrapperAttributes', tracking?: string | null, url?: string | null } | null } | null } | null };

export type UpdateLgpResultsWidgetSubscriptionVariables = Exact<{
  gpId: Scalars['ID']['input'];
  sessionName: Scalars['String']['input'];
}>;


export type UpdateLgpResultsWidgetSubscription = { __typename?: 'Subscription', onUpdateLgpResultsWidgetByGpIdAndSessionName?: { __typename: 'LgpResultsWidget', gpId: string, gpStatus?: string | null, isCurrent?: boolean | null, seasonAndCompId: string, sessionName: string, competitionId: string, seasonId: string, ranking?: { __typename?: 'LgpInfoLink', link?: string | null, text?: string | null } | null, results?: { __typename?: 'LgpInfoLink', link?: string | null, text?: string | null } | null, calendar?: { __typename?: 'LgpInfoLink', link?: string | null, text?: string | null } | null, gpInfo?: { __typename?: 'LgpResultsGpInfo', customGpName?: string | null, gpStatus?: string | null, isCurrent?: boolean | null, isExclusive?: boolean | null, isSprint?: boolean | null, lapRecord?: string | null, laps?: string | null, lengthKm?: string | null, startDateTime?: string | null } | null, sessions?: Array<{ __typename?: 'LgpResultsSession', isCurrent?: boolean | null, sessionInfo?: { __typename?: 'LgpResultsSessionInfo', isCurrent?: boolean | null, sessionLabel?: string | null, sessionName?: string | null, sessionStatus?: string | null, startDateTime?: string | null, details?: Array<{ __typename?: 'LgpResultsSessionInfoDetails', customDriverName?: string | null, customDriverPageUrl?: string | null, customDriverSurname?: string | null, customTeamName?: string | null, customTeamPageUrl?: string | null, fastestLap?: string | null, flagUrl?: string | null, gap?: string | null, isFastestLap?: boolean | null, laps?: string | null, position?: string | null, status?: string | null, timing?: { __typename?: 'LgpResultsSessionInfoDetailsTiming', timeHours?: string | null, timeMilliseconds?: string | null, timeMinutes?: string | null, timeSeconds?: string | null } | null } | null> | null } | null } | null> | null } | null };

export type UpdateLiveScoreWidgetSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UpdateLiveScoreWidgetSubscription = { __typename?: 'Subscription', onUpdateLiveScoreWidgetById?: { __typename?: 'LiveScoreWidget', id: string, currentDay?: Array<{ __typename?: 'LiveScoreWidgetDay', gpInfo?: { __typename?: 'LiveScoreWidgetGpInfo', gpPageUrl?: string | null, gpCrosslink?: string | null } | null, sessions?: Array<{ __typename?: 'LiveScoreWidgetSession', sessionDate?: string | null, sessionName?: string | null, sessionStatus?: string | null, resultsUrl?: string | null, results?: Array<{ __typename?: 'LiveScoreWidgetResults', customDriverName?: string | null, customDriverPageUrl?: string | null, customDriverSurname?: string | null, customTeamName?: string | null, customTeamPageUrl?: string | null, fastestLap?: string | null, firstName?: string | null, flagUrl?: string | null, gap?: string | null, isFastestLap?: boolean | null, lastName?: string | null, position?: string | null, teamName?: string | null, timing?: { __typename?: 'LiveScoreWidgetResultsTiming', timeHours?: string | null, timeMilliseconds?: string | null, timeMinutes?: string | null, timeSeconds?: string | null } | null } | null> | null } | null> | null } | null> | null } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const GetCardDriverRankingWidgetDocument = new TypedDocumentString(`
    query GetCardDriverRankingWidget($competitionId: ID!) {
  getCardDriverRankingWidget(competitionId: $competitionId) {
    competitionId
    customCompetitionName
    rankingLink
    drivers {
      customDriverName
      customDriverPageUrl
      customDriverSurname
      flagUrl
      pos
      pts
    }
  }
}
    `) as unknown as TypedDocumentString<GetCardDriverRankingWidgetQuery, GetCardDriverRankingWidgetQueryVariables>;
export const GetCardGpCalendarWidgetDocument = new TypedDocumentString(`
    query GetCardGpCalendarWidget($competitionId: ID!) {
  getCardGpCalendarWidget(competitionId: $competitionId) {
    competitionId
    customCompetitionName
    calendarLink
    gpList {
      customGpName
      flagUrl
      isExclusive
      startDateTime
      endDateTime
      lgpPreviewUrl
    }
  }
}
    `) as unknown as TypedDocumentString<GetCardGpCalendarWidgetQuery, GetCardGpCalendarWidgetQueryVariables>;
export const GetCardGpResultsDocument = new TypedDocumentString(`
    query GetCardGpResults($competitionId: ID!) {
  getCardGpResultsWidget(competitionId: $competitionId) {
    competitionId
    customCompetitionName
    customGpName
    resultsLink
    isSprint
    results {
      customDriverName
      customDriverPageUrl
      customDriverSurname
      flagUrl
      gap
      pos
      timing {
        timeSeconds
        timeMilliseconds
        timeHours
        timeMinutes
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCardGpResultsQuery, GetCardGpResultsQueryVariables>;
export const GetCardTeamRankingWidgetDocument = new TypedDocumentString(`
    query GetCardTeamRankingWidget($competitionId: ID!) {
  getCardTeamRankingWidget(competitionId: $competitionId) {
    competitionId
    customCompetitionName
    rankingLink
    teams {
      customTeamName
      customTeamPageUrl
      logoUrl
      pos
      pts
    }
  }
}
    `) as unknown as TypedDocumentString<GetCardTeamRankingWidgetQuery, GetCardTeamRankingWidgetQueryVariables>;
export const CompetitionCalendarWidgetDocument = new TypedDocumentString(`
    query CompetitionCalendarWidget($seasonAndCompId: ID!) {
  getGpCalendarWidget(seasonAndCompId: $seasonAndCompId) {
    items {
      gpInfo {
        circuitUrl
        customGpName
        flagUrl
        gpPageUrl
        gpStatus
        isCurrent
        isExclusive
        isSprint
        lapRecord
        laps
        lengthKm
        startDateTime
      }
      sessions {
        items {
          sessionLabel
          sessionStatus
          sessionResultUrl
          sessionInfo {
            isCurrent
            sessionLabel
            sessionName
            sessionStatus
            startDateTime
          }
        }
      }
    }
    seasonAndCompId
    seasonId
    competitionId
  }
}
    `) as unknown as TypedDocumentString<CompetitionCalendarWidgetQuery, CompetitionCalendarWidgetQueryVariables>;
export const CurrentCalendarWidgetDocument = new TypedDocumentString(`
    query CurrentCalendarWidget($seasonAndCompId: ID!) {
  getGpCurrentCalendarWidget(seasonAndCompId: $seasonAndCompId) {
    items {
      gpInfo {
        circuitUrl
        customGpName
        flagUrl
        gpPageUrl
        gpStatus
        isCurrent
        isExclusive
        isSprint
        lapRecord
        laps
        lengthKm
        startDateTime
      }
      sessions {
        items {
          sessionLabel
          sessionStatus
          sessionResultUrl
          sessionInfo {
            isCurrent
            sessionLabel
            sessionName
            sessionStatus
            startDateTime
          }
        }
      }
    }
    seasonAndCompId
    seasonId
    competitionId
  }
}
    `) as unknown as TypedDocumentString<CurrentCalendarWidgetQuery, CurrentCalendarWidgetQueryVariables>;
export const GetDriverRankingWidgetDocument = new TypedDocumentString(`
    query GetDriverRankingWidget($seasonAndCompId: ID!) {
  getDriverRankingWidget(seasonAndCompId: $seasonAndCompId) {
    seasonAndCompId
    seasonId
    competitionId
    competitionLabel
    items {
      driverInfo {
        customDriverName
        customDriverPageUrl
        customDriverSurname
        customTeamName
        customTeamPageUrl
        firstName
        flagUrl
        lastName
        nationality
        pos
        pts
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetDriverRankingWidgetQuery, GetDriverRankingWidgetQueryVariables>;
export const GetDriverStatsWidgetDocument = new TypedDocumentString(`
    query GetDriverStatsWidget($driverId: ID!) {
  getDriverStatsWidget(driverId: $driverId) {
    driverId
    seasonAndCompId
    customSeasonName
    customCompetitionName
    statistics {
      type
      value
    }
  }
}
    `) as unknown as TypedDocumentString<GetDriverStatsWidgetQuery, GetDriverStatsWidgetQueryVariables>;
export const GetLgpHeroStickyWidgetDocument = new TypedDocumentString(`
    query GetLgpHeroStickyWidget($seasonAndCompId: ID!, $gpId: ID!) {
  getLgpHeroStickyWidget(seasonAndCompId: $seasonAndCompId, gpId: $gpId) {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    info {
      flagImgUrl
      customGpName
      startDate
      endDate
    }
    session {
      status
      name
      label
    }
  }
}
    `) as unknown as TypedDocumentString<GetLgpHeroStickyWidgetQuery, GetLgpHeroStickyWidgetQueryVariables>;
export const GetLgpHeroWidgetDocument = new TypedDocumentString(`
    query GetLgpHeroWidget($seasonAndCompId: ID!, $gpId: ID!) {
  getLgpHeroWidget(seasonAndCompId: $seasonAndCompId, gpId: $gpId) {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    info {
      flagImgUrl
      circuitImgUrl
      customGpName
      startDate
      endDate
      sportTag
    }
    session {
      status
      name
      label
      podium {
        customDriverName
        customDriverSurname
        customDriverShortName
        flagImgUrl
        driverImgUrl
        position
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetLgpHeroWidgetQuery, GetLgpHeroWidgetQueryVariables>;
export const GetLgpPreviewWidgetDocument = new TypedDocumentString(`
    query GetLgpPreviewWidget($seasonAndCompId: ID!, $gpId: ID!) {
  getLgpPreviewWidget(seasonAndCompId: $seasonAndCompId, gpId: $gpId) {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    gpStartDateTime
    gpName
    laps
    lengthKm
    sportLabel
    sessions {
      sessionName
      date
    }
    calendar {
      link
      text
    }
    ranking {
      link
      text
    }
    results {
      link
      text
    }
    news {
      link
      text
    }
  }
}
    `) as unknown as TypedDocumentString<GetLgpPreviewWidgetQuery, GetLgpPreviewWidgetQueryVariables>;
export const GetLgpResultsContainerWidgetDocument = new TypedDocumentString(`
    query GetLgpResultsContainerWidget($seasonAndCompId: ID!, $gpId: ID!) {
  getLgpResultsContainerWidget(seasonAndCompId: $seasonAndCompId, gpId: $gpId) {
    gpId
    seasonAndCompId
    seasonId
    competitionId
    FP1 {
      customDataAttributes {
        tracking
        url
      }
      ssi
      startDateTime
    }
    FP2 {
      customDataAttributes {
        tracking
        url
      }
      ssi
      startDateTime
    }
    FP3 {
      customDataAttributes {
        tracking
        url
      }
      ssi
      startDateTime
    }
    FP4 {
      ssi
      customDataAttributes {
        tracking
        url
      }
      startDateTime
    }
    G {
      customDataAttributes {
        tracking
        url
      }
      ssi
      startDateTime
    }
    GS {
      customDataAttributes {
        tracking
        url
      }
      ssi
      startDateTime
    }
    Q {
      customDataAttributes {
        tracking
        url
      }
      ssi
      startDateTime
    }
    QS {
      customDataAttributes {
        tracking
        url
      }
      ssi
      startDateTime
    }
    R {
      customDataAttributes {
        tracking
        url
      }
      ssi
      startDateTime
    }
    SPRINT {
      customDataAttributes {
        tracking
        url
      }
      ssi
      startDateTime
    }
    SS {
      customDataAttributes {
        tracking
        url
      }
      ssi
      startDateTime
    }
  }
}
    `) as unknown as TypedDocumentString<GetLgpResultsContainerWidgetQuery, GetLgpResultsContainerWidgetQueryVariables>;
export const GetLgpResultsWidgetDocument = new TypedDocumentString(`
    query GetLgpResultsWidget($gpId: ID!, $sessionName: String!) {
  getLgpResultsWidget(sessionName: $sessionName, gpId: $gpId) {
    gpId
    gpStatus
    isCurrent
    seasonAndCompId
    sessionName
    seasonId
    competitionId
    calendar {
      link
      text
    }
    ranking {
      link
      text
    }
    results {
      link
      text
    }
    gpInfo {
      customGpName
      gpStatus
      isCurrent
      isExclusive
      isSprint
      lapRecord
      laps
      lengthKm
      startDateTime
    }
    sessions {
      isCurrent
      sessionInfo {
        isCurrent
        sessionLabel
        sessionName
        sessionStatus
        startDateTime
        details {
          customDriverName
          customDriverPageUrl
          customDriverSurname
          customTeamName
          customTeamPageUrl
          fastestLap
          flagUrl
          gap
          isFastestLap
          laps
          position
          status
          timing {
            timeHours
            timeMilliseconds
            timeMinutes
            timeSeconds
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetLgpResultsWidgetQuery, GetLgpResultsWidgetQueryVariables>;
export const GetLiveScoreWidgetDocument = new TypedDocumentString(`
    query GetLiveScoreWidget($id: ID!) {
  getLiveScoreWidget(id: $id) {
    previousDay {
      sportTag
      gpInfo {
        calendarUrl
        customGpName
        gpPageUrl
        rankingUrl
        gpFlag
        gpCrosslink
      }
      sessions {
        sessionDate
        sessionName
        sessionStatus
        resultsUrl
        results {
          customDriverName
          customDriverPageUrl
          customDriverSurname
          customTeamName
          customTeamPageUrl
          fastestLap
          firstName
          flagUrl
          gap
          isFastestLap
          lastName
          position
          teamName
          timing {
            timeHours
            timeMilliseconds
            timeMinutes
            timeSeconds
          }
        }
      }
    }
    currentDay {
      sportTag
      gpInfo {
        calendarUrl
        customGpName
        gpPageUrl
        rankingUrl
        gpFlag
        gpCrosslink
      }
      sessions {
        sessionDate
        sessionName
        sessionStatus
        resultsUrl
        results {
          customDriverName
          customDriverPageUrl
          customDriverSurname
          customTeamName
          customTeamPageUrl
          fastestLap
          firstName
          flagUrl
          gap
          isFastestLap
          lastName
          position
          teamName
          timing {
            timeHours
            timeMilliseconds
            timeMinutes
            timeSeconds
          }
        }
      }
    }
    nextDay {
      sportTag
      gpInfo {
        calendarUrl
        customGpName
        gpPageUrl
        rankingUrl
        gpFlag
        gpCrosslink
      }
      sessions {
        sessionDate
        sessionName
        sessionStatus
        resultsUrl
        results {
          customDriverName
          customDriverPageUrl
          customDriverSurname
          customTeamName
          customTeamPageUrl
          fastestLap
          firstName
          flagUrl
          gap
          isFastestLap
          lastName
          position
          teamName
          timing {
            timeHours
            timeMilliseconds
            timeMinutes
            timeSeconds
          }
        }
      }
    }
    id
  }
}
    `) as unknown as TypedDocumentString<GetLiveScoreWidgetQuery, GetLiveScoreWidgetQueryVariables>;
export const GetGpPodiumListWidgetDocument = new TypedDocumentString(`
    query GetGpPodiumListWidget($seasonAndCompId: ID!) {
  getGpPodiumListWidget(seasonAndCompId: $seasonAndCompId) {
    competitionId
    seasonAndCompId
    seasonId
    grandPrixList {
      gpStatus
      isCurrent
      gpInfo {
        customGpName
        gpPageUrl
        gpStatus
        isCurrent
        isExclusive
        isSprint
        lapRecord
        laps
        lengthKm
        startDateTime
        gpCrosslink
      }
      session {
        isCurrent
        sessionLabel
        sessionStatus
        sessionInfo {
          isCurrent
          sessionLabel
          sessionName
          sessionStatus
          startDateTime
          details {
            customDriverName
            customDriverSurname
            customDriverPageUrl
            customTeamName
            customTeamPageUrl
            fastestLap
            firstName
            flagUrl
            gap
            isFastestLap
            laps
            lastName
            position
            status
            points {
              personPoints
              teamPoints
            }
            team {
              name
            }
            timing {
              timeHours
              timeMilliseconds
              timeMinutes
              timeSeconds
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetGpPodiumListWidgetQuery, GetGpPodiumListWidgetQueryVariables>;
export const GetSeasonRankingGalleryWidgetDocument = new TypedDocumentString(`
    query GetSeasonRankingGalleryWidget($seasonAndCompId: ID!) {
  getSeasonRankingGalleryWidget(seasonAndCompId: $seasonAndCompId) {
    seasonAndCompId
    seasonId
    competitionId
    competitionsSlugName
    competitionName
    drivers {
      teamId
      driverId
      driverFirstname
      driverSurname
      teamName
      teamUrl
      logoUrl
      position
      points
      driverPageLink
      driverImageUrl
    }
    teams {
      teamId
      teamName
      teamUrl
      logoUrl
      position
      points
      teamImageUrl
    }
  }
}
    `) as unknown as TypedDocumentString<GetSeasonRankingGalleryWidgetQuery, GetSeasonRankingGalleryWidgetQueryVariables>;
export const GetTeamDriverPageWidgetDocument = new TypedDocumentString(`
    query GetTeamDriverPageWidget($seasonAndCompId: ID!) {
  getTeamDriverPageWidget(seasonAndCompId: $seasonAndCompId) {
    seasonAndCompId
    seasonId
    competitionId
    teamList {
      position
      teamLogoUrl
      teamName
      teamUrl
      drivers {
        name
        imageUrl
        position
        url
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetTeamDriverPageWidgetQuery, GetTeamDriverPageWidgetQueryVariables>;
export const GetTeamRankingWidgetDocument = new TypedDocumentString(`
    query GetTeamRankingWidget($seasonAndCompId: ID!) {
  getTeamRankingWidget(seasonAndCompId: $seasonAndCompId) {
    items {
      customTeamPageUrl
      pos
      pts
      teamName
    }
    competitionLabel
    seasonAndCompId
    seasonId
    competitionId
  }
}
    `) as unknown as TypedDocumentString<GetTeamRankingWidgetQuery, GetTeamRankingWidgetQueryVariables>;
export const onCreateCardDriverRankingWidgetDocument = new TypedDocumentString(`
    subscription onCreateCardDriverRankingWidget {
  onCreateCardDriverRankingWidget {
    competitionId
    customCompetitionName
    rankingLink
    drivers {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateCardDriverRankingWidgetSubscription, onCreateCardDriverRankingWidgetSubscriptionVariables>;
export const onCreateCardGpCalendarWidgetDocument = new TypedDocumentString(`
    subscription onCreateCardGpCalendarWidget {
  onCreateCardGpCalendarWidget {
    competitionId
    customCompetitionName
    calendarLink
    gpList {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateCardGpCalendarWidgetSubscription, onCreateCardGpCalendarWidgetSubscriptionVariables>;
export const onCreateCardGpResultsWidgetDocument = new TypedDocumentString(`
    subscription onCreateCardGpResultsWidget {
  onCreateCardGpResultsWidget {
    competitionId
    customCompetitionName
    customGpName
    resultsLink
    isSprint
    results {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateCardGpResultsWidgetSubscription, onCreateCardGpResultsWidgetSubscriptionVariables>;
export const onCreateCardTeamRankingWidgetDocument = new TypedDocumentString(`
    subscription onCreateCardTeamRankingWidget {
  onCreateCardTeamRankingWidget {
    competitionId
    customCompetitionName
    rankingLink
    teams {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateCardTeamRankingWidgetSubscription, onCreateCardTeamRankingWidgetSubscriptionVariables>;
export const onCreateCompetitionDocument = new TypedDocumentString(`
    subscription onCreateCompetition {
  onCreateCompetition {
    seasonAndCompId
    seasonId
    competitionId
    competitionJson
    editorialDataId
    previousSeasonAndCompId
    season {
      __typename
    }
    previousCompetition {
      __typename
    }
    editorialData {
      __typename
    }
    teams {
      __typename
    }
    drivers {
      __typename
    }
    grandPrixes {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateCompetitionSubscription, onCreateCompetitionSubscriptionVariables>;
export const onCreateCrossLinkDocument = new TypedDocumentString(`
    subscription onCreateCrossLink {
  onCreateCrossLink {
    seasonAndCompId
    gpId
    crossLinkJson
  }
}
    `) as unknown as TypedDocumentString<onCreateCrossLinkSubscription, onCreateCrossLinkSubscriptionVariables>;
export const onCreateDriverDocument = new TypedDocumentString(`
    subscription onCreateDriver {
  onCreateDriver {
    seasonAndCompId
    driverId
    teamId
    editorialDataId
    driverJson
    competition {
      __typename
    }
    editorialData {
      __typename
    }
    team {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateDriverSubscription, onCreateDriverSubscriptionVariables>;
export const onCreateDriverRankingWidgetDocument = new TypedDocumentString(`
    subscription onCreateDriverRankingWidget {
  onCreateDriverRankingWidget {
    seasonAndCompId
    seasonId
    competitionId
    competitionLabel
    items {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateDriverRankingWidgetSubscription, onCreateDriverRankingWidgetSubscriptionVariables>;
export const onCreateDriverStatsWidgetDocument = new TypedDocumentString(`
    subscription onCreateDriverStatsWidget {
  onCreateDriverStatsWidget {
    driverId
    seasonAndCompId
    customSeasonName
    customCompetitionName
    statistics {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateDriverStatsWidgetSubscription, onCreateDriverStatsWidgetSubscriptionVariables>;
export const onCreateEditorialDataDocument = new TypedDocumentString(`
    subscription onCreateEditorialData {
  onCreateEditorialData {
    editorialDataId
    seasonAndCompId
    isCurrent
    editorialJson
    competition {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateEditorialDataSubscription, onCreateEditorialDataSubscriptionVariables>;
export const onCreateGpCalendarWidgetDocument = new TypedDocumentString(`
    subscription onCreateGpCalendarWidget {
  onCreateGpCalendarWidget {
    seasonAndCompId
    seasonId
    competitionId
    items {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateGpCalendarWidgetSubscription, onCreateGpCalendarWidgetSubscriptionVariables>;
export const onCreateGpCurrentCalendarWidgetDocument = new TypedDocumentString(`
    subscription onCreateGpCurrentCalendarWidget {
  onCreateGpCurrentCalendarWidget {
    seasonAndCompId
    seasonId
    competitionId
    items {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateGpCurrentCalendarWidgetSubscription, onCreateGpCurrentCalendarWidgetSubscriptionVariables>;
export const onCreateGpDataDocument = new TypedDocumentString(`
    subscription onCreateGpData {
  onCreateGpData {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    messageType
    data
  }
}
    `) as unknown as TypedDocumentString<onCreateGpDataSubscription, onCreateGpDataSubscriptionVariables>;
export const onCreateGpLiveContainerWidgetDocument = new TypedDocumentString(`
    subscription onCreateGpLiveContainerWidget {
  onCreateGpLiveContainerWidget {
    seasonAndCompId
    seasonId
    competitionId
    R {
      __typename
    }
    G {
      __typename
    }
    TS {
      __typename
    }
    DS {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateGpLiveContainerWidgetSubscription, onCreateGpLiveContainerWidgetSubscriptionVariables>;
export const onCreateGpLiveHeroWidgetDocument = new TypedDocumentString(`
    subscription onCreateGpLiveHeroWidget {
  onCreateGpLiveHeroWidget {
    seasonAndCompId
    seasonId
    competitionId
    gpInfo {
      __typename
    }
    isCurrent
  }
}
    `) as unknown as TypedDocumentString<onCreateGpLiveHeroWidgetSubscription, onCreateGpLiveHeroWidgetSubscriptionVariables>;
export const onCreateGpPodiumListWidgetDocument = new TypedDocumentString(`
    subscription onCreateGpPodiumListWidget {
  onCreateGpPodiumListWidget {
    seasonAndCompId
    seasonId
    competitionId
    grandPrixList {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateGpPodiumListWidgetSubscription, onCreateGpPodiumListWidgetSubscriptionVariables>;
export const onCreateGpResultsContainerWidgetDocument = new TypedDocumentString(`
    subscription onCreateGpResultsContainerWidget {
  onCreateGpResultsContainerWidget {
    seasonAndCompId
    seasonId
    competitionId
    gpId
    R {
      __typename
    }
    G {
      __typename
    }
    Q {
      __typename
    }
    FP4 {
      __typename
    }
    FP3 {
      __typename
    }
    FP2 {
      __typename
    }
    FP1 {
      __typename
    }
    SPRINT {
      __typename
    }
    SS {
      __typename
    }
    GS {
      __typename
    }
    QS {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateGpResultsContainerWidgetSubscription, onCreateGpResultsContainerWidgetSubscriptionVariables>;
export const onCreateGpResultsWidgetDocument = new TypedDocumentString(`
    subscription onCreateGpResultsWidget {
  onCreateGpResultsWidget {
    seasonAndCompId
    seasonId
    competitionId
    gpId
    sessionName
    isCurrent
    gpStatus
    gpInfo {
      __typename
    }
    sessions {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateGpResultsWidgetSubscription, onCreateGpResultsWidgetSubscriptionVariables>;
export const onCreateGrandPrixDocument = new TypedDocumentString(`
    subscription onCreateGrandPrix {
  onCreateGrandPrix {
    gpId
    seasonAndCompId
    status
    isCurrent
    date
    gpJson
    editorialDataId
    editorialData {
      __typename
    }
    sessions {
      __typename
    }
    crossLink {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateGrandPrixSubscription, onCreateGrandPrixSubscriptionVariables>;
export const onCreateLgpHeroStickyWidgetDocument = new TypedDocumentString(`
    subscription onCreateLgpHeroStickyWidget {
  onCreateLgpHeroStickyWidget {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    info {
      __typename
    }
    session {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateLgpHeroStickyWidgetSubscription, onCreateLgpHeroStickyWidgetSubscriptionVariables>;
export const onCreateLgpHeroWidgetDocument = new TypedDocumentString(`
    subscription onCreateLgpHeroWidget {
  onCreateLgpHeroWidget {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    info {
      __typename
    }
    session {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateLgpHeroWidgetSubscription, onCreateLgpHeroWidgetSubscriptionVariables>;
export const onCreateLgpPreviewWidgetDocument = new TypedDocumentString(`
    subscription onCreateLgpPreviewWidget {
  onCreateLgpPreviewWidget {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    gpStartDateTime
    gpName
    laps
    lengthKm
    sportLabel
    sessions {
      __typename
    }
    calendar {
      __typename
    }
    ranking {
      __typename
    }
    results {
      __typename
    }
    news {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateLgpPreviewWidgetSubscription, onCreateLgpPreviewWidgetSubscriptionVariables>;
export const onCreateLgpResultsContainerWidgetDocument = new TypedDocumentString(`
    subscription onCreateLgpResultsContainerWidget {
  onCreateLgpResultsContainerWidget {
    seasonAndCompId
    seasonId
    competitionId
    gpId
    R {
      __typename
    }
    G {
      __typename
    }
    Q {
      __typename
    }
    FP4 {
      __typename
    }
    FP3 {
      __typename
    }
    FP2 {
      __typename
    }
    FP1 {
      __typename
    }
    SPRINT {
      __typename
    }
    SS {
      __typename
    }
    GS {
      __typename
    }
    QS {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateLgpResultsContainerWidgetSubscription, onCreateLgpResultsContainerWidgetSubscriptionVariables>;
export const onCreateLgpResultsWidgetDocument = new TypedDocumentString(`
    subscription onCreateLgpResultsWidget {
  onCreateLgpResultsWidget {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    sessionName
    isCurrent
    gpStatus
    calendar {
      __typename
    }
    ranking {
      __typename
    }
    results {
      __typename
    }
    gpInfo {
      __typename
    }
    sessions {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateLgpResultsWidgetSubscription, onCreateLgpResultsWidgetSubscriptionVariables>;
export const onCreateLiveScoreWidgetDocument = new TypedDocumentString(`
    subscription onCreateLiveScoreWidget {
  onCreateLiveScoreWidget {
    id
    previousDay {
      __typename
    }
    currentDay {
      __typename
    }
    nextDay {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateLiveScoreWidgetSubscription, onCreateLiveScoreWidgetSubscriptionVariables>;
export const onCreateSeasonDocument = new TypedDocumentString(`
    subscription onCreateSeason {
  onCreateSeason {
    seasonId
    seasonJson
    competitions {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateSeasonSubscription, onCreateSeasonSubscriptionVariables>;
export const onCreateSeasonRankingGalleryWidgetDocument = new TypedDocumentString(`
    subscription onCreateSeasonRankingGalleryWidget {
  onCreateSeasonRankingGalleryWidget {
    seasonAndCompId
    seasonId
    competitionId
    competitionsSlugName
    competitionName
    drivers {
      __typename
    }
    teams {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateSeasonRankingGalleryWidgetSubscription, onCreateSeasonRankingGalleryWidgetSubscriptionVariables>;
export const onCreateSessionDocument = new TypedDocumentString(`
    subscription onCreateSession {
  onCreateSession {
    sessionId
    gpId
    seasonAndCompId
    status
    isCurrent
    date
    sessionJson
  }
}
    `) as unknown as TypedDocumentString<onCreateSessionSubscription, onCreateSessionSubscriptionVariables>;
export const onCreateTeamDocument = new TypedDocumentString(`
    subscription onCreateTeam {
  onCreateTeam {
    seasonAndCompId
    teamId
    teamJson
    editorialDataId
    competition {
      __typename
    }
    editorialData {
      __typename
    }
    drivers {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateTeamSubscription, onCreateTeamSubscriptionVariables>;
export const onCreateTeamDriverPageWidgetDocument = new TypedDocumentString(`
    subscription onCreateTeamDriverPageWidget {
  onCreateTeamDriverPageWidget {
    seasonAndCompId
    seasonId
    competitionId
    teamList {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateTeamDriverPageWidgetSubscription, onCreateTeamDriverPageWidgetSubscriptionVariables>;
export const onCreateTeamRankingWidgetDocument = new TypedDocumentString(`
    subscription onCreateTeamRankingWidget {
  onCreateTeamRankingWidget {
    seasonAndCompId
    seasonId
    competitionId
    competitionLabel
    items {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onCreateTeamRankingWidgetSubscription, onCreateTeamRankingWidgetSubscriptionVariables>;
export const onDeleteCardDriverRankingWidgetDocument = new TypedDocumentString(`
    subscription onDeleteCardDriverRankingWidget {
  onDeleteCardDriverRankingWidget {
    competitionId
    customCompetitionName
    rankingLink
    drivers {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteCardDriverRankingWidgetSubscription, onDeleteCardDriverRankingWidgetSubscriptionVariables>;
export const onDeleteCardGpCalendarWidgetDocument = new TypedDocumentString(`
    subscription onDeleteCardGpCalendarWidget {
  onDeleteCardGpCalendarWidget {
    competitionId
    customCompetitionName
    calendarLink
    gpList {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteCardGpCalendarWidgetSubscription, onDeleteCardGpCalendarWidgetSubscriptionVariables>;
export const onDeleteCardGpResultsWidgetDocument = new TypedDocumentString(`
    subscription onDeleteCardGpResultsWidget {
  onDeleteCardGpResultsWidget {
    competitionId
    customCompetitionName
    customGpName
    resultsLink
    isSprint
    results {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteCardGpResultsWidgetSubscription, onDeleteCardGpResultsWidgetSubscriptionVariables>;
export const onDeleteCardTeamRankingWidgetDocument = new TypedDocumentString(`
    subscription onDeleteCardTeamRankingWidget {
  onDeleteCardTeamRankingWidget {
    competitionId
    customCompetitionName
    rankingLink
    teams {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteCardTeamRankingWidgetSubscription, onDeleteCardTeamRankingWidgetSubscriptionVariables>;
export const onDeleteCompetitionDocument = new TypedDocumentString(`
    subscription onDeleteCompetition {
  onDeleteCompetition {
    seasonAndCompId
    seasonId
    competitionId
    competitionJson
    editorialDataId
    previousSeasonAndCompId
    season {
      __typename
    }
    previousCompetition {
      __typename
    }
    editorialData {
      __typename
    }
    teams {
      __typename
    }
    drivers {
      __typename
    }
    grandPrixes {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteCompetitionSubscription, onDeleteCompetitionSubscriptionVariables>;
export const onDeleteCrossLinkDocument = new TypedDocumentString(`
    subscription onDeleteCrossLink {
  onDeleteCrossLink {
    seasonAndCompId
    gpId
    crossLinkJson
  }
}
    `) as unknown as TypedDocumentString<onDeleteCrossLinkSubscription, onDeleteCrossLinkSubscriptionVariables>;
export const onDeleteDriverDocument = new TypedDocumentString(`
    subscription onDeleteDriver {
  onDeleteDriver {
    seasonAndCompId
    driverId
    teamId
    editorialDataId
    driverJson
    competition {
      __typename
    }
    editorialData {
      __typename
    }
    team {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteDriverSubscription, onDeleteDriverSubscriptionVariables>;
export const onDeleteDriverRankingWidgetDocument = new TypedDocumentString(`
    subscription onDeleteDriverRankingWidget {
  onDeleteDriverRankingWidget {
    seasonAndCompId
    seasonId
    competitionId
    competitionLabel
    items {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteDriverRankingWidgetSubscription, onDeleteDriverRankingWidgetSubscriptionVariables>;
export const onDeleteDriverStatsWidgetDocument = new TypedDocumentString(`
    subscription onDeleteDriverStatsWidget {
  onDeleteDriverStatsWidget {
    driverId
    seasonAndCompId
    customSeasonName
    customCompetitionName
    statistics {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteDriverStatsWidgetSubscription, onDeleteDriverStatsWidgetSubscriptionVariables>;
export const onDeleteEditorialDataDocument = new TypedDocumentString(`
    subscription onDeleteEditorialData {
  onDeleteEditorialData {
    editorialDataId
    seasonAndCompId
    isCurrent
    editorialJson
    competition {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteEditorialDataSubscription, onDeleteEditorialDataSubscriptionVariables>;
export const onDeleteGpCalendarWidgetDocument = new TypedDocumentString(`
    subscription onDeleteGpCalendarWidget {
  onDeleteGpCalendarWidget {
    seasonAndCompId
    seasonId
    competitionId
    items {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteGpCalendarWidgetSubscription, onDeleteGpCalendarWidgetSubscriptionVariables>;
export const onDeleteGpCurrentCalendarWidgetDocument = new TypedDocumentString(`
    subscription onDeleteGpCurrentCalendarWidget {
  onDeleteGpCurrentCalendarWidget {
    seasonAndCompId
    seasonId
    competitionId
    items {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteGpCurrentCalendarWidgetSubscription, onDeleteGpCurrentCalendarWidgetSubscriptionVariables>;
export const onDeleteGpDataDocument = new TypedDocumentString(`
    subscription onDeleteGpData {
  onDeleteGpData {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    messageType
    data
  }
}
    `) as unknown as TypedDocumentString<onDeleteGpDataSubscription, onDeleteGpDataSubscriptionVariables>;
export const onDeleteGpLiveContainerWidgetDocument = new TypedDocumentString(`
    subscription onDeleteGpLiveContainerWidget {
  onDeleteGpLiveContainerWidget {
    seasonAndCompId
    seasonId
    competitionId
    R {
      __typename
    }
    G {
      __typename
    }
    TS {
      __typename
    }
    DS {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteGpLiveContainerWidgetSubscription, onDeleteGpLiveContainerWidgetSubscriptionVariables>;
export const onDeleteGpLiveHeroWidgetDocument = new TypedDocumentString(`
    subscription onDeleteGpLiveHeroWidget {
  onDeleteGpLiveHeroWidget {
    seasonAndCompId
    seasonId
    competitionId
    gpInfo {
      __typename
    }
    isCurrent
  }
}
    `) as unknown as TypedDocumentString<onDeleteGpLiveHeroWidgetSubscription, onDeleteGpLiveHeroWidgetSubscriptionVariables>;
export const onDeleteGpPodiumListWidgetDocument = new TypedDocumentString(`
    subscription onDeleteGpPodiumListWidget {
  onDeleteGpPodiumListWidget {
    seasonAndCompId
    seasonId
    competitionId
    grandPrixList {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteGpPodiumListWidgetSubscription, onDeleteGpPodiumListWidgetSubscriptionVariables>;
export const onDeleteGpResultsContainerWidgetDocument = new TypedDocumentString(`
    subscription onDeleteGpResultsContainerWidget {
  onDeleteGpResultsContainerWidget {
    seasonAndCompId
    seasonId
    competitionId
    gpId
    R {
      __typename
    }
    G {
      __typename
    }
    Q {
      __typename
    }
    FP4 {
      __typename
    }
    FP3 {
      __typename
    }
    FP2 {
      __typename
    }
    FP1 {
      __typename
    }
    SPRINT {
      __typename
    }
    SS {
      __typename
    }
    GS {
      __typename
    }
    QS {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteGpResultsContainerWidgetSubscription, onDeleteGpResultsContainerWidgetSubscriptionVariables>;
export const onDeleteGpResultsWidgetDocument = new TypedDocumentString(`
    subscription onDeleteGpResultsWidget {
  onDeleteGpResultsWidget {
    seasonAndCompId
    seasonId
    competitionId
    gpId
    sessionName
    isCurrent
    gpStatus
    gpInfo {
      __typename
    }
    sessions {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteGpResultsWidgetSubscription, onDeleteGpResultsWidgetSubscriptionVariables>;
export const onDeleteGrandPrixDocument = new TypedDocumentString(`
    subscription onDeleteGrandPrix {
  onDeleteGrandPrix {
    gpId
    seasonAndCompId
    status
    isCurrent
    date
    gpJson
    editorialDataId
    editorialData {
      __typename
    }
    sessions {
      __typename
    }
    crossLink {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteGrandPrixSubscription, onDeleteGrandPrixSubscriptionVariables>;
export const onDeleteLgpHeroStickyWidgetDocument = new TypedDocumentString(`
    subscription onDeleteLgpHeroStickyWidget {
  onDeleteLgpHeroStickyWidget {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    info {
      __typename
    }
    session {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteLgpHeroStickyWidgetSubscription, onDeleteLgpHeroStickyWidgetSubscriptionVariables>;
export const onDeleteLgpHeroWidgetDocument = new TypedDocumentString(`
    subscription onDeleteLgpHeroWidget {
  onDeleteLgpHeroWidget {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    info {
      __typename
    }
    session {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteLgpHeroWidgetSubscription, onDeleteLgpHeroWidgetSubscriptionVariables>;
export const onDeleteLgpPreviewWidgetDocument = new TypedDocumentString(`
    subscription onDeleteLgpPreviewWidget {
  onDeleteLgpPreviewWidget {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    gpStartDateTime
    gpName
    laps
    lengthKm
    sportLabel
    sessions {
      __typename
    }
    calendar {
      __typename
    }
    ranking {
      __typename
    }
    results {
      __typename
    }
    news {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteLgpPreviewWidgetSubscription, onDeleteLgpPreviewWidgetSubscriptionVariables>;
export const onDeleteLgpResultsContainerWidgetDocument = new TypedDocumentString(`
    subscription onDeleteLgpResultsContainerWidget {
  onDeleteLgpResultsContainerWidget {
    seasonAndCompId
    seasonId
    competitionId
    gpId
    R {
      __typename
    }
    G {
      __typename
    }
    Q {
      __typename
    }
    FP4 {
      __typename
    }
    FP3 {
      __typename
    }
    FP2 {
      __typename
    }
    FP1 {
      __typename
    }
    SPRINT {
      __typename
    }
    SS {
      __typename
    }
    GS {
      __typename
    }
    QS {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteLgpResultsContainerWidgetSubscription, onDeleteLgpResultsContainerWidgetSubscriptionVariables>;
export const onDeleteLgpResultsWidgetDocument = new TypedDocumentString(`
    subscription onDeleteLgpResultsWidget {
  onDeleteLgpResultsWidget {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    sessionName
    isCurrent
    gpStatus
    calendar {
      __typename
    }
    ranking {
      __typename
    }
    results {
      __typename
    }
    gpInfo {
      __typename
    }
    sessions {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteLgpResultsWidgetSubscription, onDeleteLgpResultsWidgetSubscriptionVariables>;
export const onDeleteLiveScoreWidgetDocument = new TypedDocumentString(`
    subscription onDeleteLiveScoreWidget {
  onDeleteLiveScoreWidget {
    id
    previousDay {
      __typename
    }
    currentDay {
      __typename
    }
    nextDay {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteLiveScoreWidgetSubscription, onDeleteLiveScoreWidgetSubscriptionVariables>;
export const onDeleteSeasonDocument = new TypedDocumentString(`
    subscription onDeleteSeason {
  onDeleteSeason {
    seasonId
    seasonJson
    competitions {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteSeasonSubscription, onDeleteSeasonSubscriptionVariables>;
export const onDeleteSeasonRankingGalleryWidgetDocument = new TypedDocumentString(`
    subscription onDeleteSeasonRankingGalleryWidget {
  onDeleteSeasonRankingGalleryWidget {
    seasonAndCompId
    seasonId
    competitionId
    competitionsSlugName
    competitionName
    drivers {
      __typename
    }
    teams {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteSeasonRankingGalleryWidgetSubscription, onDeleteSeasonRankingGalleryWidgetSubscriptionVariables>;
export const onDeleteSessionDocument = new TypedDocumentString(`
    subscription onDeleteSession {
  onDeleteSession {
    sessionId
    gpId
    seasonAndCompId
    status
    isCurrent
    date
    sessionJson
  }
}
    `) as unknown as TypedDocumentString<onDeleteSessionSubscription, onDeleteSessionSubscriptionVariables>;
export const onDeleteTeamDocument = new TypedDocumentString(`
    subscription onDeleteTeam {
  onDeleteTeam {
    seasonAndCompId
    teamId
    teamJson
    editorialDataId
    competition {
      __typename
    }
    editorialData {
      __typename
    }
    drivers {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteTeamSubscription, onDeleteTeamSubscriptionVariables>;
export const onDeleteTeamDriverPageWidgetDocument = new TypedDocumentString(`
    subscription onDeleteTeamDriverPageWidget {
  onDeleteTeamDriverPageWidget {
    seasonAndCompId
    seasonId
    competitionId
    teamList {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteTeamDriverPageWidgetSubscription, onDeleteTeamDriverPageWidgetSubscriptionVariables>;
export const onDeleteTeamRankingWidgetDocument = new TypedDocumentString(`
    subscription onDeleteTeamRankingWidget {
  onDeleteTeamRankingWidget {
    seasonAndCompId
    seasonId
    competitionId
    competitionLabel
    items {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onDeleteTeamRankingWidgetSubscription, onDeleteTeamRankingWidgetSubscriptionVariables>;
export const onUpdateCardDriverRankingWidgetDocument = new TypedDocumentString(`
    subscription onUpdateCardDriverRankingWidget {
  onUpdateCardDriverRankingWidget {
    competitionId
    customCompetitionName
    rankingLink
    drivers {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateCardDriverRankingWidgetSubscription, onUpdateCardDriverRankingWidgetSubscriptionVariables>;
export const onUpdateCardGpCalendarWidgetDocument = new TypedDocumentString(`
    subscription onUpdateCardGpCalendarWidget {
  onUpdateCardGpCalendarWidget {
    competitionId
    customCompetitionName
    calendarLink
    gpList {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateCardGpCalendarWidgetSubscription, onUpdateCardGpCalendarWidgetSubscriptionVariables>;
export const onUpdateCardGpResultsWidgetDocument = new TypedDocumentString(`
    subscription onUpdateCardGpResultsWidget {
  onUpdateCardGpResultsWidget {
    competitionId
    customCompetitionName
    customGpName
    resultsLink
    isSprint
    results {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateCardGpResultsWidgetSubscription, onUpdateCardGpResultsWidgetSubscriptionVariables>;
export const onUpdateCardTeamRankingWidgetDocument = new TypedDocumentString(`
    subscription onUpdateCardTeamRankingWidget {
  onUpdateCardTeamRankingWidget {
    competitionId
    customCompetitionName
    rankingLink
    teams {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateCardTeamRankingWidgetSubscription, onUpdateCardTeamRankingWidgetSubscriptionVariables>;
export const onUpdateCompetitionDocument = new TypedDocumentString(`
    subscription onUpdateCompetition {
  onUpdateCompetition {
    seasonAndCompId
    seasonId
    competitionId
    competitionJson
    editorialDataId
    previousSeasonAndCompId
    season {
      __typename
    }
    previousCompetition {
      __typename
    }
    editorialData {
      __typename
    }
    teams {
      __typename
    }
    drivers {
      __typename
    }
    grandPrixes {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateCompetitionSubscription, onUpdateCompetitionSubscriptionVariables>;
export const onUpdateCrossLinkDocument = new TypedDocumentString(`
    subscription onUpdateCrossLink {
  onUpdateCrossLink {
    seasonAndCompId
    gpId
    crossLinkJson
  }
}
    `) as unknown as TypedDocumentString<onUpdateCrossLinkSubscription, onUpdateCrossLinkSubscriptionVariables>;
export const onUpdateDriverDocument = new TypedDocumentString(`
    subscription onUpdateDriver {
  onUpdateDriver {
    seasonAndCompId
    driverId
    teamId
    editorialDataId
    driverJson
    competition {
      __typename
    }
    editorialData {
      __typename
    }
    team {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateDriverSubscription, onUpdateDriverSubscriptionVariables>;
export const onUpdateDriverRankingWidgetDocument = new TypedDocumentString(`
    subscription onUpdateDriverRankingWidget {
  onUpdateDriverRankingWidget {
    seasonAndCompId
    seasonId
    competitionId
    competitionLabel
    items {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateDriverRankingWidgetSubscription, onUpdateDriverRankingWidgetSubscriptionVariables>;
export const onUpdateDriverStatsWidgetDocument = new TypedDocumentString(`
    subscription onUpdateDriverStatsWidget {
  onUpdateDriverStatsWidget {
    driverId
    seasonAndCompId
    customSeasonName
    customCompetitionName
    statistics {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateDriverStatsWidgetSubscription, onUpdateDriverStatsWidgetSubscriptionVariables>;
export const onUpdateEditorialDataDocument = new TypedDocumentString(`
    subscription onUpdateEditorialData {
  onUpdateEditorialData {
    editorialDataId
    seasonAndCompId
    isCurrent
    editorialJson
    competition {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateEditorialDataSubscription, onUpdateEditorialDataSubscriptionVariables>;
export const onUpdateGpCalendarWidgetDocument = new TypedDocumentString(`
    subscription onUpdateGpCalendarWidget {
  onUpdateGpCalendarWidget {
    seasonAndCompId
    seasonId
    competitionId
    items {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateGpCalendarWidgetSubscription, onUpdateGpCalendarWidgetSubscriptionVariables>;
export const onUpdateGpCurrentCalendarWidgetDocument = new TypedDocumentString(`
    subscription onUpdateGpCurrentCalendarWidget {
  onUpdateGpCurrentCalendarWidget {
    seasonAndCompId
    seasonId
    competitionId
    items {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateGpCurrentCalendarWidgetSubscription, onUpdateGpCurrentCalendarWidgetSubscriptionVariables>;
export const onUpdateGpDataDocument = new TypedDocumentString(`
    subscription onUpdateGpData {
  onUpdateGpData {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    messageType
    data
  }
}
    `) as unknown as TypedDocumentString<onUpdateGpDataSubscription, onUpdateGpDataSubscriptionVariables>;
export const onUpdateGpLiveContainerWidgetDocument = new TypedDocumentString(`
    subscription onUpdateGpLiveContainerWidget {
  onUpdateGpLiveContainerWidget {
    seasonAndCompId
    seasonId
    competitionId
    R {
      __typename
    }
    G {
      __typename
    }
    TS {
      __typename
    }
    DS {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateGpLiveContainerWidgetSubscription, onUpdateGpLiveContainerWidgetSubscriptionVariables>;
export const onUpdateGpLiveHeroWidgetDocument = new TypedDocumentString(`
    subscription onUpdateGpLiveHeroWidget {
  onUpdateGpLiveHeroWidget {
    seasonAndCompId
    seasonId
    competitionId
    gpInfo {
      __typename
    }
    isCurrent
  }
}
    `) as unknown as TypedDocumentString<onUpdateGpLiveHeroWidgetSubscription, onUpdateGpLiveHeroWidgetSubscriptionVariables>;
export const onUpdateGpPodiumListWidgetDocument = new TypedDocumentString(`
    subscription onUpdateGpPodiumListWidget {
  onUpdateGpPodiumListWidget {
    seasonAndCompId
    seasonId
    competitionId
    grandPrixList {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateGpPodiumListWidgetSubscription, onUpdateGpPodiumListWidgetSubscriptionVariables>;
export const onUpdateGpResultsContainerWidgetDocument = new TypedDocumentString(`
    subscription onUpdateGpResultsContainerWidget {
  onUpdateGpResultsContainerWidget {
    seasonAndCompId
    seasonId
    competitionId
    gpId
    R {
      __typename
    }
    G {
      __typename
    }
    Q {
      __typename
    }
    FP4 {
      __typename
    }
    FP3 {
      __typename
    }
    FP2 {
      __typename
    }
    FP1 {
      __typename
    }
    SPRINT {
      __typename
    }
    SS {
      __typename
    }
    GS {
      __typename
    }
    QS {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateGpResultsContainerWidgetSubscription, onUpdateGpResultsContainerWidgetSubscriptionVariables>;
export const onUpdateGpResultsWidgetDocument = new TypedDocumentString(`
    subscription onUpdateGpResultsWidget {
  onUpdateGpResultsWidget {
    seasonAndCompId
    seasonId
    competitionId
    gpId
    sessionName
    isCurrent
    gpStatus
    gpInfo {
      __typename
    }
    sessions {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateGpResultsWidgetSubscription, onUpdateGpResultsWidgetSubscriptionVariables>;
export const onUpdateGpResultsWidgetByGpIdAndSessionNameDocument = new TypedDocumentString(`
    subscription onUpdateGpResultsWidgetByGpIdAndSessionName($gpId: ID!, $sessionName: String!) {
  onUpdateGpResultsWidgetByGpIdAndSessionName(
    gpId: $gpId
    sessionName: $sessionName
  ) {
    seasonAndCompId
    seasonId
    competitionId
    gpId
    sessionName
    isCurrent
    gpStatus
    gpInfo {
      __typename
    }
    sessions {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateGpResultsWidgetByGpIdAndSessionNameSubscription, onUpdateGpResultsWidgetByGpIdAndSessionNameSubscriptionVariables>;
export const onUpdateGrandPrixDocument = new TypedDocumentString(`
    subscription onUpdateGrandPrix {
  onUpdateGrandPrix {
    gpId
    seasonAndCompId
    status
    isCurrent
    date
    gpJson
    editorialDataId
    editorialData {
      __typename
    }
    sessions {
      __typename
    }
    crossLink {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateGrandPrixSubscription, onUpdateGrandPrixSubscriptionVariables>;
export const onUpdateLgpHeroStickyBySeasonAndCompIdAndGpIdDocument = new TypedDocumentString(`
    subscription onUpdateLgpHeroStickyBySeasonAndCompIdAndGpId($seasonAndCompId: ID!, $gpId: ID!) {
  onUpdateLgpHeroStickyBySeasonAndCompIdAndGpId(
    seasonAndCompId: $seasonAndCompId
    gpId: $gpId
  ) {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    info {
      __typename
    }
    session {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateLgpHeroStickyBySeasonAndCompIdAndGpIdSubscription, onUpdateLgpHeroStickyBySeasonAndCompIdAndGpIdSubscriptionVariables>;
export const onUpdateLgpHeroStickyWidgetDocument = new TypedDocumentString(`
    subscription onUpdateLgpHeroStickyWidget {
  onUpdateLgpHeroStickyWidget {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    info {
      __typename
    }
    session {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateLgpHeroStickyWidgetSubscription, onUpdateLgpHeroStickyWidgetSubscriptionVariables>;
export const onUpdateLgpHeroWidgetDocument = new TypedDocumentString(`
    subscription onUpdateLgpHeroWidget {
  onUpdateLgpHeroWidget {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    info {
      __typename
    }
    session {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateLgpHeroWidgetSubscription, onUpdateLgpHeroWidgetSubscriptionVariables>;
export const onUpdateLgpHeroWidgetBySeasonAndCompIdAndGpIdDocument = new TypedDocumentString(`
    subscription onUpdateLgpHeroWidgetBySeasonAndCompIdAndGpId($seasonAndCompId: ID!, $gpId: ID!) {
  onUpdateLgpHeroWidgetBySeasonAndCompIdAndGpId(
    seasonAndCompId: $seasonAndCompId
    gpId: $gpId
  ) {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    info {
      __typename
    }
    session {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateLgpHeroWidgetBySeasonAndCompIdAndGpIdSubscription, onUpdateLgpHeroWidgetBySeasonAndCompIdAndGpIdSubscriptionVariables>;
export const onUpdateLgpPreviewWidgetDocument = new TypedDocumentString(`
    subscription onUpdateLgpPreviewWidget {
  onUpdateLgpPreviewWidget {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    gpStartDateTime
    gpName
    laps
    lengthKm
    sportLabel
    sessions {
      __typename
    }
    calendar {
      __typename
    }
    ranking {
      __typename
    }
    results {
      __typename
    }
    news {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateLgpPreviewWidgetSubscription, onUpdateLgpPreviewWidgetSubscriptionVariables>;
export const onUpdateLgpPreviewWidgetBySeasonAndCompIdAndGpIdDocument = new TypedDocumentString(`
    subscription onUpdateLgpPreviewWidgetBySeasonAndCompIdAndGpId($seasonAndCompId: ID!, $gpId: ID!) {
  onUpdateLgpPreviewWidgetBySeasonAndCompIdAndGpId(
    seasonAndCompId: $seasonAndCompId
    gpId: $gpId
  ) {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    gpStartDateTime
    gpName
    laps
    lengthKm
    sportLabel
    sessions {
      __typename
    }
    calendar {
      __typename
    }
    ranking {
      __typename
    }
    results {
      __typename
    }
    news {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateLgpPreviewWidgetBySeasonAndCompIdAndGpIdSubscription, onUpdateLgpPreviewWidgetBySeasonAndCompIdAndGpIdSubscriptionVariables>;
export const onUpdateLgpResContainerBySeasonAndCompIdAndGpIdDocument = new TypedDocumentString(`
    subscription onUpdateLgpResContainerBySeasonAndCompIdAndGpId($seasonAndCompId: ID!, $gpId: ID!) {
  onUpdateLgpResContainerBySeasonAndCompIdAndGpId(
    seasonAndCompId: $seasonAndCompId
    gpId: $gpId
  ) {
    seasonAndCompId
    seasonId
    competitionId
    gpId
    R {
      __typename
    }
    G {
      __typename
    }
    Q {
      __typename
    }
    FP4 {
      __typename
    }
    FP3 {
      __typename
    }
    FP2 {
      __typename
    }
    FP1 {
      __typename
    }
    SPRINT {
      __typename
    }
    SS {
      __typename
    }
    GS {
      __typename
    }
    QS {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateLgpResContainerBySeasonAndCompIdAndGpIdSubscription, onUpdateLgpResContainerBySeasonAndCompIdAndGpIdSubscriptionVariables>;
export const onUpdateLgpResultsContainerWidgetDocument = new TypedDocumentString(`
    subscription onUpdateLgpResultsContainerWidget {
  onUpdateLgpResultsContainerWidget {
    seasonAndCompId
    seasonId
    competitionId
    gpId
    R {
      __typename
    }
    G {
      __typename
    }
    Q {
      __typename
    }
    FP4 {
      __typename
    }
    FP3 {
      __typename
    }
    FP2 {
      __typename
    }
    FP1 {
      __typename
    }
    SPRINT {
      __typename
    }
    SS {
      __typename
    }
    GS {
      __typename
    }
    QS {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateLgpResultsContainerWidgetSubscription, onUpdateLgpResultsContainerWidgetSubscriptionVariables>;
export const onUpdateLgpResultsWidgetDocument = new TypedDocumentString(`
    subscription onUpdateLgpResultsWidget {
  onUpdateLgpResultsWidget {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    sessionName
    isCurrent
    gpStatus
    calendar {
      __typename
    }
    ranking {
      __typename
    }
    results {
      __typename
    }
    gpInfo {
      __typename
    }
    sessions {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateLgpResultsWidgetSubscription, onUpdateLgpResultsWidgetSubscriptionVariables>;
export const onUpdateLgpResultsWidgetByGpIdAndSessionNameDocument = new TypedDocumentString(`
    subscription onUpdateLgpResultsWidgetByGpIdAndSessionName($gpId: ID!, $sessionName: String!) {
  onUpdateLgpResultsWidgetByGpIdAndSessionName(
    gpId: $gpId
    sessionName: $sessionName
  ) {
    seasonAndCompId
    gpId
    seasonId
    competitionId
    sessionName
    isCurrent
    gpStatus
    calendar {
      __typename
    }
    ranking {
      __typename
    }
    results {
      __typename
    }
    gpInfo {
      __typename
    }
    sessions {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateLgpResultsWidgetByGpIdAndSessionNameSubscription, onUpdateLgpResultsWidgetByGpIdAndSessionNameSubscriptionVariables>;
export const onUpdateLiveScoreWidgetDocument = new TypedDocumentString(`
    subscription onUpdateLiveScoreWidget {
  onUpdateLiveScoreWidget {
    id
    previousDay {
      __typename
    }
    currentDay {
      __typename
    }
    nextDay {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateLiveScoreWidgetSubscription, onUpdateLiveScoreWidgetSubscriptionVariables>;
export const onUpdateLiveScoreWidgetByIdDocument = new TypedDocumentString(`
    subscription onUpdateLiveScoreWidgetById($id: ID!) {
  onUpdateLiveScoreWidgetById(id: $id) {
    id
    previousDay {
      __typename
    }
    currentDay {
      __typename
    }
    nextDay {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateLiveScoreWidgetByIdSubscription, onUpdateLiveScoreWidgetByIdSubscriptionVariables>;
export const onUpdateSeasonDocument = new TypedDocumentString(`
    subscription onUpdateSeason {
  onUpdateSeason {
    seasonId
    seasonJson
    competitions {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateSeasonSubscription, onUpdateSeasonSubscriptionVariables>;
export const onUpdateSeasonRankingGalleryWidgetDocument = new TypedDocumentString(`
    subscription onUpdateSeasonRankingGalleryWidget {
  onUpdateSeasonRankingGalleryWidget {
    seasonAndCompId
    seasonId
    competitionId
    competitionsSlugName
    competitionName
    drivers {
      __typename
    }
    teams {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateSeasonRankingGalleryWidgetSubscription, onUpdateSeasonRankingGalleryWidgetSubscriptionVariables>;
export const onUpdateSessionDocument = new TypedDocumentString(`
    subscription onUpdateSession {
  onUpdateSession {
    sessionId
    gpId
    seasonAndCompId
    status
    isCurrent
    date
    sessionJson
  }
}
    `) as unknown as TypedDocumentString<onUpdateSessionSubscription, onUpdateSessionSubscriptionVariables>;
export const onUpdateTeamDocument = new TypedDocumentString(`
    subscription onUpdateTeam {
  onUpdateTeam {
    seasonAndCompId
    teamId
    teamJson
    editorialDataId
    competition {
      __typename
    }
    editorialData {
      __typename
    }
    drivers {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateTeamSubscription, onUpdateTeamSubscriptionVariables>;
export const onUpdateTeamDriverPageWidgetDocument = new TypedDocumentString(`
    subscription onUpdateTeamDriverPageWidget {
  onUpdateTeamDriverPageWidget {
    seasonAndCompId
    seasonId
    competitionId
    teamList {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateTeamDriverPageWidgetSubscription, onUpdateTeamDriverPageWidgetSubscriptionVariables>;
export const onUpdateTeamRankingWidgetDocument = new TypedDocumentString(`
    subscription onUpdateTeamRankingWidget {
  onUpdateTeamRankingWidget {
    seasonAndCompId
    seasonId
    competitionId
    competitionLabel
    items {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<onUpdateTeamRankingWidgetSubscription, onUpdateTeamRankingWidgetSubscriptionVariables>;
export const UpdateLgpHeroStickyWidgetDocument = new TypedDocumentString(`
    subscription UpdateLgpHeroStickyWidget($gpId: ID!, $seasonAndCompId: ID!) {
  onUpdateLgpHeroStickyBySeasonAndCompIdAndGpId(
    gpId: $gpId
    seasonAndCompId: $seasonAndCompId
  ) {
    gpId
    seasonAndCompId
    session {
      label
      name
      status
    }
    info {
      customGpName
      endDate
      flagImgUrl
      startDate
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateLgpHeroStickyWidgetSubscription, UpdateLgpHeroStickyWidgetSubscriptionVariables>;
export const UpdateLgpHeroWidgetDocument = new TypedDocumentString(`
    subscription UpdateLgpHeroWidget($seasonAndCompId: ID!, $gpId: ID!) {
  onUpdateLgpHeroWidgetBySeasonAndCompIdAndGpId(
    seasonAndCompId: $seasonAndCompId
    gpId: $gpId
  ) {
    gpId
    session {
      label
      name
      status
      podium {
        customDriverName
        customDriverSurname
        customDriverShortName
        driverImgUrl
        flagImgUrl
        position
      }
    }
    info {
      circuitImgUrl
      customGpName
      flagImgUrl
      startDate
      sportTag
      endDate
    }
    seasonAndCompId
  }
}
    `) as unknown as TypedDocumentString<UpdateLgpHeroWidgetSubscription, UpdateLgpHeroWidgetSubscriptionVariables>;
export const UpdateLgpResultsContainerWidgetDocument = new TypedDocumentString(`
    subscription UpdateLgpResultsContainerWidget($seasonAndCompId: ID!, $gpId: ID!) {
  onUpdateLgpResContainerBySeasonAndCompIdAndGpId(
    seasonAndCompId: $seasonAndCompId
    gpId: $gpId
  ) {
    FP1 {
      ssi
      startDateTime
      customDataAttributes {
        tracking
        url
      }
    }
    FP2 {
      ssi
      startDateTime
      customDataAttributes {
        tracking
        url
      }
    }
    FP3 {
      ssi
      startDateTime
      customDataAttributes {
        tracking
        url
      }
    }
    FP4 {
      customDataAttributes {
        tracking
        url
      }
      startDateTime
      ssi
    }
    G {
      ssi
      startDateTime
      customDataAttributes {
        tracking
        url
      }
    }
    GS {
      ssi
      startDateTime
      customDataAttributes {
        tracking
        url
      }
    }
    Q {
      customDataAttributes {
        tracking
        url
      }
      ssi
      startDateTime
    }
    QS {
      customDataAttributes {
        tracking
        url
      }
      ssi
      startDateTime
    }
    R {
      customDataAttributes {
        tracking
        url
      }
      ssi
      startDateTime
    }
    SPRINT {
      customDataAttributes {
        tracking
        url
      }
      ssi
      startDateTime
    }
    gpId
    seasonAndCompId
    __typename
    createdAt
    updatedAt
    competitionId
    seasonId
  }
}
    `) as unknown as TypedDocumentString<UpdateLgpResultsContainerWidgetSubscription, UpdateLgpResultsContainerWidgetSubscriptionVariables>;
export const UpdateLgpResultsWidgetDocument = new TypedDocumentString(`
    subscription UpdateLgpResultsWidget($gpId: ID!, $sessionName: String!) {
  onUpdateLgpResultsWidgetByGpIdAndSessionName(
    gpId: $gpId
    sessionName: $sessionName
  ) {
    gpId
    gpStatus
    isCurrent
    seasonAndCompId
    sessionName
    ranking {
      link
      text
    }
    results {
      link
      text
    }
    calendar {
      link
      text
    }
    gpInfo {
      customGpName
      gpStatus
      isCurrent
      isExclusive
      isSprint
      lapRecord
      laps
      lengthKm
      startDateTime
    }
    sessions {
      isCurrent
      sessionInfo {
        isCurrent
        sessionLabel
        sessionName
        sessionStatus
        startDateTime
        details {
          customDriverName
          customDriverPageUrl
          customDriverSurname
          customTeamName
          customTeamPageUrl
          fastestLap
          flagUrl
          gap
          isFastestLap
          laps
          position
          status
          timing {
            timeHours
            timeMilliseconds
            timeMinutes
            timeSeconds
          }
        }
      }
    }
    seasonAndCompId
    __typename
    competitionId
    seasonId
  }
}
    `) as unknown as TypedDocumentString<UpdateLgpResultsWidgetSubscription, UpdateLgpResultsWidgetSubscriptionVariables>;
export const UpdateLiveScoreWidgetDocument = new TypedDocumentString(`
    subscription UpdateLiveScoreWidget($id: ID!) {
  onUpdateLiveScoreWidgetById(id: $id) {
    currentDay {
      gpInfo {
        gpPageUrl
        gpCrosslink
      }
      sessions {
        sessionDate
        sessionName
        sessionStatus
        results {
          customDriverName
          customDriverPageUrl
          customDriverSurname
          customTeamName
          customTeamPageUrl
          fastestLap
          firstName
          flagUrl
          gap
          isFastestLap
          lastName
          position
          teamName
          timing {
            timeHours
            timeMilliseconds
            timeMinutes
            timeSeconds
          }
        }
        resultsUrl
      }
    }
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateLiveScoreWidgetSubscription, UpdateLiveScoreWidgetSubscriptionVariables>;